/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AiIntakeItem } from '../models/aiIntakeItem';

import type { AwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostParams } from '../models/awardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostParams';

import type { BodyImportShipmentsExcelApiV1ShipmentsImportPost } from '../models/bodyImportShipmentsExcelApiV1ShipmentsImportPost';

import type { BookingEquipment } from '../models/bookingEquipment';

import type { BookingEquipmentDeleteResult } from '../models/bookingEquipmentDeleteResult';

import type { ChargeCodeCreate } from '../models/chargeCodeCreate';

import type { ChargeCodeUpdate } from '../models/chargeCodeUpdate';

import type { ChassisUsageCreate } from '../models/chassisUsageCreate';

import type { ChassisUsageUpdate } from '../models/chassisUsageUpdate';

import type { ContainerFdaStatusUpdate } from '../models/containerFdaStatusUpdate';

import type { ContainerGateReadinessList } from '../models/containerGateReadinessList';

import type { ContainerGateRecord } from '../models/containerGateRecord';

import type { DgDeclarationCreate } from '../models/dgDeclarationCreate';

import type { DgDeclarationLineCreate } from '../models/dgDeclarationLineCreate';

import type { DgDeclarationLineUpdate } from '../models/dgDeclarationLineUpdate';

import type { DgDeclarationSign } from '../models/dgDeclarationSign';

import type { DgDeclarationUpdate } from '../models/dgDeclarationUpdate';

import type { DispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostParams } from '../models/dispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostParams';

import type { DndDisputeCreate } from '../models/dndDisputeCreate';

import type { DndDisputeUpdate } from '../models/dndDisputeUpdate';

import type { EmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostParams } from '../models/emailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostParams';

import type { ExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetParams } from '../models/exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetParams';

import type { ExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetParams } from '../models/exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetParams';

import type { ExportControlRecordCreate } from '../models/exportControlRecordCreate';

import type { ExportControlRecordUpdate } from '../models/exportControlRecordUpdate';

import type { FreetimeTermCreate } from '../models/freetimeTermCreate';

import type { FreetimeTermUpdate } from '../models/freetimeTermUpdate';

import type { FreightQuoteApprovalRequest } from '../models/freightQuoteApprovalRequest';

import type { FreightQuoteDecision } from '../models/freightQuoteDecision';

import type { FreightQuoteRecipientInput } from '../models/freightQuoteRecipientInput';

import type { FreightQuoteRecord } from '../models/freightQuoteRecord';

import type { FreightQuoteRequest } from '../models/freightQuoteRequest';

import type { FreightQuoteRequestCreate } from '../models/freightQuoteRequestCreate';

import type { FreightQuoteRequestList } from '../models/freightQuoteRequestList';

import type { FreightQuoteRequestUpdate } from '../models/freightQuoteRequestUpdate';

import type { GetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetParams } from '../models/getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetParams';

import type { GetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetParams } from '../models/getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetParams';

import type { GetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetParams } from '../models/getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetParams';

import type { GetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetParams } from '../models/getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetParams';

import type { GetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetParams } from '../models/getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetParams';

import type { GetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetParams } from '../models/getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetParams';

import type { GetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetParams } from '../models/getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { HolidayCalendar } from '../models/holidayCalendar';

import type { HolidayCalendarCreate } from '../models/holidayCalendarCreate';

import type { HolidayCalendarDeleteResult } from '../models/holidayCalendarDeleteResult';

import type { HolidayCalendarList } from '../models/holidayCalendarList';

import type { HolidayCalendarUpdate } from '../models/holidayCalendarUpdate';

import type { InsuranceCertificate } from '../models/insuranceCertificate';

import type { JobCloseState } from '../models/jobCloseState';

import type { JobPnl } from '../models/jobPnl';

import type { LandedCostApplyResponse } from '../models/landedCostApplyResponse';

import type { ListBillableChargesApiV1ShipmentsBillableChargesGetParams } from '../models/listBillableChargesApiV1ShipmentsBillableChargesGetParams';

import type { ListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetParams } from '../models/listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetParams';

import type { ListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetParams } from '../models/listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetParams';

import type { ListChargeCodesApiV1ShipmentsChargeCodesGetParams } from '../models/listChargeCodesApiV1ShipmentsChargeCodesGetParams';

import type { ListDndQueueApiV1ShipmentsDndQueueGetParams } from '../models/listDndQueueApiV1ShipmentsDndQueueGetParams';

import type { ListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetParams } from '../models/listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetParams';

import type { ListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetParams } from '../models/listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetParams';

import type { ListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetParams } from '../models/listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetParams';

import type { ListExceptionQueueApiV1ShipmentsExceptionsQueueGetParams } from '../models/listExceptionQueueApiV1ShipmentsExceptionsQueueGetParams';

import type { ListFreetimeTermsApiV1ShipmentsFreetimeTermsGetParams } from '../models/listFreetimeTermsApiV1ShipmentsFreetimeTermsGetParams';

import type { ListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetParams } from '../models/listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetParams';

import type { ListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetParams } from '../models/listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetParams';

import type { ListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetParams } from '../models/listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetParams';

import type { ListShipmentsApiV1ShipmentsGetParams } from '../models/listShipmentsApiV1ShipmentsGetParams';

import type { ListStreetTurnsApiV1ShipmentsStreetTurnsGetParams } from '../models/listStreetTurnsApiV1ShipmentsStreetTurnsGetParams';

import type { ListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetParams } from '../models/listTenantDocumentTypesApiV1ShipmentsDocumentTypesGetParams';

import type { ListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetParams } from '../models/listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetParams';

import type { ListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetParams } from '../models/listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetParams';

import type { ListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetParams } from '../models/listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetParams';

import type { ListUninvoicedWipApiV1ShipmentsUninvoicedWipGetParams } from '../models/listUninvoicedWipApiV1ShipmentsUninvoicedWipGetParams';

import type { ListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetParams } from '../models/listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetParams';

import type { PartnerRequest } from '../models/partnerRequest';

import type { PartnerRequestCreate } from '../models/partnerRequestCreate';

import type { PartnerRequestList } from '../models/partnerRequestList';

import type { PartnerRequestRespond } from '../models/partnerRequestRespond';

import type { PartnerRequestSend } from '../models/partnerRequestSend';

import type { PartnerRequestUpdate } from '../models/partnerRequestUpdate';

import type { ShipmentBillList } from '../models/shipmentBillList';

import type { ShipmentCargo } from '../models/shipmentCargo';

import type { ShipmentCargoContentsLink } from '../models/shipmentCargoContentsLink';

import type { ShipmentCargoContentsLinkCreate } from '../models/shipmentCargoContentsLinkCreate';

import type { ShipmentCargoContentsLinkDeleteResult } from '../models/shipmentCargoContentsLinkDeleteResult';

import type { ShipmentCargoContentsLinkList } from '../models/shipmentCargoContentsLinkList';

import type { ShipmentCargoContentsLinkUpdate } from '../models/shipmentCargoContentsLinkUpdate';

import type { ShipmentCargoCreate } from '../models/shipmentCargoCreate';

import type { ShipmentCargoEnumerate } from '../models/shipmentCargoEnumerate';

import type { ShipmentCargoList } from '../models/shipmentCargoList';

import type { ShipmentCargoUpdate } from '../models/shipmentCargoUpdate';

import type { ShipmentCharge } from '../models/shipmentCharge';

import type { ShipmentChargeList } from '../models/shipmentChargeList';

import type { ShipmentCostAllocation } from '../models/shipmentCostAllocation';

import type { ShipmentCostSummary } from '../models/shipmentCostSummary';

import type { ShipmentCoverage } from '../models/shipmentCoverage';

import type { ShipmentCoverageDetail } from '../models/shipmentCoverageDetail';

import type { ShipmentDiversionList } from '../models/shipmentDiversionList';

import type { ShipmentDivertPreview } from '../models/shipmentDivertPreview';

import type { ShipmentDivertResult } from '../models/shipmentDivertResult';

import type { ShipmentDocumentDispatchRequest } from '../models/shipmentDocumentDispatchRequest';

import type { ShipmentDocumentParseJob } from '../models/shipmentDocumentParseJob';

import type { ShipmentDocumentParseJobList } from '../models/shipmentDocumentParseJobList';

import type { ShipmentDocumentReissueResolution } from '../models/shipmentDocumentReissueResolution';

import type { ShipmentDocumentTriageResolve } from '../models/shipmentDocumentTriageResolve';

import type { ShipmentEstimateReminder } from '../models/shipmentEstimateReminder';

import type { ShipmentExceptionAssign } from '../models/shipmentExceptionAssign';

import type { ShipmentExceptionTransition } from '../models/shipmentExceptionTransition';

import type { ShipmentFilterFacets } from '../models/shipmentFilterFacets';

import type { ShipmentImportResult } from '../models/shipmentImportResult';

import type { ShipmentLineItem } from '../models/shipmentLineItem';

import type { ShipmentLineItemCreate } from '../models/shipmentLineItemCreate';

import type { ShipmentLineItemList } from '../models/shipmentLineItemList';

import type { ShipmentLineItemUpdate } from '../models/shipmentLineItemUpdate';

import type { ShipmentMilestone } from '../models/shipmentMilestone';

import type { ShipmentMilestoneCreate } from '../models/shipmentMilestoneCreate';

import type { ShipmentMilestoneDeleteResult } from '../models/shipmentMilestoneDeleteResult';

import type { ShipmentMilestoneList } from '../models/shipmentMilestoneList';

import type { ShipmentPartyCreate } from '../models/shipmentPartyCreate';

import type { ShipmentQuotationEmailRequest } from '../models/shipmentQuotationEmailRequest';

import type { ShipmentsShipmentDocumentLocation } from '../models/shipmentsShipmentDocumentLocation';

import type { StreetTurnCreate } from '../models/streetTurnCreate';

import type { StreetTurnUpdate } from '../models/streetTurnUpdate';

import type { SuggestPortsApiV1ShipmentsRoutingSuggestPortsGetParams } from '../models/suggestPortsApiV1ShipmentsRoutingSuggestPortsGetParams';

import type { TenantDocumentType } from '../models/tenantDocumentType';

import type { TenantDocumentTypeCreate } from '../models/tenantDocumentTypeCreate';

import type { TenantDocumentTypeDeleteResult } from '../models/tenantDocumentTypeDeleteResult';

import type { TenantDocumentTypeList } from '../models/tenantDocumentTypeList';

import type { TenantDocumentTypeUpdate } from '../models/tenantDocumentTypeUpdate';

import type { TerminalAppointmentCreate } from '../models/terminalAppointmentCreate';

import type { TerminalAppointmentUpdate } from '../models/terminalAppointmentUpdate';

import type { UninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetParams } from '../models/uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetParams';

import type { WarehouseIntakeCapacity } from '../models/warehouseIntakeCapacity';

import type { WarehouseIntakeCapacityCreate } from '../models/warehouseIntakeCapacityCreate';

import type { WarehouseIntakeCapacityDeleteResult } from '../models/warehouseIntakeCapacityDeleteResult';

import type { WarehouseIntakeCapacityList } from '../models/warehouseIntakeCapacityList';

import type { WarehouseIntakeCapacityUpdate } from '../models/warehouseIntakeCapacityUpdate';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * List shipments for the tracker.

Every row carries the derived ``direction`` / ``is_cross_border`` /
``customs_regime`` / ``customs_required`` fields, ``checklist_completion`` and
``container_gate_readiness`` (all batch-computed — no N+1;
``container_gate_readiness`` is null on a file with no containers, which reads
as "not applicable" rather than as "0 of 7"). SQL filters (mode/status/customer/supplier/customs
status/search) paginate in the DB; derived filters (direction/border/
checklist %) filter the SQL-matching set in the service. When
``include_costs`` is set, the returned page is augmented with the per-shipment
AP cost rollup (``total_cost`` / ``total_paid`` / ``outstanding``).
 * @summary List Shipments
 */
export const listShipmentsApiV1ShipmentsGet = (
  params?: ListShipmentsApiV1ShipmentsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments`,
    method: 'GET',
    params,
    signal
  });
};

export const getListShipmentsApiV1ShipmentsGetQueryKey = (
  params?: ListShipmentsApiV1ShipmentsGetParams
) => {
  return [`/api/v1/shipments`, ...(params ? [params] : [])] as const;
};

export const getListShipmentsApiV1ShipmentsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListShipmentsApiV1ShipmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListShipmentsApiV1ShipmentsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>
  > = ({ signal }) => listShipmentsApiV1ShipmentsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListShipmentsApiV1ShipmentsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>
>;
export type ListShipmentsApiV1ShipmentsGetQueryError = HTTPValidationError;

export function useListShipmentsApiV1ShipmentsGet<
  TData = Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListShipmentsApiV1ShipmentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
          TError,
          Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListShipmentsApiV1ShipmentsGet<
  TData = Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListShipmentsApiV1ShipmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
          TError,
          Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListShipmentsApiV1ShipmentsGet<
  TData = Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListShipmentsApiV1ShipmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Shipments
 */

export function useListShipmentsApiV1ShipmentsGet<
  TData = Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListShipmentsApiV1ShipmentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listShipmentsApiV1ShipmentsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListShipmentsApiV1ShipmentsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a shipment.
 * @summary Create Shipment
 */
export const createShipmentApiV1ShipmentsPost = (signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments`,
    method: 'POST',
    signal
  });
};

export const getCreateShipmentApiV1ShipmentsPostMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createShipmentApiV1ShipmentsPost>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createShipmentApiV1ShipmentsPost>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['createShipmentApiV1ShipmentsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createShipmentApiV1ShipmentsPost>>,
    void
  > = () => {
    return createShipmentApiV1ShipmentsPost();
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateShipmentApiV1ShipmentsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createShipmentApiV1ShipmentsPost>>
>;

export type CreateShipmentApiV1ShipmentsPostMutationError = unknown;

/**
 * @summary Create Shipment
 */
export const useCreateShipmentApiV1ShipmentsPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createShipmentApiV1ShipmentsPost>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createShipmentApiV1ShipmentsPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getCreateShipmentApiV1ShipmentsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Entity-FK candidates in use on the accessible tracker base scope.
 * @summary Get Shipment Filter Facets
 */
export const getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet = (
  params?: GetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentFilterFacets>({
    url: `/api/v1/shipments/filter-facets`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetQueryKey = (
  params?: GetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetParams
) => {
  return [
    `/api/v1/shipments/filter-facets`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet>
      >
    > = ({ signal }) =>
      getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet>
    >
  >;
export type GetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetQueryError =
  HTTPValidationError;

export function useGetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Shipment Filter Facets
 */

export function useGetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet<
  TData = Awaited<
    ReturnType<typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentFilterFacetsApiV1ShipmentsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetShipmentFilterFacetsApiV1ShipmentsFilterFacetsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Import a shipment tracker spreadsheet (XLSX). With ``dry_run`` the file is
validated and a reconciliation report returned without persisting.
 * @summary Import Shipments Excel
 */
export const importShipmentsExcelApiV1ShipmentsImportPost = (
  bodyImportShipmentsExcelApiV1ShipmentsImportPost: BodyImportShipmentsExcelApiV1ShipmentsImportPost,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(
    `file`,
    bodyImportShipmentsExcelApiV1ShipmentsImportPost.file
  );
  if (bodyImportShipmentsExcelApiV1ShipmentsImportPost.dry_run !== undefined) {
    formData.append(
      `dry_run`,
      bodyImportShipmentsExcelApiV1ShipmentsImportPost.dry_run.toString()
    );
  }

  return customInstance<ShipmentImportResult>({
    url: `/api/v1/shipments/import`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getImportShipmentsExcelApiV1ShipmentsImportPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importShipmentsExcelApiV1ShipmentsImportPost>>,
    TError,
    { data: BodyImportShipmentsExcelApiV1ShipmentsImportPost },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importShipmentsExcelApiV1ShipmentsImportPost>>,
  TError,
  { data: BodyImportShipmentsExcelApiV1ShipmentsImportPost },
  TContext
> => {
  const mutationKey = ['importShipmentsExcelApiV1ShipmentsImportPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importShipmentsExcelApiV1ShipmentsImportPost>>,
    { data: BodyImportShipmentsExcelApiV1ShipmentsImportPost }
  > = (props) => {
    const { data } = props ?? {};

    return importShipmentsExcelApiV1ShipmentsImportPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportShipmentsExcelApiV1ShipmentsImportPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof importShipmentsExcelApiV1ShipmentsImportPost>>
  >;
export type ImportShipmentsExcelApiV1ShipmentsImportPostMutationBody =
  BodyImportShipmentsExcelApiV1ShipmentsImportPost;
export type ImportShipmentsExcelApiV1ShipmentsImportPostMutationError =
  HTTPValidationError;

/**
 * @summary Import Shipments Excel
 */
export const useImportShipmentsExcelApiV1ShipmentsImportPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importShipmentsExcelApiV1ShipmentsImportPost>>,
      TError,
      { data: BodyImportShipmentsExcelApiV1ShipmentsImportPost },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof importShipmentsExcelApiV1ShipmentsImportPost>>,
  TError,
  { data: BodyImportShipmentsExcelApiV1ShipmentsImportPost },
  TContext
> => {
  const mutationOptions =
    getImportShipmentsExcelApiV1ShipmentsImportPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Download the .xlsx import template: canonical headers (derived from the
importer's alias table) plus one example row, so a first-time user knows
which columns to supply. Cheap, in-memory build — no DB access.
 * @summary Download Import Template
 */
export const downloadImportTemplateApiV1ShipmentsImportTemplateGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/import/template`,
    method: 'GET',
    signal
  });
};

export const getDownloadImportTemplateApiV1ShipmentsImportTemplateGetQueryKey =
  () => {
    return [`/api/v1/shipments/import/template`] as const;
  };

export const getDownloadImportTemplateApiV1ShipmentsImportTemplateGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDownloadImportTemplateApiV1ShipmentsImportTemplateGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet>
      >
    > = ({ signal }) =>
      downloadImportTemplateApiV1ShipmentsImportTemplateGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DownloadImportTemplateApiV1ShipmentsImportTemplateGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet>
    >
  >;
export type DownloadImportTemplateApiV1ShipmentsImportTemplateGetQueryError =
  unknown;

export function useDownloadImportTemplateApiV1ShipmentsImportTemplateGet<
  TData = Awaited<
    ReturnType<typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadImportTemplateApiV1ShipmentsImportTemplateGet<
  TData = Awaited<
    ReturnType<typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadImportTemplateApiV1ShipmentsImportTemplateGet<
  TData = Awaited<
    ReturnType<typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Import Template
 */

export function useDownloadImportTemplateApiV1ShipmentsImportTemplateGet<
  TData = Awaited<
    ReturnType<typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadImportTemplateApiV1ShipmentsImportTemplateGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadImportTemplateApiV1ShipmentsImportTemplateGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List charge codes for the tenant.

Shape B (bounded, tenant-curated): omitting ``limit`` returns the complete
set — the picker and the admin page both slice client-side, so a hidden cap
here would drop codes off a filtered subset without saying so.
 * @summary List Charge Codes
 */
export const listChargeCodesApiV1ShipmentsChargeCodesGet = (
  params?: ListChargeCodesApiV1ShipmentsChargeCodesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/charge-codes`,
    method: 'GET',
    params,
    signal
  });
};

export const getListChargeCodesApiV1ShipmentsChargeCodesGetQueryKey = (
  params?: ListChargeCodesApiV1ShipmentsChargeCodesGetParams
) => {
  return [
    `/api/v1/shipments/charge-codes`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListChargeCodesApiV1ShipmentsChargeCodesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListChargeCodesApiV1ShipmentsChargeCodesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListChargeCodesApiV1ShipmentsChargeCodesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>>
  > = ({ signal }) =>
    listChargeCodesApiV1ShipmentsChargeCodesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListChargeCodesApiV1ShipmentsChargeCodesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>>
  >;
export type ListChargeCodesApiV1ShipmentsChargeCodesGetQueryError =
  HTTPValidationError;

export function useListChargeCodesApiV1ShipmentsChargeCodesGet<
  TData = Awaited<
    ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListChargeCodesApiV1ShipmentsChargeCodesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListChargeCodesApiV1ShipmentsChargeCodesGet<
  TData = Awaited<
    ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListChargeCodesApiV1ShipmentsChargeCodesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListChargeCodesApiV1ShipmentsChargeCodesGet<
  TData = Awaited<
    ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListChargeCodesApiV1ShipmentsChargeCodesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Charge Codes
 */

export function useListChargeCodesApiV1ShipmentsChargeCodesGet<
  TData = Awaited<
    ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListChargeCodesApiV1ShipmentsChargeCodesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listChargeCodesApiV1ShipmentsChargeCodesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListChargeCodesApiV1ShipmentsChargeCodesGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a charge code.
 * @summary Create Charge Code
 */
export const createChargeCodeApiV1ShipmentsChargeCodesPost = (
  chargeCodeCreate: ChargeCodeCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/charge-codes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: chargeCodeCreate,
    signal
  });
};

export const getCreateChargeCodeApiV1ShipmentsChargeCodesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChargeCodeApiV1ShipmentsChargeCodesPost>>,
    TError,
    { data: ChargeCodeCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChargeCodeApiV1ShipmentsChargeCodesPost>>,
  TError,
  { data: ChargeCodeCreate },
  TContext
> => {
  const mutationKey = ['createChargeCodeApiV1ShipmentsChargeCodesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChargeCodeApiV1ShipmentsChargeCodesPost>>,
    { data: ChargeCodeCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createChargeCodeApiV1ShipmentsChargeCodesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChargeCodeApiV1ShipmentsChargeCodesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createChargeCodeApiV1ShipmentsChargeCodesPost>>
  >;
export type CreateChargeCodeApiV1ShipmentsChargeCodesPostMutationBody =
  ChargeCodeCreate;
export type CreateChargeCodeApiV1ShipmentsChargeCodesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Charge Code
 */
export const useCreateChargeCodeApiV1ShipmentsChargeCodesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createChargeCodeApiV1ShipmentsChargeCodesPost>>,
      TError,
      { data: ChargeCodeCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createChargeCodeApiV1ShipmentsChargeCodesPost>>,
  TError,
  { data: ChargeCodeCreate },
  TContext
> => {
  const mutationOptions =
    getCreateChargeCodeApiV1ShipmentsChargeCodesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a charge code.
 * @summary Update Charge Code
 */
export const updateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPut = (
  chargeCodeId: string,
  chargeCodeUpdate: ChargeCodeUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/charge-codes/${chargeCodeId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: chargeCodeUpdate
  });
};

export const getUpdateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPut
        >
      >,
      TError,
      { chargeCodeId: string; data: ChargeCodeUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPut
      >
    >,
    TError,
    { chargeCodeId: string; data: ChargeCodeUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPut
        >
      >,
      { chargeCodeId: string; data: ChargeCodeUpdate }
    > = (props) => {
      const { chargeCodeId, data } = props ?? {};

      return updateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPut(
        chargeCodeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPut
      >
    >
  >;
export type UpdateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPutMutationBody =
  ChargeCodeUpdate;
export type UpdateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Charge Code
 */
export const useUpdateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPut
        >
      >,
      TError,
      { chargeCodeId: string; data: ChargeCodeUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPut>
  >,
  TError,
  { chargeCodeId: string; data: ChargeCodeUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a charge code (soft delete; deactivates its shipment_service offering).
 * @summary Delete Charge Code
 */
export const deleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDelete = (
  chargeCodeId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/charge-codes/${chargeCodeId}`,
    method: 'DELETE'
  });
};

export const getDeleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDelete
        >
      >,
      TError,
      { chargeCodeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDelete
      >
    >,
    TError,
    { chargeCodeId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDelete
        >
      >,
      { chargeCodeId: string }
    > = (props) => {
      const { chargeCodeId } = props ?? {};

      return deleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDelete(
        chargeCodeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDelete
      >
    >
  >;

export type DeleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Charge Code
 */
export const useDeleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDelete
        >
      >,
      TError,
      { chargeCodeId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDelete
    >
  >,
  TError,
  { chargeCodeId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteChargeCodeApiV1ShipmentsChargeCodesChargeCodeIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Bulk-create the curated standard freight charge-code set for the tenant.

Idempotent — codes that already exist (by ``code``) are skipped. Codes are
anchored to the GL by category when the default company's chart carries the
freight overlay, otherwise left unmapped for the tenant to map on this page;
an existing code that is unmapped on both sides is back-filled (``mapped``).
Returns ``{"created": int, "skipped": int, "mapped": int}``.
 * @summary Load Standard Charge Codes
 */
export const loadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPost =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/charge-codes/load-standard`,
      method: 'POST',
      signal
    });
  };

export const getLoadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof loadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof loadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'loadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof loadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPost
        >
      >,
      void
    > = () => {
      return loadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type LoadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof loadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPost
      >
    >
  >;

export type LoadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPostMutationError =
  unknown;

/**
 * @summary Load Standard Charge Codes
 */
export const useLoadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPost =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof loadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPost
          >
        >,
        TError,
        void,
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof loadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationOptions =
      getLoadStandardChargeCodesApiV1ShipmentsChargeCodesLoadStandardPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the tenant's D&D free-time rules.
 * @summary List Freetime Terms
 */
export const listFreetimeTermsApiV1ShipmentsFreetimeTermsGet = (
  params?: ListFreetimeTermsApiV1ShipmentsFreetimeTermsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/freetime-terms`,
    method: 'GET',
    params,
    signal
  });
};

export const getListFreetimeTermsApiV1ShipmentsFreetimeTermsGetQueryKey = (
  params?: ListFreetimeTermsApiV1ShipmentsFreetimeTermsGetParams
) => {
  return [
    `/api/v1/shipments/freetime-terms`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListFreetimeTermsApiV1ShipmentsFreetimeTermsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFreetimeTermsApiV1ShipmentsFreetimeTermsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListFreetimeTermsApiV1ShipmentsFreetimeTermsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>>
  > = ({ signal }) =>
    listFreetimeTermsApiV1ShipmentsFreetimeTermsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListFreetimeTermsApiV1ShipmentsFreetimeTermsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>>
  >;
export type ListFreetimeTermsApiV1ShipmentsFreetimeTermsGetQueryError =
  HTTPValidationError;

export function useListFreetimeTermsApiV1ShipmentsFreetimeTermsGet<
  TData = Awaited<
    ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListFreetimeTermsApiV1ShipmentsFreetimeTermsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListFreetimeTermsApiV1ShipmentsFreetimeTermsGet<
  TData = Awaited<
    ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFreetimeTermsApiV1ShipmentsFreetimeTermsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListFreetimeTermsApiV1ShipmentsFreetimeTermsGet<
  TData = Awaited<
    ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFreetimeTermsApiV1ShipmentsFreetimeTermsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Freetime Terms
 */

export function useListFreetimeTermsApiV1ShipmentsFreetimeTermsGet<
  TData = Awaited<
    ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListFreetimeTermsApiV1ShipmentsFreetimeTermsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listFreetimeTermsApiV1ShipmentsFreetimeTermsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListFreetimeTermsApiV1ShipmentsFreetimeTermsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a D&D free-time rule.

Two-sided (§ entity-link far side): a contract-scoped rule names a
``ctr_contracts`` id in its BODY, and ``contract`` is a separately
sharing-ENFORCED object type. This route's own gate is tenant-level setup
access, which says nothing about that contract — so a caller who merely KNEW a
contract id could pin a tenant-wide D&D rate card to a contract they cannot
open, and every free-time surface then renders the link back at them.
 * @summary Create Freetime Term
 */
export const createFreetimeTermApiV1ShipmentsFreetimeTermsPost = (
  freetimeTermCreate: FreetimeTermCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/freetime-terms`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: freetimeTermCreate,
    signal
  });
};

export const getCreateFreetimeTermApiV1ShipmentsFreetimeTermsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createFreetimeTermApiV1ShipmentsFreetimeTermsPost>
      >,
      TError,
      { data: FreetimeTermCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createFreetimeTermApiV1ShipmentsFreetimeTermsPost>
    >,
    TError,
    { data: FreetimeTermCreate },
    TContext
  > => {
    const mutationKey = ['createFreetimeTermApiV1ShipmentsFreetimeTermsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createFreetimeTermApiV1ShipmentsFreetimeTermsPost>
      >,
      { data: FreetimeTermCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createFreetimeTermApiV1ShipmentsFreetimeTermsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateFreetimeTermApiV1ShipmentsFreetimeTermsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createFreetimeTermApiV1ShipmentsFreetimeTermsPost>
    >
  >;
export type CreateFreetimeTermApiV1ShipmentsFreetimeTermsPostMutationBody =
  FreetimeTermCreate;
export type CreateFreetimeTermApiV1ShipmentsFreetimeTermsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Freetime Term
 */
export const useCreateFreetimeTermApiV1ShipmentsFreetimeTermsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createFreetimeTermApiV1ShipmentsFreetimeTermsPost>
      >,
      TError,
      { data: FreetimeTermCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createFreetimeTermApiV1ShipmentsFreetimeTermsPost>>,
  TError,
  { data: FreetimeTermCreate },
  TContext
> => {
  const mutationOptions =
    getCreateFreetimeTermApiV1ShipmentsFreetimeTermsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a D&D free-time rule.
 * @summary Update Freetime Term
 */
export const updateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPut = (
  termId: string,
  freetimeTermUpdate: FreetimeTermUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/freetime-terms/${termId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: freetimeTermUpdate
  });
};

export const getUpdateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPut
        >
      >,
      TError,
      { termId: string; data: FreetimeTermUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPut>
    >,
    TError,
    { termId: string; data: FreetimeTermUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPut
        >
      >,
      { termId: string; data: FreetimeTermUpdate }
    > = (props) => {
      const { termId, data } = props ?? {};

      return updateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPut(
        termId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPut>
    >
  >;
export type UpdateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPutMutationBody =
  FreetimeTermUpdate;
export type UpdateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Freetime Term
 */
export const useUpdateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPut
        >
      >,
      TError,
      { termId: string; data: FreetimeTermUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPut>
  >,
  TError,
  { termId: string; data: FreetimeTermUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateFreetimeTermApiV1ShipmentsFreetimeTermsTermIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a D&D free-time rule (historical clocks keep their snapshot figures).
 * @summary Delete Freetime Term
 */
export const deleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDelete = (
  termId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/freetime-terms/${termId}`,
    method: 'DELETE'
  });
};

export const getDeleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDelete
        >
      >,
      TError,
      { termId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDelete
      >
    >,
    TError,
    { termId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDelete
        >
      >,
      { termId: string }
    > = (props) => {
      const { termId } = props ?? {};

      return deleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDelete(termId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDelete
      >
    >
  >;

export type DeleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Freetime Term
 */
export const useDeleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDelete
        >
      >,
      TError,
      { termId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDelete>
  >,
  TError,
  { termId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteFreetimeTermApiV1ShipmentsFreetimeTermsTermIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List the tenant's holiday closure dates.
 * @summary List Holiday Calendars
 */
export const listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet = (
  params?: ListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<HolidayCalendarList>({
    url: `/api/v1/shipments/holiday-calendars`,
    method: 'GET',
    params,
    signal
  });
};

export const getListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetQueryKey =
  (params?: ListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetParams) => {
    return [
      `/api/v1/shipments/holiday-calendars`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet>
      >
    > = ({ signal }) =>
      listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet>
    >
  >;
export type ListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetQueryError =
  HTTPValidationError;

export function useListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet<
  TData = Awaited<
    ReturnType<typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet<
  TData = Awaited<
    ReturnType<typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet<
  TData = Awaited<
    ReturnType<typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Holiday Calendars
 */

export function useListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet<
  TData = Awaited<
    ReturnType<typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listHolidayCalendarsApiV1ShipmentsHolidayCalendarsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListHolidayCalendarsApiV1ShipmentsHolidayCalendarsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a tenant holiday closure date.
 * @summary Create Holiday Calendar
 */
export const createHolidayCalendarApiV1ShipmentsHolidayCalendarsPost = (
  holidayCalendarCreate: HolidayCalendarCreate,
  signal?: AbortSignal
) => {
  return customInstance<HolidayCalendar>({
    url: `/api/v1/shipments/holiday-calendars`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: holidayCalendarCreate,
    signal
  });
};

export const getCreateHolidayCalendarApiV1ShipmentsHolidayCalendarsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createHolidayCalendarApiV1ShipmentsHolidayCalendarsPost
        >
      >,
      TError,
      { data: HolidayCalendarCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createHolidayCalendarApiV1ShipmentsHolidayCalendarsPost>
    >,
    TError,
    { data: HolidayCalendarCreate },
    TContext
  > => {
    const mutationKey = [
      'createHolidayCalendarApiV1ShipmentsHolidayCalendarsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createHolidayCalendarApiV1ShipmentsHolidayCalendarsPost
        >
      >,
      { data: HolidayCalendarCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createHolidayCalendarApiV1ShipmentsHolidayCalendarsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateHolidayCalendarApiV1ShipmentsHolidayCalendarsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createHolidayCalendarApiV1ShipmentsHolidayCalendarsPost>
    >
  >;
export type CreateHolidayCalendarApiV1ShipmentsHolidayCalendarsPostMutationBody =
  HolidayCalendarCreate;
export type CreateHolidayCalendarApiV1ShipmentsHolidayCalendarsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Holiday Calendar
 */
export const useCreateHolidayCalendarApiV1ShipmentsHolidayCalendarsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createHolidayCalendarApiV1ShipmentsHolidayCalendarsPost
        >
      >,
      TError,
      { data: HolidayCalendarCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createHolidayCalendarApiV1ShipmentsHolidayCalendarsPost>
  >,
  TError,
  { data: HolidayCalendarCreate },
  TContext
> => {
  const mutationOptions =
    getCreateHolidayCalendarApiV1ShipmentsHolidayCalendarsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a tenant holiday closure date.
 * @summary Update Holiday Calendar
 */
export const updateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPut = (
  holidayId: string,
  holidayCalendarUpdate: HolidayCalendarUpdate
) => {
  return customInstance<HolidayCalendar>({
    url: `/api/v1/shipments/holiday-calendars/${holidayId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: holidayCalendarUpdate
  });
};

export const getUpdateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPut
        >
      >,
      TError,
      { holidayId: string; data: HolidayCalendarUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPut
      >
    >,
    TError,
    { holidayId: string; data: HolidayCalendarUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPut
        >
      >,
      { holidayId: string; data: HolidayCalendarUpdate }
    > = (props) => {
      const { holidayId, data } = props ?? {};

      return updateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPut(
        holidayId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPut
      >
    >
  >;
export type UpdateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPutMutationBody =
  HolidayCalendarUpdate;
export type UpdateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Holiday Calendar
 */
export const useUpdateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPut
          >
        >,
        TError,
        { holidayId: string; data: HolidayCalendarUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPut
      >
    >,
    TError,
    { holidayId: string; data: HolidayCalendarUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a tenant holiday closure date.
 * @summary Delete Holiday Calendar
 */
export const deleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDelete =
  (holidayId: string) => {
    return customInstance<HolidayCalendarDeleteResult>({
      url: `/api/v1/shipments/holiday-calendars/${holidayId}`,
      method: 'DELETE'
    });
  };

export const getDeleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDelete
        >
      >,
      TError,
      { holidayId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDelete
      >
    >,
    TError,
    { holidayId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDelete
        >
      >,
      { holidayId: string }
    > = (props) => {
      const { holidayId } = props ?? {};

      return deleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDelete(
        holidayId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDelete
      >
    >
  >;

export type DeleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Holiday Calendar
 */
export const useDeleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDelete
          >
        >,
        TError,
        { holidayId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDelete
      >
    >,
    TError,
    { holidayId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteHolidayCalendarApiV1ShipmentsHolidayCalendarsHolidayIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the tenant's per-warehouse daily-intake ceilings.
 * @summary List Warehouse Intake Capacities
 */
export const listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet =
  (
    params?: ListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<WarehouseIntakeCapacityList>({
      url: `/api/v1/shipments/warehouse-intake-capacities`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetQueryKey =
  (
    params?: ListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetParams
  ) => {
    return [
      `/api/v1/shipments/warehouse-intake-capacities`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
        >
      >
    > = ({ signal }) =>
      listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
      >
    >
  >;
export type ListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetQueryError =
  HTTPValidationError;

export function useListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Warehouse Intake Capacities
 */

export function useListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListWarehouseIntakeCapacitiesApiV1ShipmentsWarehouseIntakeCapacitiesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set a warehouse's daily-intake ceiling.
 * @summary Create Warehouse Intake Capacity
 */
export const createWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPost =
  (
    warehouseIntakeCapacityCreate: WarehouseIntakeCapacityCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<WarehouseIntakeCapacity>({
      url: `/api/v1/shipments/warehouse-intake-capacities`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: warehouseIntakeCapacityCreate,
      signal
    });
  };

export const getCreateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPost
        >
      >,
      TError,
      { data: WarehouseIntakeCapacityCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPost
      >
    >,
    TError,
    { data: WarehouseIntakeCapacityCreate },
    TContext
  > => {
    const mutationKey = [
      'createWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPost
        >
      >,
      { data: WarehouseIntakeCapacityCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPost
      >
    >
  >;
export type CreateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPostMutationBody =
  WarehouseIntakeCapacityCreate;
export type CreateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Warehouse Intake Capacity
 */
export const useCreateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPost
          >
        >,
        TError,
        { data: WarehouseIntakeCapacityCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPost
      >
    >,
    TError,
    { data: WarehouseIntakeCapacityCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a warehouse's daily-intake ceiling.
 * @summary Update Warehouse Intake Capacity
 */
export const updateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPut =
  (
    capacityId: string,
    warehouseIntakeCapacityUpdate: WarehouseIntakeCapacityUpdate
  ) => {
    return customInstance<WarehouseIntakeCapacity>({
      url: `/api/v1/shipments/warehouse-intake-capacities/${capacityId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: warehouseIntakeCapacityUpdate
    });
  };

export const getUpdateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPut
        >
      >,
      TError,
      { capacityId: string; data: WarehouseIntakeCapacityUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPut
      >
    >,
    TError,
    { capacityId: string; data: WarehouseIntakeCapacityUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPut
        >
      >,
      { capacityId: string; data: WarehouseIntakeCapacityUpdate }
    > = (props) => {
      const { capacityId, data } = props ?? {};

      return updateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPut(
        capacityId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPut
      >
    >
  >;
export type UpdateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPutMutationBody =
  WarehouseIntakeCapacityUpdate;
export type UpdateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Warehouse Intake Capacity
 */
export const useUpdateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPut
          >
        >,
        TError,
        { capacityId: string; data: WarehouseIntakeCapacityUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPut
      >
    >,
    TError,
    { capacityId: string; data: WarehouseIntakeCapacityUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a warehouse's daily-intake ceiling.
 * @summary Delete Warehouse Intake Capacity
 */
export const deleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDelete =
  (capacityId: string) => {
    return customInstance<WarehouseIntakeCapacityDeleteResult>({
      url: `/api/v1/shipments/warehouse-intake-capacities/${capacityId}`,
      method: 'DELETE'
    });
  };

export const getDeleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDelete
        >
      >,
      TError,
      { capacityId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDelete
      >
    >,
    TError,
    { capacityId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDelete
        >
      >,
      { capacityId: string }
    > = (props) => {
      const { capacityId } = props ?? {};

      return deleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDelete(
        capacityId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDelete
      >
    >
  >;

export type DeleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Warehouse Intake Capacity
 */
export const useDeleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDelete
          >
        >,
        TError,
        { capacityId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDelete
      >
    >,
    TError,
    { capacityId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteWarehouseIntakeCapacityApiV1ShipmentsWarehouseIntakeCapacitiesCapacityIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The tenant-wide D&D queue: at-risk/accruing first, then LFD ascending.

Server-paged (Shape A — clocks accumulate): pass ``limit``/``offset`` for one
page; ``total`` is the unpaginated count for the same filters. The ordering is
server-owned (status rank → LFD → exposure → id tiebreak), so there is no
caller-selectable sort.
 * @summary List Dnd Queue
 */
export const listDndQueueApiV1ShipmentsDndQueueGet = (
  params?: ListDndQueueApiV1ShipmentsDndQueueGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/dnd/queue`,
    method: 'GET',
    params,
    signal
  });
};

export const getListDndQueueApiV1ShipmentsDndQueueGetQueryKey = (
  params?: ListDndQueueApiV1ShipmentsDndQueueGetParams
) => {
  return [`/api/v1/shipments/dnd/queue`, ...(params ? [params] : [])] as const;
};

export const getListDndQueueApiV1ShipmentsDndQueueGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
  TError = HTTPValidationError
>(
  params?: ListDndQueueApiV1ShipmentsDndQueueGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListDndQueueApiV1ShipmentsDndQueueGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>
  > = ({ signal }) => listDndQueueApiV1ShipmentsDndQueueGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListDndQueueApiV1ShipmentsDndQueueGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>
>;
export type ListDndQueueApiV1ShipmentsDndQueueGetQueryError =
  HTTPValidationError;

export function useListDndQueueApiV1ShipmentsDndQueueGet<
  TData = Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListDndQueueApiV1ShipmentsDndQueueGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
          TError,
          Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDndQueueApiV1ShipmentsDndQueueGet<
  TData = Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
  TError = HTTPValidationError
>(
  params?: ListDndQueueApiV1ShipmentsDndQueueGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
          TError,
          Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDndQueueApiV1ShipmentsDndQueueGet<
  TData = Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
  TError = HTTPValidationError
>(
  params?: ListDndQueueApiV1ShipmentsDndQueueGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Dnd Queue
 */

export function useListDndQueueApiV1ShipmentsDndQueueGet<
  TData = Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
  TError = HTTPValidationError
>(
  params?: ListDndQueueApiV1ShipmentsDndQueueGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDndQueueApiV1ShipmentsDndQueueGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListDndQueueApiV1ShipmentsDndQueueGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The tenant-wide ops triage queue: open exceptions, highest risk_score first.

Score = money-at-risk (linked sell charges + accrued D&D exposure) x customer
tier, blended with a severity floor. Batch-loaded (no N+1). Filterable by type,
severity, open status, owner (mine/unassigned/all), and aging bucket.
Server-paged (Shape A) when ``limit`` is passed — the flat table view — while
the grouped/pivot view omits it and keeps the whole open set (§ 11's
kanban-hybrid rule). Ordering is server-owned (risk → severity → detected →
id tiebreak), so there is no caller-selectable sort. Returns
``{"items": [...], "total": int, "truncated": bool}``.
 * @summary List Exception Queue
 */
export const listExceptionQueueApiV1ShipmentsExceptionsQueueGet = (
  params?: ListExceptionQueueApiV1ShipmentsExceptionsQueueGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/exceptions/queue`,
    method: 'GET',
    params,
    signal
  });
};

export const getListExceptionQueueApiV1ShipmentsExceptionsQueueGetQueryKey = (
  params?: ListExceptionQueueApiV1ShipmentsExceptionsQueueGetParams
) => {
  return [
    `/api/v1/shipments/exceptions/queue`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListExceptionQueueApiV1ShipmentsExceptionsQueueGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListExceptionQueueApiV1ShipmentsExceptionsQueueGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListExceptionQueueApiV1ShipmentsExceptionsQueueGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
      >
    > = ({ signal }) =>
      listExceptionQueueApiV1ShipmentsExceptionsQueueGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListExceptionQueueApiV1ShipmentsExceptionsQueueGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
    >
  >;
export type ListExceptionQueueApiV1ShipmentsExceptionsQueueGetQueryError =
  HTTPValidationError;

export function useListExceptionQueueApiV1ShipmentsExceptionsQueueGet<
  TData = Awaited<
    ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListExceptionQueueApiV1ShipmentsExceptionsQueueGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListExceptionQueueApiV1ShipmentsExceptionsQueueGet<
  TData = Awaited<
    ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExceptionQueueApiV1ShipmentsExceptionsQueueGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListExceptionQueueApiV1ShipmentsExceptionsQueueGet<
  TData = Awaited<
    ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExceptionQueueApiV1ShipmentsExceptionsQueueGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Exception Queue
 */

export function useListExceptionQueueApiV1ShipmentsExceptionsQueueGet<
  TData = Awaited<
    ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListExceptionQueueApiV1ShipmentsExceptionsQueueGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExceptionQueueApiV1ShipmentsExceptionsQueueGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListExceptionQueueApiV1ShipmentsExceptionsQueueGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Server-side GROUP BY rollup for the re-pivotable triage board: per-group
count + money-at-risk sum over ALL matching open rows (uncapped, so section
totals are accurate even when the flat queue is truncated). Returns
``{"group_by": ..., "groups": [{key, label, count, money_at_risk, ...}]}``.
 * @summary Exception Queue Groups
 */
export const exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet = (
  params: ExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/exceptions/queue/groups`,
    method: 'GET',
    params,
    signal
  });
};

export const getExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetQueryKey =
  (
    params?: ExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetParams
  ) => {
    return [
      `/api/v1/shipments/exceptions/queue/groups`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: ExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
        >
      >
    > = ({ signal }) =>
      exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
      >
    >
  >;
export type ExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetQueryError =
  HTTPValidationError;

export function useExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet<
  TData = Awaited<
    ReturnType<
      typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet<
  TData = Awaited<
    ReturnType<
      typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet<
  TData = Awaited<
    ReturnType<
      typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Exception Queue Groups
 */

export function useExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet<
  TData = Awaited<
    ReturnType<
      typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
    >
  >,
  TError = HTTPValidationError
>(
  params: ExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExceptionQueueGroupsApiV1ShipmentsExceptionsQueueGroupsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The aging band: open-exception counts per age-in-state bucket
(`d0_1` / `d2_3` / `d4_7` / `d7_plus`) over ALL matching open rows. Always
returns every bucket (zero-filled). Returns ``{"buckets": [{key, count}]}``.
 * @summary Exception Queue Aging
 */
export const exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet = (
  params?: ExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/exceptions/queue/aging`,
    method: 'GET',
    params,
    signal
  });
};

export const getExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetQueryKey =
  (params?: ExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetParams) => {
    return [
      `/api/v1/shipments/exceptions/queue/aging`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
        >
      >
    > = ({ signal }) =>
      exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
      >
    >
  >;
export type ExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetQueryError =
  HTTPValidationError;

export function useExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet<
  TData = Awaited<
    ReturnType<typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet<
  TData = Awaited<
    ReturnType<typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet>
  >,
  TError = HTTPValidationError
>(
  params?: ExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet<
  TData = Awaited<
    ReturnType<typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet>
  >,
  TError = HTTPValidationError
>(
  params?: ExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Exception Queue Aging
 */

export function useExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet<
  TData = Awaited<
    ReturnType<typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet>
  >,
  TError = HTTPValidationError
>(
  params?: ExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof exceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExceptionQueueAgingApiV1ShipmentsExceptionsQueueAgingGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One page of the uninvoiced-WIP list: one row per shipment carrying
un-invoiced sell charges (recorded revenue not yet drafted onto an AR
invoice), oldest ready-to-invoice first. Server-side aggregation, batch-loaded
(no N+1), server-paged. ``sort_direction`` is constrained here at the route —
the service treats anything that is not ``desc`` as ascending, so this pattern
is its only guard. Returns ``{"items": [...], "total": int}``.
 * @summary List Uninvoiced Wip
 */
export const listUninvoicedWipApiV1ShipmentsUninvoicedWipGet = (
  params?: ListUninvoicedWipApiV1ShipmentsUninvoicedWipGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/uninvoiced-wip`,
    method: 'GET',
    params,
    signal
  });
};

export const getListUninvoicedWipApiV1ShipmentsUninvoicedWipGetQueryKey = (
  params?: ListUninvoicedWipApiV1ShipmentsUninvoicedWipGetParams
) => {
  return [
    `/api/v1/shipments/uninvoiced-wip`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListUninvoicedWipApiV1ShipmentsUninvoicedWipGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListUninvoicedWipApiV1ShipmentsUninvoicedWipGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListUninvoicedWipApiV1ShipmentsUninvoicedWipGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>>
  > = ({ signal }) =>
    listUninvoicedWipApiV1ShipmentsUninvoicedWipGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListUninvoicedWipApiV1ShipmentsUninvoicedWipGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>>
  >;
export type ListUninvoicedWipApiV1ShipmentsUninvoicedWipGetQueryError =
  HTTPValidationError;

export function useListUninvoicedWipApiV1ShipmentsUninvoicedWipGet<
  TData = Awaited<
    ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListUninvoicedWipApiV1ShipmentsUninvoicedWipGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListUninvoicedWipApiV1ShipmentsUninvoicedWipGet<
  TData = Awaited<
    ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListUninvoicedWipApiV1ShipmentsUninvoicedWipGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUninvoicedWipApiV1ShipmentsUninvoicedWipGet<
  TData = Awaited<
    ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListUninvoicedWipApiV1ShipmentsUninvoicedWipGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Uninvoiced Wip
 */

export function useListUninvoicedWipApiV1ShipmentsUninvoicedWipGet<
  TData = Awaited<
    ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListUninvoicedWipApiV1ShipmentsUninvoicedWipGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listUninvoicedWipApiV1ShipmentsUninvoicedWipGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListUninvoicedWipApiV1ShipmentsUninvoicedWipGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The WIP aging band: count of shipments with un-invoiced sell charges per
age-since-ready bucket (`d0_1` / `d2_3` / `d4_7` / `d7_plus`) over the full
open set. Always returns every bucket (zero-filled). Returns
``{"buckets": [{key, count}]}``.
 * @summary Uninvoiced Wip Aging
 */
export const uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet = (
  params?: UninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/uninvoiced-wip/aging`,
    method: 'GET',
    params,
    signal
  });
};

export const getUninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetQueryKey =
  (params?: UninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetParams) => {
    return [
      `/api/v1/shipments/uninvoiced-wip/aging`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getUninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet>
    >,
    TError = HTTPValidationError
  >(
    params?: UninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getUninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet>
      >
    > = ({ signal }) =>
      uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type UninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet>
    >
  >;
export type UninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetQueryError =
  HTTPValidationError;

export function useUninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet<
  TData = Awaited<
    ReturnType<typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | UninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useUninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet<
  TData = Awaited<
    ReturnType<typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet>
  >,
  TError = HTTPValidationError
>(
  params?: UninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet<
  TData = Awaited<
    ReturnType<typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet>
  >,
  TError = HTTPValidationError
>(
  params?: UninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Uninvoiced Wip Aging
 */

export function useUninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet<
  TData = Awaited<
    ReturnType<typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet>
  >,
  TError = HTTPValidationError
>(
  params?: UninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof uninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getUninvoicedWipAgingApiV1ShipmentsUninvoicedWipAgingGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List disputes for a container D&D clock.
 * @summary List Dnd Disputes
 */
export const listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet = (
  clockId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/dnd-clocks/${clockId}/disputes`,
    method: 'GET',
    signal
  });
};

export const getListDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGetQueryKey =
  (clockId?: string) => {
    return [`/api/v1/shipments/dnd-clocks/${clockId}/disputes`] as const;
  };

export const getListDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
      >
    >,
    TError = HTTPValidationError
  >(
    clockId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGetQueryKey(
        clockId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
        >
      >
    > = ({ signal }) =>
      listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet(clockId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!clockId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
      >
    >
  >;
export type ListDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGetQueryError =
  HTTPValidationError;

export function useListDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet<
  TData = Awaited<
    ReturnType<typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet>
  >,
  TError = HTTPValidationError
>(
  clockId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet<
  TData = Awaited<
    ReturnType<typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet>
  >,
  TError = HTTPValidationError
>(
  clockId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet<
  TData = Awaited<
    ReturnType<typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet>
  >,
  TError = HTTPValidationError
>(
  clockId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Dnd Disputes
 */

export function useListDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet<
  TData = Awaited<
    ReturnType<typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet>
  >,
  TError = HTTPValidationError
>(
  clockId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDndDisputesApiV1ShipmentsDndClocksClockIdDisputesGetQueryOptions(
      clockId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Raise a dispute against the carrier's D&D invoice for a clock.
 * @summary Create Dnd Dispute
 */
export const createDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPost = (
  clockId: string,
  dndDisputeCreate: DndDisputeCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/dnd-clocks/${clockId}/disputes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dndDisputeCreate,
    signal
  });
};

export const getCreateDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPost
        >
      >,
      TError,
      { clockId: string; data: DndDisputeCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPost
      >
    >,
    TError,
    { clockId: string; data: DndDisputeCreate },
    TContext
  > => {
    const mutationKey = [
      'createDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPost
        >
      >,
      { clockId: string; data: DndDisputeCreate }
    > = (props) => {
      const { clockId, data } = props ?? {};

      return createDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPost(
        clockId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPost
      >
    >
  >;
export type CreateDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPostMutationBody =
  DndDisputeCreate;
export type CreateDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Dnd Dispute
 */
export const useCreateDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPost
        >
      >,
      TError,
      { clockId: string; data: DndDisputeCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPost
    >
  >,
  TError,
  { clockId: string; data: DndDisputeCreate },
  TContext
> => {
  const mutationOptions =
    getCreateDndDisputeApiV1ShipmentsDndClocksClockIdDisputesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Edit or transition a D&D dispute (accepting/rejecting/settling releases the clock).
 * @summary Update Dnd Dispute
 */
export const updateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPut = (
  disputeId: string,
  dndDisputeUpdate: DndDisputeUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/dnd-disputes/${disputeId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dndDisputeUpdate
  });
};

export const getUpdateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPut>
      >,
      TError,
      { disputeId: string; data: DndDisputeUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPut>
    >,
    TError,
    { disputeId: string; data: DndDisputeUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPut>
      >,
      { disputeId: string; data: DndDisputeUpdate }
    > = (props) => {
      const { disputeId, data } = props ?? {};

      return updateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPut(
        disputeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPut>
    >
  >;
export type UpdateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPutMutationBody =
  DndDisputeUpdate;
export type UpdateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Dnd Dispute
 */
export const useUpdateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPut>
      >,
      TError,
      { disputeId: string; data: DndDisputeUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPut>
  >,
  TError,
  { disputeId: string; data: DndDisputeUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateDndDisputeApiV1ShipmentsDndDisputesDisputeIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List the terminal gate appointments booked against a drayage leg.
 * @summary List Terminal Appointments
 */
export const listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet =
  (legId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/legs/${legId}/terminal-appointments`,
      method: 'GET',
      signal
    });
  };

export const getListTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGetQueryKey =
  (legId?: string) => {
    return [`/api/v1/shipments/legs/${legId}/terminal-appointments`] as const;
  };

export const getListTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    legId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGetQueryKey(
        legId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
        >
      >
    > = ({ signal }) =>
      listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet(
        legId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!legId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
      >
    >
  >;
export type ListTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGetQueryError =
  HTTPValidationError;

export function useListTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  legId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  legId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  legId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Terminal Appointments
 */

export function useListTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet<
  TData = Awaited<
    ReturnType<
      typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
    >
  >,
  TError = HTTPValidationError
>(
  legId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTerminalAppointmentsApiV1ShipmentsLegsLegIdTerminalAppointmentsGetQueryOptions(
      legId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Record a terminal gate appointment for a drayage leg.
 * @summary Create Terminal Appointment
 */
export const createTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPost =
  (
    legId: string,
    terminalAppointmentCreate: TerminalAppointmentCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/legs/${legId}/terminal-appointments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: terminalAppointmentCreate,
      signal
    });
  };

export const getCreateTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPost
        >
      >,
      TError,
      { legId: string; data: TerminalAppointmentCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPost
      >
    >,
    TError,
    { legId: string; data: TerminalAppointmentCreate },
    TContext
  > => {
    const mutationKey = [
      'createTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPost
        >
      >,
      { legId: string; data: TerminalAppointmentCreate }
    > = (props) => {
      const { legId, data } = props ?? {};

      return createTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPost(
        legId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPost
      >
    >
  >;
export type CreateTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPostMutationBody =
  TerminalAppointmentCreate;
export type CreateTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Terminal Appointment
 */
export const useCreateTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPost
          >
        >,
        TError,
        { legId: string; data: TerminalAppointmentCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPost
      >
    >,
    TError,
    { legId: string; data: TerminalAppointmentCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateTerminalAppointmentApiV1ShipmentsLegsLegIdTerminalAppointmentsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Edit a terminal appointment or transition its status.
 * @summary Update Terminal Appointment
 */
export const updateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPut =
  (
    appointmentId: string,
    terminalAppointmentUpdate: TerminalAppointmentUpdate
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/terminal-appointments/${appointmentId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: terminalAppointmentUpdate
    });
  };

export const getUpdateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPut
        >
      >,
      TError,
      { appointmentId: string; data: TerminalAppointmentUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPut
      >
    >,
    TError,
    { appointmentId: string; data: TerminalAppointmentUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPut
        >
      >,
      { appointmentId: string; data: TerminalAppointmentUpdate }
    > = (props) => {
      const { appointmentId, data } = props ?? {};

      return updateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPut(
        appointmentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPut
      >
    >
  >;
export type UpdateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPutMutationBody =
  TerminalAppointmentUpdate;
export type UpdateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Terminal Appointment
 */
export const useUpdateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPut
          >
        >,
        TError,
        { appointmentId: string; data: TerminalAppointmentUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPut
      >
    >,
    TError,
    { appointmentId: string; data: TerminalAppointmentUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a terminal appointment.
 * @summary Delete Terminal Appointment
 */
export const deleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDelete =
  (appointmentId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/terminal-appointments/${appointmentId}`,
      method: 'DELETE'
    });
  };

export const getDeleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDelete
        >
      >,
      TError,
      { appointmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDelete
      >
    >,
    TError,
    { appointmentId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDelete
        >
      >,
      { appointmentId: string }
    > = (props) => {
      const { appointmentId } = props ?? {};

      return deleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDelete(
        appointmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDelete
      >
    >
  >;

export type DeleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Terminal Appointment
 */
export const useDeleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDelete
          >
        >,
        TError,
        { appointmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDelete
      >
    >,
    TError,
    { appointmentId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteTerminalAppointmentApiV1ShipmentsTerminalAppointmentsAppointmentIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the chassis used on a drayage leg.
 * @summary List Chassis Usage
 */
export const listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet = (
  legId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/legs/${legId}/chassis-usage`,
    method: 'GET',
    signal
  });
};

export const getListChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGetQueryKey =
  (legId?: string) => {
    return [`/api/v1/shipments/legs/${legId}/chassis-usage`] as const;
  };

export const getListChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet>
    >,
    TError = HTTPValidationError
  >(
    legId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGetQueryKey(legId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
        >
      >
    > = ({ signal }) =>
      listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet(legId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!legId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet>
    >
  >;
export type ListChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGetQueryError =
  HTTPValidationError;

export function useListChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet<
  TData = Awaited<
    ReturnType<typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet>
  >,
  TError = HTTPValidationError
>(
  legId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet<
  TData = Awaited<
    ReturnType<typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet>
  >,
  TError = HTTPValidationError
>(
  legId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet<
  TData = Awaited<
    ReturnType<typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet>
  >,
  TError = HTTPValidationError
>(
  legId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Chassis Usage
 */

export function useListChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet<
  TData = Awaited<
    ReturnType<typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet>
  >,
  TError = HTTPValidationError
>(
  legId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListChassisUsageApiV1ShipmentsLegsLegIdChassisUsageGetQueryOptions(
      legId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Record chassis usage against a drayage leg.
 * @summary Create Chassis Usage
 */
export const createChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePost = (
  legId: string,
  chassisUsageCreate: ChassisUsageCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/legs/${legId}/chassis-usage`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: chassisUsageCreate,
    signal
  });
};

export const getCreateChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePost
        >
      >,
      TError,
      { legId: string; data: ChassisUsageCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePost
      >
    >,
    TError,
    { legId: string; data: ChassisUsageCreate },
    TContext
  > => {
    const mutationKey = [
      'createChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePost
        >
      >,
      { legId: string; data: ChassisUsageCreate }
    > = (props) => {
      const { legId, data } = props ?? {};

      return createChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePost(
        legId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePost
      >
    >
  >;
export type CreateChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePostMutationBody =
  ChassisUsageCreate;
export type CreateChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePostMutationError =
  HTTPValidationError;

/**
 * @summary Create Chassis Usage
 */
export const useCreateChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePost
        >
      >,
      TError,
      { legId: string; data: ChassisUsageCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePost>
  >,
  TError,
  { legId: string; data: ChassisUsageCreate },
  TContext
> => {
  const mutationOptions =
    getCreateChassisUsageApiV1ShipmentsLegsLegIdChassisUsagePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Edit a chassis-usage record.
 * @summary Update Chassis Usage
 */
export const updateChassisUsageApiV1ShipmentsChassisUsageUsageIdPut = (
  usageId: string,
  chassisUsageUpdate: ChassisUsageUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/chassis-usage/${usageId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: chassisUsageUpdate
  });
};

export const getUpdateChassisUsageApiV1ShipmentsChassisUsageUsageIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateChassisUsageApiV1ShipmentsChassisUsageUsageIdPut
        >
      >,
      TError,
      { usageId: string; data: ChassisUsageUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateChassisUsageApiV1ShipmentsChassisUsageUsageIdPut>
    >,
    TError,
    { usageId: string; data: ChassisUsageUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateChassisUsageApiV1ShipmentsChassisUsageUsageIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateChassisUsageApiV1ShipmentsChassisUsageUsageIdPut
        >
      >,
      { usageId: string; data: ChassisUsageUpdate }
    > = (props) => {
      const { usageId, data } = props ?? {};

      return updateChassisUsageApiV1ShipmentsChassisUsageUsageIdPut(
        usageId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateChassisUsageApiV1ShipmentsChassisUsageUsageIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateChassisUsageApiV1ShipmentsChassisUsageUsageIdPut>
    >
  >;
export type UpdateChassisUsageApiV1ShipmentsChassisUsageUsageIdPutMutationBody =
  ChassisUsageUpdate;
export type UpdateChassisUsageApiV1ShipmentsChassisUsageUsageIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Chassis Usage
 */
export const useUpdateChassisUsageApiV1ShipmentsChassisUsageUsageIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateChassisUsageApiV1ShipmentsChassisUsageUsageIdPut
        >
      >,
      TError,
      { usageId: string; data: ChassisUsageUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateChassisUsageApiV1ShipmentsChassisUsageUsageIdPut>
  >,
  TError,
  { usageId: string; data: ChassisUsageUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateChassisUsageApiV1ShipmentsChassisUsageUsageIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a chassis-usage record.
 * @summary Delete Chassis Usage
 */
export const deleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDelete = (
  usageId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/chassis-usage/${usageId}`,
    method: 'DELETE'
  });
};

export const getDeleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDelete
        >
      >,
      TError,
      { usageId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDelete
      >
    >,
    TError,
    { usageId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDelete
        >
      >,
      { usageId: string }
    > = (props) => {
      const { usageId } = props ?? {};

      return deleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDelete(usageId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDelete
      >
    >
  >;

export type DeleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Chassis Usage
 */
export const useDeleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDelete
        >
      >,
      TError,
      { usageId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDelete>
  >,
  TError,
  { usageId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteChassisUsageApiV1ShipmentsChassisUsageUsageIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * The tenant-wide street-turn queue, newest first.

Bounded — returns ``{"items": [...], "truncated": bool}`` like the D&D and
exception queues, so one tenant cannot pull an unbounded scan.
 * @summary List Street Turns
 */
export const listStreetTurnsApiV1ShipmentsStreetTurnsGet = (
  params?: ListStreetTurnsApiV1ShipmentsStreetTurnsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/street-turns`,
    method: 'GET',
    params,
    signal
  });
};

export const getListStreetTurnsApiV1ShipmentsStreetTurnsGetQueryKey = (
  params?: ListStreetTurnsApiV1ShipmentsStreetTurnsGetParams
) => {
  return [
    `/api/v1/shipments/street-turns`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListStreetTurnsApiV1ShipmentsStreetTurnsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListStreetTurnsApiV1ShipmentsStreetTurnsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListStreetTurnsApiV1ShipmentsStreetTurnsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>>
  > = ({ signal }) =>
    listStreetTurnsApiV1ShipmentsStreetTurnsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListStreetTurnsApiV1ShipmentsStreetTurnsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>>
  >;
export type ListStreetTurnsApiV1ShipmentsStreetTurnsGetQueryError =
  HTTPValidationError;

export function useListStreetTurnsApiV1ShipmentsStreetTurnsGet<
  TData = Awaited<
    ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListStreetTurnsApiV1ShipmentsStreetTurnsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListStreetTurnsApiV1ShipmentsStreetTurnsGet<
  TData = Awaited<
    ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListStreetTurnsApiV1ShipmentsStreetTurnsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListStreetTurnsApiV1ShipmentsStreetTurnsGet<
  TData = Awaited<
    ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListStreetTurnsApiV1ShipmentsStreetTurnsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Street Turns
 */

export function useListStreetTurnsApiV1ShipmentsStreetTurnsGet<
  TData = Awaited<
    ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListStreetTurnsApiV1ShipmentsStreetTurnsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listStreetTurnsApiV1ShipmentsStreetTurnsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListStreetTurnsApiV1ShipmentsStreetTurnsGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Propose a street turn: reuse an import container directly on an export.
 * @summary Create Street Turn
 */
export const createStreetTurnApiV1ShipmentsStreetTurnsPost = (
  streetTurnCreate: StreetTurnCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/street-turns`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: streetTurnCreate,
    signal
  });
};

export const getCreateStreetTurnApiV1ShipmentsStreetTurnsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStreetTurnApiV1ShipmentsStreetTurnsPost>>,
    TError,
    { data: StreetTurnCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStreetTurnApiV1ShipmentsStreetTurnsPost>>,
  TError,
  { data: StreetTurnCreate },
  TContext
> => {
  const mutationKey = ['createStreetTurnApiV1ShipmentsStreetTurnsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStreetTurnApiV1ShipmentsStreetTurnsPost>>,
    { data: StreetTurnCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createStreetTurnApiV1ShipmentsStreetTurnsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStreetTurnApiV1ShipmentsStreetTurnsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createStreetTurnApiV1ShipmentsStreetTurnsPost>>
  >;
export type CreateStreetTurnApiV1ShipmentsStreetTurnsPostMutationBody =
  StreetTurnCreate;
export type CreateStreetTurnApiV1ShipmentsStreetTurnsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Street Turn
 */
export const useCreateStreetTurnApiV1ShipmentsStreetTurnsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createStreetTurnApiV1ShipmentsStreetTurnsPost>>,
      TError,
      { data: StreetTurnCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createStreetTurnApiV1ShipmentsStreetTurnsPost>>,
  TError,
  { data: StreetTurnCreate },
  TContext
> => {
  const mutationOptions =
    getCreateStreetTurnApiV1ShipmentsStreetTurnsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Edit a street turn or transition its status (approve / reject / complete).
 * @summary Update Street Turn
 */
export const updateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPut = (
  streetTurnId: string,
  streetTurnUpdate: StreetTurnUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/street-turns/${streetTurnId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: streetTurnUpdate
  });
};

export const getUpdateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPut
        >
      >,
      TError,
      { streetTurnId: string; data: StreetTurnUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPut
      >
    >,
    TError,
    { streetTurnId: string; data: StreetTurnUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPut
        >
      >,
      { streetTurnId: string; data: StreetTurnUpdate }
    > = (props) => {
      const { streetTurnId, data } = props ?? {};

      return updateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPut(
        streetTurnId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPut
      >
    >
  >;
export type UpdateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPutMutationBody =
  StreetTurnUpdate;
export type UpdateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Street Turn
 */
export const useUpdateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPut
        >
      >,
      TError,
      { streetTurnId: string; data: StreetTurnUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPut>
  >,
  TError,
  { streetTurnId: string; data: StreetTurnUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a street turn.
 * @summary Delete Street Turn
 */
export const deleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDelete = (
  streetTurnId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/street-turns/${streetTurnId}`,
    method: 'DELETE'
  });
};

export const getDeleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDelete
        >
      >,
      TError,
      { streetTurnId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDelete
      >
    >,
    TError,
    { streetTurnId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDelete
        >
      >,
      { streetTurnId: string }
    > = (props) => {
      const { streetTurnId } = props ?? {};

      return deleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDelete(
        streetTurnId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDelete
      >
    >
  >;

export type DeleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Street Turn
 */
export const useDeleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDelete
        >
      >,
      TError,
      { streetTurnId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDelete
    >
  >,
  TError,
  { streetTurnId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteStreetTurnApiV1ShipmentsStreetTurnsStreetTurnIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Amend an export-control record's classification, licence decision or AES ITN —
admin-gated (regulated assertion).
 * @summary Update Export Control Record
 */
export const updateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPut =
  (recordId: string, exportControlRecordUpdate: ExportControlRecordUpdate) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/export-control-records/${recordId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: exportControlRecordUpdate
    });
  };

export const getUpdateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPut
        >
      >,
      TError,
      { recordId: string; data: ExportControlRecordUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPut
      >
    >,
    TError,
    { recordId: string; data: ExportControlRecordUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPut
        >
      >,
      { recordId: string; data: ExportControlRecordUpdate }
    > = (props) => {
      const { recordId, data } = props ?? {};

      return updateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPut(
        recordId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPut
      >
    >
  >;
export type UpdateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPutMutationBody =
  ExportControlRecordUpdate;
export type UpdateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Export Control Record
 */
export const useUpdateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPut
          >
        >,
        TError,
        { recordId: string; data: ExportControlRecordUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPut
      >
    >,
    TError,
    { recordId: string; data: ExportControlRecordUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete an export-control record — admin-gated (regulated assertion).
 * @summary Delete Export Control Record
 */
export const deleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDelete =
  (recordId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/export-control-records/${recordId}`,
      method: 'DELETE'
    });
  };

export const getDeleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDelete
        >
      >,
      TError,
      { recordId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDelete
      >
    >,
    TError,
    { recordId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDelete
        >
      >,
      { recordId: string }
    > = (props) => {
      const { recordId } = props ?? {};

      return deleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDelete(
        recordId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDelete
      >
    >
  >;

export type DeleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Export Control Record
 */
export const useDeleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDelete
          >
        >,
        TError,
        { recordId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDelete
      >
    >,
    TError,
    { recordId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteExportControlRecordApiV1ShipmentsExportControlRecordsRecordIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Magic-drop for a document with no target job: classify + extract it, then
match it to a shipment by its extracted references (B/L, AWB, booking, container).

Body: ``{ "file_id": <uuid>, "document_type"?: <intent>,
"confirm_duplicate"?: bool }`` — an already-uploaded
file, NOT attached to any shipment. Byte-identical content this extractor has
already read is held with ``DOCUMENT_ALREADY_EXTRACTED`` (409) naming where that
earlier result went, and ``confirm_duplicate: true`` re-posts past it. On an
unambiguous match the item is filed
against that shipment (and the file attached to it) exactly as a job-file drop,
surfacing in that job's review summary. On no/ambiguous match it lands un-filed in
the quarantine queue below. Nothing is applied to any shipment until approved.

Multi-company: the un-filed item is stamped with the dropper's effective company
(S? — NULL when a multi-company user has no active scope, i.e. tenant-shared), so
the inbox below only shows an operator the drops their companies made. The
auto-match is likewise bounded to the dropper's accessible companies — a document
whose refs resolve to a sibling company's job quarantines instead of being filed
onto a shipment the dropper cannot see.
 * @summary Extract Unfiled Document
 */
export const extractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPost = (
  signal?: AbortSignal
) => {
  return customInstance<ShipmentDocumentParseJob>({
    url: `/api/v1/shipments/document-inbox/extract`,
    method: 'POST',
    signal
  });
};

export const getExtractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof extractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof extractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'extractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof extractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPost
        >
      >,
      void
    > = () => {
      return extractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExtractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof extractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPost
      >
    >
  >;

export type ExtractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPostMutationError =
  unknown;

/**
 * @summary Extract Unfiled Document
 */
export const useExtractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof extractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPost
        >
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof extractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPost
    >
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getExtractUnfiledDocumentApiV1ShipmentsDocumentInboxExtractPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Progress of the background parse jobs for files dropped on the un-filed inbox
— or, with ``file_ids`` omitted, this user's recent drop history.

Scoped to the jobs THIS user dropped, on both arms. This surface carries no
per-record gate (an un-filed document has no owning shipment to hang ReBAC on),
so scoping by dropper is what keeps it from becoming a window onto a job the
caller cannot see once a part auto-matches — while still letting the dropper
follow their own upload all the way to completion. The history arm drops only the
file-id filter, so that boundary is untouched. See
``ShipmentDocumentIntakeService.list_parse_jobs_for_dropper``.
 * @summary List Unfiled Document Parse Jobs
 */
export const listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet =
  (
    params?: ListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<ShipmentDocumentParseJob[]>({
      url: `/api/v1/shipments/document-inbox/parse-jobs`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetQueryKey =
  (
    params?: ListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetParams
  ) => {
    return [
      `/api/v1/shipments/document-inbox/parse-jobs`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
        >
      >
    > = ({ signal }) =>
      listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
      >
    >
  >;
export type ListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetQueryError =
  HTTPValidationError;

export function useListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Unfiled Document Parse Jobs
 */

export function useListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListUnfiledDocumentParseJobsApiV1ShipmentsDocumentInboxParseJobsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The inbox twin of the job-file upload-attempt history: one page of THIS user's
un-filed drops, newest first, with the unpaginated ``total``.

Server-paged (Shape A) for the same reason as its twin — un-filed drops
accumulate too, and an inbox drop that hard-failed is exactly as unreachable once
it has aged past the panel's recent window.

Scoped to the DROPPER on every page. This surface carries no per-record gate (an
un-filed document has no owning shipment to hang ReBAC on), so that predicate is
the only boundary it has, and a page is not a place it may be relaxed: an offset
past this caller's own drops returns nothing, never somebody else's older ones.
See ``ShipmentDocumentIntakeService.parse_job_history_page_for_dropper``.
 * @summary List Unfiled Document Parse Job History
 */
export const listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet =
  (
    params?: ListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<ShipmentDocumentParseJobList>({
      url: `/api/v1/shipments/document-inbox/parse-jobs/history`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetQueryKey =
  (
    params?: ListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetParams
  ) => {
    return [
      `/api/v1/shipments/document-inbox/parse-jobs/history`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
        >
      >
    > = ({ signal }) =>
      listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
      >
    >
  >;
export type ListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetQueryError =
  HTTPValidationError;

export function useListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Unfiled Document Parse Job History
 */

export function useListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListUnfiledDocumentParseJobHistoryApiV1ShipmentsDocumentInboxParseJobsHistoryGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Re-extract only the parts of an un-filed drop the model could not read.

The inbox twin of the job-file retry below. Scoped to the job's DROPPER, for the
same reason its poll route is (this surface carries no per-record gate — an
un-filed document has no owning shipment to hang ReBAC on), and it is the
dropper's own company scope that bounds any auto-match the retried parts make.

Refuses (409) a job that is still extracting, or one with nothing unread. What
it replaces is a re-drop, which uploads the same bytes again as a NEW file and so
re-extracts every part of the pack — duplicating the ones that already worked.
 * @summary Retry Unfiled Document Parse Job
 */
export const retryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPost =
  (jobId: string, signal?: AbortSignal) => {
    return customInstance<ShipmentDocumentParseJob>({
      url: `/api/v1/shipments/document-inbox/parse-jobs/${jobId}/retry`,
      method: 'POST',
      signal
    });
  };

export const getRetryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof retryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPost
        >
      >,
      TError,
      { jobId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof retryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPost
      >
    >,
    TError,
    { jobId: string },
    TContext
  > => {
    const mutationKey = [
      'retryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof retryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPost
        >
      >,
      { jobId: string }
    > = (props) => {
      const { jobId } = props ?? {};

      return retryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPost(
        jobId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RetryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof retryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPost
      >
    >
  >;

export type RetryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPostMutationError =
  HTTPValidationError;

/**
 * @summary Retry Unfiled Document Parse Job
 */
export const useRetryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof retryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPost
          >
        >,
        TError,
        { jobId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof retryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPost
      >
    >,
    TError,
    { jobId: string },
    TContext
  > => {
    const mutationOptions =
      getRetryUnfiledDocumentParseJobApiV1ShipmentsDocumentInboxParseJobsJobIdRetryPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The quarantine queue: extracted documents that could not be matched to a job.

Tenant-scoped (RLS) + company-scoped (S? — a NULL ``company_id`` is a
tenant-shared drop and stays visible to everyone). There is no per-shipment ReBAC
gate to apply here — that is the whole point of the queue: these items have no
shipment. An operator files one via the assign route below, after which it is only
visible through that shipment's own access-gated intake route.
 * @summary List Unfiled Document Intake Items
 */
export const listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet =
  (
    params?: ListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/document-inbox/items`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetQueryKey =
  (
    params?: ListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetParams
  ) => {
    return [
      `/api/v1/shipments/document-inbox/items`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
        >
      >
    > = ({ signal }) =>
      listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
      >
    >
  >;
export type ListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetQueryError =
  HTTPValidationError;

export function useListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Unfiled Document Intake Items
 */

export function useListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListUnfiledDocumentIntakeItemsApiV1ShipmentsDocumentInboxItemsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * File a quarantined document against the shipment an operator picked.

Body: ``{ "shipment_id": <uuid> }``. The target shipment arrives in the BODY, so
the router's path-keyed ReBAC gate does not cover it — enforce EDITOR on the
chosen shipment inline (writing an extracted document onto a job is a mutation of
that job), exactly as the child-id-only routes above do.

The same applies to the multi-company boundary: RLS isolates tenants, not
companies, so a caller-supplied ``shipment_id`` steers which company's row is
read. Assert the target shipment's company is one the caller can act on — the
picker's list route already hides sibling-company jobs, this is the gate that
makes it a boundary rather than a UI convenience.
 * @summary Assign Unfiled Document Intake Item
 */
export const assignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPost =
  (itemId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/document-inbox/items/${itemId}/assign`,
      method: 'POST',
      signal
    });
  };

export const getAssignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof assignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPost
        >
      >,
      TError,
      { itemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof assignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPost
      >
    >,
    TError,
    { itemId: string },
    TContext
  > => {
    const mutationKey = [
      'assignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof assignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPost
        >
      >,
      { itemId: string }
    > = (props) => {
      const { itemId } = props ?? {};

      return assignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPost(
        itemId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof assignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPost
      >
    >
  >;

export type AssignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPostMutationError =
  HTTPValidationError;

/**
 * @summary Assign Unfiled Document Intake Item
 */
export const useAssignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof assignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPost
          >
        >,
        TError,
        { itemId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof assignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPost
      >
    >,
    TError,
    { itemId: string },
    TContext
  > => {
    const mutationOptions =
      getAssignUnfiledDocumentIntakeItemApiV1ShipmentsDocumentInboxItemsItemIdAssignPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The export-control records held against a shipment, by ECCN.
 * @summary List Export Control Records
 */
export const listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/export-control-records`,
      method: 'GET',
      signal
    });
  };

export const getListExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/export-control-records`] as const;
  };

export const getListExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
        >
      >
    > = ({ signal }) =>
      listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
      >
    >
  >;
export type ListExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGetQueryError =
  HTTPValidationError;

export function useListExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet<
  TData = Awaited<
    ReturnType<
      typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet<
  TData = Awaited<
    ReturnType<
      typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet<
  TData = Awaited<
    ReturnType<
      typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Export Control Records
 */

export function useListExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet<
  TData = Awaited<
    ReturnType<
      typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListExportControlRecordsApiV1ShipmentsShipmentIdExportControlRecordsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Record an export-control classification against a shipment — admin-gated
(regulated assertion).
 * @summary Create Export Control Record
 */
export const createExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPost =
  (
    shipmentId: string,
    exportControlRecordCreate: ExportControlRecordCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/export-control-records`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: exportControlRecordCreate,
      signal
    });
  };

export const getCreateExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPost
        >
      >,
      TError,
      { shipmentId: string; data: ExportControlRecordCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPost
      >
    >,
    TError,
    { shipmentId: string; data: ExportControlRecordCreate },
    TContext
  > => {
    const mutationKey = [
      'createExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPost
        >
      >,
      { shipmentId: string; data: ExportControlRecordCreate }
    > = (props) => {
      const { shipmentId, data } = props ?? {};

      return createExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPost(
        shipmentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPost
      >
    >
  >;
export type CreateExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPostMutationBody =
  ExportControlRecordCreate;
export type CreateExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Export Control Record
 */
export const useCreateExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPost
          >
        >,
        TError,
        { shipmentId: string; data: ExportControlRecordCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPost
      >
    >,
    TError,
    { shipmentId: string; data: ExportControlRecordCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateExportControlRecordApiV1ShipmentsShipmentIdExportControlRecordsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Amend a DG declaration's regulation, emergency contact or notes — admin-gated.
Rejected with 409 while the declaration is signed.
 * @summary Update Dg Declaration
 */
export const updateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPut = (
  declarationId: string,
  dgDeclarationUpdate: DgDeclarationUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/dg-declarations/${declarationId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: dgDeclarationUpdate
  });
};

export const getUpdateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPut
        >
      >,
      TError,
      { declarationId: string; data: DgDeclarationUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPut
      >
    >,
    TError,
    { declarationId: string; data: DgDeclarationUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPut
        >
      >,
      { declarationId: string; data: DgDeclarationUpdate }
    > = (props) => {
      const { declarationId, data } = props ?? {};

      return updateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPut(
        declarationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPut
      >
    >
  >;
export type UpdateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPutMutationBody =
  DgDeclarationUpdate;
export type UpdateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Dg Declaration
 */
export const useUpdateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPut
          >
        >,
        TError,
        { declarationId: string; data: DgDeclarationUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPut
      >
    >,
    TError,
    { declarationId: string; data: DgDeclarationUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a DG declaration and its lines — admin-gated. Refused while signed.
 * @summary Delete Dg Declaration
 */
export const deleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDelete =
  (declarationId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/dg-declarations/${declarationId}`,
      method: 'DELETE'
    });
  };

export const getDeleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDelete
        >
      >,
      TError,
      { declarationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDelete
      >
    >,
    TError,
    { declarationId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDelete
        >
      >,
      { declarationId: string }
    > = (props) => {
      const { declarationId } = props ?? {};

      return deleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDelete(
        declarationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDelete
      >
    >
  >;

export type DeleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Dg Declaration
 */
export const useDeleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDelete
          >
        >,
        TError,
        { declarationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDelete
      >
    >,
    TError,
    { declarationId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Record the signatory's attestation and freeze the declaration — admin-gated.

PanLuma stores the attestation the signatory makes; it never makes or verifies it.
 * @summary Sign Dg Declaration
 */
export const signDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPost =
  (
    declarationId: string,
    dgDeclarationSign: DgDeclarationSign,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/dg-declarations/${declarationId}/sign`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dgDeclarationSign,
      signal
    });
  };

export const getSignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof signDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPost
        >
      >,
      TError,
      { declarationId: string; data: DgDeclarationSign },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof signDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPost
      >
    >,
    TError,
    { declarationId: string; data: DgDeclarationSign },
    TContext
  > => {
    const mutationKey = [
      'signDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof signDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPost
        >
      >,
      { declarationId: string; data: DgDeclarationSign }
    > = (props) => {
      const { declarationId, data } = props ?? {};

      return signDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPost(
        declarationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof signDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPost
      >
    >
  >;
export type SignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPostMutationBody =
  DgDeclarationSign;
export type SignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPostMutationError =
  HTTPValidationError;

/**
 * @summary Sign Dg Declaration
 */
export const useSignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof signDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPost
          >
        >,
        TError,
        { declarationId: string; data: DgDeclarationSign },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof signDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPost
      >
    >,
    TError,
    { declarationId: string; data: DgDeclarationSign },
    TContext
  > => {
    const mutationOptions =
      getSignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdSignPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Withdraw the signature so the declaration can be amended — admin-gated.
 * @summary Unsign Dg Declaration
 */
export const unsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPost =
  (declarationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/dg-declarations/${declarationId}/unsign`,
      method: 'POST',
      signal
    });
  };

export const getUnsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPost
        >
      >,
      TError,
      { declarationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPost
      >
    >,
    TError,
    { declarationId: string },
    TContext
  > => {
    const mutationKey = [
      'unsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPost
        >
      >,
      { declarationId: string }
    > = (props) => {
      const { declarationId } = props ?? {};

      return unsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPost(
        declarationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPost
      >
    >
  >;

export type UnsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPostMutationError =
  HTTPValidationError;

/**
 * @summary Unsign Dg Declaration
 */
export const useUnsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPost
          >
        >,
        TError,
        { declarationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPost
      >
    >,
    TError,
    { declarationId: string },
    TContext
  > => {
    const mutationOptions =
      getUnsignDgDeclarationApiV1ShipmentsDgDeclarationsDeclarationIdUnsignPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Add a dangerous-goods entry to a declaration — admin-gated. Refused while signed.
 * @summary Create Dg Declaration Line
 */
export const createDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPost =
  (
    declarationId: string,
    dgDeclarationLineCreate: DgDeclarationLineCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/dg-declarations/${declarationId}/lines`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dgDeclarationLineCreate,
      signal
    });
  };

export const getCreateDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPost
        >
      >,
      TError,
      { declarationId: string; data: DgDeclarationLineCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPost
      >
    >,
    TError,
    { declarationId: string; data: DgDeclarationLineCreate },
    TContext
  > => {
    const mutationKey = [
      'createDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPost
        >
      >,
      { declarationId: string; data: DgDeclarationLineCreate }
    > = (props) => {
      const { declarationId, data } = props ?? {};

      return createDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPost(
        declarationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPost
      >
    >
  >;
export type CreateDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPostMutationBody =
  DgDeclarationLineCreate;
export type CreateDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Dg Declaration Line
 */
export const useCreateDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPost
          >
        >,
        TError,
        { declarationId: string; data: DgDeclarationLineCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPost
      >
    >,
    TError,
    { declarationId: string; data: DgDeclarationLineCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateDgDeclarationLineApiV1ShipmentsDgDeclarationsDeclarationIdLinesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Amend a dangerous-goods entry — admin-gated. Refused while the parent is signed.
 * @summary Update Dg Declaration Line
 */
export const updateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPut =
  (lineId: string, dgDeclarationLineUpdate: DgDeclarationLineUpdate) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/dg-declaration-lines/${lineId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: dgDeclarationLineUpdate
    });
  };

export const getUpdateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPut
        >
      >,
      TError,
      { lineId: string; data: DgDeclarationLineUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPut
      >
    >,
    TError,
    { lineId: string; data: DgDeclarationLineUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPut
        >
      >,
      { lineId: string; data: DgDeclarationLineUpdate }
    > = (props) => {
      const { lineId, data } = props ?? {};

      return updateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPut(
        lineId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPut
      >
    >
  >;
export type UpdateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPutMutationBody =
  DgDeclarationLineUpdate;
export type UpdateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Dg Declaration Line
 */
export const useUpdateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPut
          >
        >,
        TError,
        { lineId: string; data: DgDeclarationLineUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPut
      >
    >,
    TError,
    { lineId: string; data: DgDeclarationLineUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a dangerous-goods entry — admin-gated. Refused while the parent is signed.
 * @summary Delete Dg Declaration Line
 */
export const deleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDelete =
  (lineId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/dg-declaration-lines/${lineId}`,
      method: 'DELETE'
    });
  };

export const getDeleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDelete
        >
      >,
      TError,
      { lineId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDelete
      >
    >,
    TError,
    { lineId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDelete
        >
      >,
      { lineId: string }
    > = (props) => {
      const { lineId } = props ?? {};

      return deleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDelete(
        lineId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDelete
      >
    >
  >;

export type DeleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Dg Declaration Line
 */
export const useDeleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDelete
          >
        >,
        TError,
        { lineId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDelete
      >
    >,
    TError,
    { lineId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteDgDeclarationLineApiV1ShipmentsDgDeclarationLinesLineIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The branded Dangerous Goods Declaration PDF.

Available on a draft as well as a signed declaration — a draft prints a visible
"NOT SIGNED" banner and an empty signature block, so it can be circulated for review
without being mistakable for the real thing. The generated PDF is retained via
file_management, attached to the declaration.

Reads are VIEWER-gated: a collaborator may see what is declared on the file.
 * @summary Get Dg Declaration Pdf
 */
export const getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet =
  (
    declarationId: string,
    params?: GetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/dg-declarations/${declarationId}/pdf`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetQueryKey =
  (
    declarationId?: string,
    params?: GetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetParams
  ) => {
    return [
      `/api/v1/shipments/dg-declarations/${declarationId}/pdf`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
      >
    >,
    TError = HTTPValidationError
  >(
    declarationId: string,
    params?: GetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetQueryKey(
        declarationId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
        >
      >
    > = ({ signal }) =>
      getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet(
        declarationId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!declarationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
      >
    >
  >;
export type GetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetQueryError =
  HTTPValidationError;

export function useGetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  declarationId: string,
  params:
    | undefined
    | GetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  declarationId: string,
  params?: GetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  declarationId: string,
  params?: GetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Dg Declaration Pdf
 */

export function useGetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  declarationId: string,
  params?: GetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDgDeclarationPdfApiV1ShipmentsDgDeclarationsDeclarationIdPdfGetQueryOptions(
      declarationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Branded DGD preview HTML (for in-browser rendering).
 * @summary Get Dg Declaration Preview
 */
export const getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet =
  (
    declarationId: string,
    params?: GetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/dg-declarations/${declarationId}/preview`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetQueryKey =
  (
    declarationId?: string,
    params?: GetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetParams
  ) => {
    return [
      `/api/v1/shipments/dg-declarations/${declarationId}/preview`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    declarationId: string,
    params?: GetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetQueryKey(
        declarationId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
        >
      >
    > = ({ signal }) =>
      getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet(
        declarationId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!declarationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
      >
    >
  >;
export type GetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetQueryError =
  HTTPValidationError;

export function useGetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  declarationId: string,
  params:
    | undefined
    | GetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  declarationId: string,
  params?: GetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  declarationId: string,
  params?: GetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Dg Declaration Preview
 */

export function useGetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  declarationId: string,
  params?: GetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDgDeclarationPreviewApiV1ShipmentsDgDeclarationsDeclarationIdPreviewGetQueryOptions(
      declarationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The DG declarations held against a shipment, by regulation, each with its lines.
 * @summary List Dg Declarations
 */
export const listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/dg-declarations`,
    method: 'GET',
    signal
  });
};

export const getListDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/dg-declarations`] as const;
  };

export const getListDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
        >
      >
    > = ({ signal }) =>
      listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
      >
    >
  >;
export type ListDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGetQueryError =
  HTTPValidationError;

export function useListDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet<
  TData = Awaited<
    ReturnType<
      typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet<
  TData = Awaited<
    ReturnType<
      typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet<
  TData = Awaited<
    ReturnType<
      typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Dg Declarations
 */

export function useListDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet<
  TData = Awaited<
    ReturnType<
      typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDgDeclarationsApiV1ShipmentsShipmentIdDgDeclarationsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Open a DG declaration against a shipment under one regulation — admin-gated.
 * @summary Create Dg Declaration
 */
export const createDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPost = (
  shipmentId: string,
  dgDeclarationCreate: DgDeclarationCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/dg-declarations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: dgDeclarationCreate,
    signal
  });
};

export const getCreateDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPost
        >
      >,
      TError,
      { shipmentId: string; data: DgDeclarationCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPost
      >
    >,
    TError,
    { shipmentId: string; data: DgDeclarationCreate },
    TContext
  > => {
    const mutationKey = [
      'createDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPost
        >
      >,
      { shipmentId: string; data: DgDeclarationCreate }
    > = (props) => {
      const { shipmentId, data } = props ?? {};

      return createDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPost(
        shipmentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPost
      >
    >
  >;
export type CreateDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPostMutationBody =
  DgDeclarationCreate;
export type CreateDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Dg Declaration
 */
export const useCreateDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPost
          >
        >,
        TError,
        { shipmentId: string; data: DgDeclarationCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPost
      >
    >,
    TError,
    { shipmentId: string; data: DgDeclarationCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateDgDeclarationApiV1ShipmentsShipmentIdDgDeclarationsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The tenant's own document types — the extra options every document-type picker
offers beside the built-in ones.

Readable by any member: a picker that hid a type the user's colleague created would
make their documents unfileable. Writing is admin-gated below.

Shape B (bounded, tenant-curated), exactly like the charge-code sibling above:
omitting ``limit`` returns the complete set, because the pickers and the settings
page both slice client-side and a hidden cap here would silently drop types off the
end of a picker — which reads to the user as "my type is gone", not as a page 2.
 * @summary List Tenant Document Types
 */
export const listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet = (
  params?: ListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<TenantDocumentTypeList>({
    url: `/api/v1/shipments/document-types`,
    method: 'GET',
    params,
    signal
  });
};

export const getListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetQueryKey =
  (params?: ListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetParams) => {
    return [
      `/api/v1/shipments/document-types`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet>
      >
    > = ({ signal }) =>
      listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet>
    >
  >;
export type ListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetQueryError =
  HTTPValidationError;

export function useListTenantDocumentTypesApiV1ShipmentsDocumentTypesGet<
  TData = Awaited<
    ReturnType<typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTenantDocumentTypesApiV1ShipmentsDocumentTypesGet<
  TData = Awaited<
    ReturnType<typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTenantDocumentTypesApiV1ShipmentsDocumentTypesGet<
  TData = Awaited<
    ReturnType<typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Tenant Document Types
 */

export function useListTenantDocumentTypesApiV1ShipmentsDocumentTypesGet<
  TData = Awaited<
    ReturnType<typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTenantDocumentTypesApiV1ShipmentsDocumentTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTenantDocumentTypesApiV1ShipmentsDocumentTypesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Define one of the tenant's own document types — admin-gated, like the workflow
templates below: it changes what every user of the tenant is offered.
 * @summary Create Tenant Document Type
 */
export const createTenantDocumentTypeApiV1ShipmentsDocumentTypesPost = (
  tenantDocumentTypeCreate: TenantDocumentTypeCreate,
  signal?: AbortSignal
) => {
  return customInstance<TenantDocumentType>({
    url: `/api/v1/shipments/document-types`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tenantDocumentTypeCreate,
    signal
  });
};

export const getCreateTenantDocumentTypeApiV1ShipmentsDocumentTypesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createTenantDocumentTypeApiV1ShipmentsDocumentTypesPost
        >
      >,
      TError,
      { data: TenantDocumentTypeCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createTenantDocumentTypeApiV1ShipmentsDocumentTypesPost>
    >,
    TError,
    { data: TenantDocumentTypeCreate },
    TContext
  > => {
    const mutationKey = [
      'createTenantDocumentTypeApiV1ShipmentsDocumentTypesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createTenantDocumentTypeApiV1ShipmentsDocumentTypesPost
        >
      >,
      { data: TenantDocumentTypeCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createTenantDocumentTypeApiV1ShipmentsDocumentTypesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateTenantDocumentTypeApiV1ShipmentsDocumentTypesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createTenantDocumentTypeApiV1ShipmentsDocumentTypesPost>
    >
  >;
export type CreateTenantDocumentTypeApiV1ShipmentsDocumentTypesPostMutationBody =
  TenantDocumentTypeCreate;
export type CreateTenantDocumentTypeApiV1ShipmentsDocumentTypesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Tenant Document Type
 */
export const useCreateTenantDocumentTypeApiV1ShipmentsDocumentTypesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createTenantDocumentTypeApiV1ShipmentsDocumentTypesPost
        >
      >,
      TError,
      { data: TenantDocumentTypeCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createTenantDocumentTypeApiV1ShipmentsDocumentTypesPost>
  >,
  TError,
  { data: TenantDocumentTypeCreate },
  TContext
> => {
  const mutationOptions =
    getCreateTenantDocumentTypeApiV1ShipmentsDocumentTypesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update one of the tenant's own document types (the code is immutable).
 * @summary Update Tenant Document Type
 */
export const updateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPut = (
  typeId: string,
  tenantDocumentTypeUpdate: TenantDocumentTypeUpdate
) => {
  return customInstance<TenantDocumentType>({
    url: `/api/v1/shipments/document-types/${typeId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: tenantDocumentTypeUpdate
  });
};

export const getUpdateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPut
        >
      >,
      TError,
      { typeId: string; data: TenantDocumentTypeUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPut
      >
    >,
    TError,
    { typeId: string; data: TenantDocumentTypeUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPut
        >
      >,
      { typeId: string; data: TenantDocumentTypeUpdate }
    > = (props) => {
      const { typeId, data } = props ?? {};

      return updateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPut(
        typeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPut
      >
    >
  >;
export type UpdateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPutMutationBody =
  TenantDocumentTypeUpdate;
export type UpdateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Document Type
 */
export const useUpdateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPut
        >
      >,
      TError,
      { typeId: string; data: TenantDocumentTypeUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPut
    >
  >,
  TError,
  { typeId: string; data: TenantDocumentTypeUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a type nothing references; RETIRE one that documents already carry.

The response says which happened, because they are different outcomes: a retired
type stops being offered and keeps rendering on the rows already filed under it,
which is the whole point of having recorded the tenant's own word for it.
 * @summary Delete Tenant Document Type
 */
export const deleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDelete = (
  typeId: string
) => {
  return customInstance<TenantDocumentTypeDeleteResult>({
    url: `/api/v1/shipments/document-types/${typeId}`,
    method: 'DELETE'
  });
};

export const getDeleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDelete
        >
      >,
      TError,
      { typeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDelete
      >
    >,
    TError,
    { typeId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDelete
        >
      >,
      { typeId: string }
    > = (props) => {
      const { typeId } = props ?? {};

      return deleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDelete(
        typeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDelete
      >
    >
  >;

export type DeleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Tenant Document Type
 */
export const useDeleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDelete
          >
        >,
        TError,
        { typeId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDelete
      >
    >,
    TError,
    { typeId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteTenantDocumentTypeApiV1ShipmentsDocumentTypesTypeIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Every visible workflow template (system seeds + the tenant's own), flagged
tenant-owned vs seed — for the shipments-settings management UI.
 * @summary List Workflow Templates
 */
export const listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/workflow-templates`,
    method: 'GET',
    signal
  });
};

export const getListWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGetQueryKey =
  () => {
    return [`/api/v1/shipments/workflow-templates`] as const;
  };

export const getListWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
        >
      >
    > = ({ signal }) =>
      listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet>
    >
  >;
export type ListWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGetQueryError =
  unknown;

export function useListWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Workflow Templates
 */

export function useListWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListWorkflowTemplatesApiV1ShipmentsWorkflowTemplatesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a tenant-owned workflow template.
 * @summary Create Workflow Template
 */
export const createWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPost = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/workflow-templates`,
    method: 'POST',
    signal
  });
};

export const getCreateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'createWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPost
        >
      >,
      void
    > = () => {
      return createWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPost
      >
    >
  >;

export type CreateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPostMutationError =
  unknown;

/**
 * @summary Create Workflow Template
 */
export const useCreateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPost
        >
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPost>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getCreateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a tenant-owned workflow template (system seeds are read-only).
 * @summary Update Workflow Template
 */
export const updateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPut =
  (templateId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/workflow-templates/${templateId}`,
      method: 'PUT'
    });
  };

export const getUpdateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPut
        >
      >,
      TError,
      { templateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPut
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationKey = [
      'updateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPut
        >
      >,
      { templateId: string }
    > = (props) => {
      const { templateId } = props ?? {};

      return updateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPut(
        templateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPut
      >
    >
  >;

export type UpdateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Workflow Template
 */
export const useUpdateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPut
          >
        >,
        TError,
        { templateId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPut
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationOptions =
      getUpdateWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a tenant-owned workflow template (system seeds are read-only).
 * @summary Delete Workflow Template
 */
export const deleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDelete =
  (templateId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/workflow-templates/${templateId}`,
      method: 'DELETE'
    });
  };

export const getDeleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDelete
        >
      >,
      TError,
      { templateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDelete
        >
      >,
      { templateId: string }
    > = (props) => {
      const { templateId } = props ?? {};

      return deleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDelete(
        templateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDelete
      >
    >
  >;

export type DeleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Workflow Template
 */
export const useDeleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDelete
          >
        >,
        TError,
        { templateId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteWorkflowTemplateApiV1ShipmentsWorkflowTemplatesTemplateIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Suggest nearby ports/airports for route planning.
 * @summary Suggest Ports
 */
export const suggestPortsApiV1ShipmentsRoutingSuggestPortsGet = (
  params: SuggestPortsApiV1ShipmentsRoutingSuggestPortsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/routing/suggest-ports`,
    method: 'GET',
    params,
    signal
  });
};

export const getSuggestPortsApiV1ShipmentsRoutingSuggestPortsGetQueryKey = (
  params?: SuggestPortsApiV1ShipmentsRoutingSuggestPortsGetParams
) => {
  return [
    `/api/v1/shipments/routing/suggest-ports`,
    ...(params ? [params] : [])
  ] as const;
};

export const getSuggestPortsApiV1ShipmentsRoutingSuggestPortsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
  >,
  TError = HTTPValidationError
>(
  params: SuggestPortsApiV1ShipmentsRoutingSuggestPortsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSuggestPortsApiV1ShipmentsRoutingSuggestPortsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>>
  > = ({ signal }) =>
    suggestPortsApiV1ShipmentsRoutingSuggestPortsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SuggestPortsApiV1ShipmentsRoutingSuggestPortsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>>
  >;
export type SuggestPortsApiV1ShipmentsRoutingSuggestPortsGetQueryError =
  HTTPValidationError;

export function useSuggestPortsApiV1ShipmentsRoutingSuggestPortsGet<
  TData = Awaited<
    ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
  >,
  TError = HTTPValidationError
>(
  params: SuggestPortsApiV1ShipmentsRoutingSuggestPortsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSuggestPortsApiV1ShipmentsRoutingSuggestPortsGet<
  TData = Awaited<
    ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
  >,
  TError = HTTPValidationError
>(
  params: SuggestPortsApiV1ShipmentsRoutingSuggestPortsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSuggestPortsApiV1ShipmentsRoutingSuggestPortsGet<
  TData = Awaited<
    ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
  >,
  TError = HTTPValidationError
>(
  params: SuggestPortsApiV1ShipmentsRoutingSuggestPortsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Suggest Ports
 */

export function useSuggestPortsApiV1ShipmentsRoutingSuggestPortsGet<
  TData = Awaited<
    ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
  >,
  TError = HTTPValidationError
>(
  params: SuggestPortsApiV1ShipmentsRoutingSuggestPortsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof suggestPortsApiV1ShipmentsRoutingSuggestPortsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getSuggestPortsApiV1ShipmentsRoutingSuggestPortsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Check whether the routing wizard should be offered for a shipment.
 * @summary Check Routing Eligibility
 */
export const checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/routing/eligibility/${shipmentId}`,
      method: 'GET',
      signal
    });
  };

export const getCheckRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/routing/eligibility/${shipmentId}`] as const;
  };

export const getCheckRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getCheckRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
        >
      >
    > = ({ signal }) =>
      checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type CheckRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
      >
    >
  >;
export type CheckRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGetQueryError =
  HTTPValidationError;

export function useCheckRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCheckRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCheckRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Check Routing Eligibility
 */

export function useCheckRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet<
  TData = Awaited<
    ReturnType<
      typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof checkRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getCheckRoutingEligibilityApiV1ShipmentsRoutingEligibilityShipmentIdGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Preview leg plans for a shipment without creating them.
 * @summary Plan Route
 */
export const planRouteApiV1ShipmentsRoutingPlanShipmentIdPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/routing/plan/${shipmentId}`,
    method: 'POST',
    signal
  });
};

export const getPlanRouteApiV1ShipmentsRoutingPlanShipmentIdPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof planRouteApiV1ShipmentsRoutingPlanShipmentIdPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof planRouteApiV1ShipmentsRoutingPlanShipmentIdPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = ['planRouteApiV1ShipmentsRoutingPlanShipmentIdPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof planRouteApiV1ShipmentsRoutingPlanShipmentIdPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return planRouteApiV1ShipmentsRoutingPlanShipmentIdPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PlanRouteApiV1ShipmentsRoutingPlanShipmentIdPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof planRouteApiV1ShipmentsRoutingPlanShipmentIdPost>>
  >;

export type PlanRouteApiV1ShipmentsRoutingPlanShipmentIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Plan Route
 */
export const usePlanRouteApiV1ShipmentsRoutingPlanShipmentIdPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof planRouteApiV1ShipmentsRoutingPlanShipmentIdPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof planRouteApiV1ShipmentsRoutingPlanShipmentIdPost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getPlanRouteApiV1ShipmentsRoutingPlanShipmentIdPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create legs for a shipment based on selected ports.
 * @summary Apply Route
 */
export const applyRouteApiV1ShipmentsRoutingApplyShipmentIdPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/routing/apply/${shipmentId}`,
    method: 'POST',
    signal
  });
};

export const getApplyRouteApiV1ShipmentsRoutingApplyShipmentIdPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof applyRouteApiV1ShipmentsRoutingApplyShipmentIdPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof applyRouteApiV1ShipmentsRoutingApplyShipmentIdPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = ['applyRouteApiV1ShipmentsRoutingApplyShipmentIdPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof applyRouteApiV1ShipmentsRoutingApplyShipmentIdPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return applyRouteApiV1ShipmentsRoutingApplyShipmentIdPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApplyRouteApiV1ShipmentsRoutingApplyShipmentIdPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof applyRouteApiV1ShipmentsRoutingApplyShipmentIdPost>
    >
  >;

export type ApplyRouteApiV1ShipmentsRoutingApplyShipmentIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Apply Route
 */
export const useApplyRouteApiV1ShipmentsRoutingApplyShipmentIdPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof applyRouteApiV1ShipmentsRoutingApplyShipmentIdPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof applyRouteApiV1ShipmentsRoutingApplyShipmentIdPost>
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getApplyRouteApiV1ShipmentsRoutingApplyShipmentIdPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Preview the un-invoiced sell charges (grouped by currency, with resolved GL
accounts + disbursement flags) the "Invoice this shipment" dialog will draft.
 * @summary List Invoiceable Charges
 */
export const listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet = (
  params?: ListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/invoiceable-charges`,
    method: 'GET',
    params,
    signal
  });
};

export const getListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetQueryKey =
  (
    params?: ListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetParams
  ) => {
    return [
      `/api/v1/shipments/invoiceable-charges`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
        >
      >
    > = ({ signal }) =>
      listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
      >
    >
  >;
export type ListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetQueryError =
  HTTPValidationError;

export function useListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet<
  TData = Awaited<
    ReturnType<typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet<
  TData = Awaited<
    ReturnType<typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet<
  TData = Awaited<
    ReturnType<typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Invoiceable Charges
 */

export function useListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet<
  TData = Awaited<
    ReturnType<typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInvoiceableChargesApiV1ShipmentsInvoiceableChargesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInvoiceableChargesApiV1ShipmentsInvoiceableChargesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Dry-run the month-end freight accrual for a period: what WOULD post, by
shipment + account, with per-shipment action (create/replace/unchanged/skip)
and warnings. No DB writes. The posted result equals this preview by
construction (shared plan-builder).
 * @summary Preview Freight Accruals
 */
export const previewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPost = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/freight-accruals/preview`,
    method: 'POST',
    signal
  });
};

export const getPreviewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof previewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof previewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'previewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof previewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPost
        >
      >,
      void
    > = () => {
      return previewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type PreviewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPost
      >
    >
  >;

export type PreviewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPostMutationError =
  unknown;

/**
 * @summary Preview Freight Accruals
 */
export const usePreviewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPost =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof previewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPost
          >
        >,
        TError,
        void,
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof previewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationOptions =
      getPreviewFreightAccrualsApiV1ShipmentsFreightAccrualsPreviewPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Post the month-end freight accrual for a period: one auto-reversing JE per
open shipment with planned-but-unbilled charges. Idempotent per (shipment,
period) — re-running replaces a changed accrual and skips an unchanged one.
Cost accrues always; revenue accrues only under an ATD/POD rev-rec basis.
 * @summary Run Freight Accruals
 */
export const runFreightAccrualsApiV1ShipmentsFreightAccrualsRunPost = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/freight-accruals/run`,
    method: 'POST',
    signal
  });
};

export const getRunFreightAccrualsApiV1ShipmentsFreightAccrualsRunPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof runFreightAccrualsApiV1ShipmentsFreightAccrualsRunPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof runFreightAccrualsApiV1ShipmentsFreightAccrualsRunPost>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'runFreightAccrualsApiV1ShipmentsFreightAccrualsRunPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof runFreightAccrualsApiV1ShipmentsFreightAccrualsRunPost
        >
      >,
      void
    > = () => {
      return runFreightAccrualsApiV1ShipmentsFreightAccrualsRunPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type RunFreightAccrualsApiV1ShipmentsFreightAccrualsRunPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof runFreightAccrualsApiV1ShipmentsFreightAccrualsRunPost>
    >
  >;

export type RunFreightAccrualsApiV1ShipmentsFreightAccrualsRunPostMutationError =
  unknown;

/**
 * @summary Run Freight Accruals
 */
export const useRunFreightAccrualsApiV1ShipmentsFreightAccrualsRunPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof runFreightAccrualsApiV1ShipmentsFreightAccrualsRunPost
        >
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof runFreightAccrualsApiV1ShipmentsFreightAccrualsRunPost>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getRunFreightAccrualsApiV1ShipmentsFreightAccrualsRunPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Draft AR invoice(s) from the selected (or all) un-invoiced sell charges of
one shipment, or a consolidated statement across several of one customer's
shipments. One draft per distinct sell currency.
 * @summary Invoice From Charges
 */
export const invoiceFromChargesApiV1ShipmentsInvoiceFromChargesPost = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/invoice-from-charges`,
    method: 'POST',
    signal
  });
};

export const getInvoiceFromChargesApiV1ShipmentsInvoiceFromChargesPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof invoiceFromChargesApiV1ShipmentsInvoiceFromChargesPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof invoiceFromChargesApiV1ShipmentsInvoiceFromChargesPost>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'invoiceFromChargesApiV1ShipmentsInvoiceFromChargesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof invoiceFromChargesApiV1ShipmentsInvoiceFromChargesPost
        >
      >,
      void
    > = () => {
      return invoiceFromChargesApiV1ShipmentsInvoiceFromChargesPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type InvoiceFromChargesApiV1ShipmentsInvoiceFromChargesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof invoiceFromChargesApiV1ShipmentsInvoiceFromChargesPost>
    >
  >;

export type InvoiceFromChargesApiV1ShipmentsInvoiceFromChargesPostMutationError =
  unknown;

/**
 * @summary Invoice From Charges
 */
export const useInvoiceFromChargesApiV1ShipmentsInvoiceFromChargesPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof invoiceFromChargesApiV1ShipmentsInvoiceFromChargesPost
        >
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof invoiceFromChargesApiV1ShipmentsInvoiceFromChargesPost>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getInvoiceFromChargesApiV1ShipmentsInvoiceFromChargesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Preview the un-billed buy charges (grouped by vendor + currency, with resolved
GL accounts + disbursement flags) the "Bill from vendor" dialog will draft.
 * @summary List Billable Charges
 */
export const listBillableChargesApiV1ShipmentsBillableChargesGet = (
  params?: ListBillableChargesApiV1ShipmentsBillableChargesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/billable-charges`,
    method: 'GET',
    params,
    signal
  });
};

export const getListBillableChargesApiV1ShipmentsBillableChargesGetQueryKey = (
  params?: ListBillableChargesApiV1ShipmentsBillableChargesGetParams
) => {
  return [
    `/api/v1/shipments/billable-charges`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListBillableChargesApiV1ShipmentsBillableChargesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListBillableChargesApiV1ShipmentsBillableChargesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listBillableChargesApiV1ShipmentsBillableChargesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListBillableChargesApiV1ShipmentsBillableChargesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
      >
    > = ({ signal }) =>
      listBillableChargesApiV1ShipmentsBillableChargesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListBillableChargesApiV1ShipmentsBillableChargesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
    >
  >;
export type ListBillableChargesApiV1ShipmentsBillableChargesGetQueryError =
  HTTPValidationError;

export function useListBillableChargesApiV1ShipmentsBillableChargesGet<
  TData = Awaited<
    ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListBillableChargesApiV1ShipmentsBillableChargesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listBillableChargesApiV1ShipmentsBillableChargesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listBillableChargesApiV1ShipmentsBillableChargesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListBillableChargesApiV1ShipmentsBillableChargesGet<
  TData = Awaited<
    ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListBillableChargesApiV1ShipmentsBillableChargesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listBillableChargesApiV1ShipmentsBillableChargesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listBillableChargesApiV1ShipmentsBillableChargesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListBillableChargesApiV1ShipmentsBillableChargesGet<
  TData = Awaited<
    ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListBillableChargesApiV1ShipmentsBillableChargesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Billable Charges
 */

export function useListBillableChargesApiV1ShipmentsBillableChargesGet<
  TData = Awaited<
    ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListBillableChargesApiV1ShipmentsBillableChargesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBillableChargesApiV1ShipmentsBillableChargesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListBillableChargesApiV1ShipmentsBillableChargesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Draft AP bill(s) from the selected (or all) un-billed buy charges of one
shipment, or a carrier invoice spanning several of one company's shipments. One
draft per distinct (vendor, buy currency). PO-less.
 * @summary Bill From Charges
 */
export const billFromChargesApiV1ShipmentsBillFromChargesPost = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/bill-from-charges`,
    method: 'POST',
    signal
  });
};

export const getBillFromChargesApiV1ShipmentsBillFromChargesPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof billFromChargesApiV1ShipmentsBillFromChargesPost>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof billFromChargesApiV1ShipmentsBillFromChargesPost>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ['billFromChargesApiV1ShipmentsBillFromChargesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof billFromChargesApiV1ShipmentsBillFromChargesPost>
      >,
      void
    > = () => {
      return billFromChargesApiV1ShipmentsBillFromChargesPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type BillFromChargesApiV1ShipmentsBillFromChargesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof billFromChargesApiV1ShipmentsBillFromChargesPost>>
  >;

export type BillFromChargesApiV1ShipmentsBillFromChargesPostMutationError =
  unknown;

/**
 * @summary Bill From Charges
 */
export const useBillFromChargesApiV1ShipmentsBillFromChargesPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof billFromChargesApiV1ShipmentsBillFromChargesPost>
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billFromChargesApiV1ShipmentsBillFromChargesPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getBillFromChargesApiV1ShipmentsBillFromChargesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get shipment with full details.

The document/milestone checklist is served by the dedicated
GET /{shipment_id}/checklist endpoint (the detail page fetches it
separately) — it is not embedded here to avoid re-querying the documents
and milestones already eager-loaded by get_shipment.
 * @summary Get Shipment
 */
export const getShipmentApiV1ShipmentsShipmentIdGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}`,
    method: 'GET',
    signal
  });
};

export const getGetShipmentApiV1ShipmentsShipmentIdGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}`] as const;
};

export const getGetShipmentApiV1ShipmentsShipmentIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetShipmentApiV1ShipmentsShipmentIdGetQueryKey(shipmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>
  > = ({ signal }) =>
    getShipmentApiV1ShipmentsShipmentIdGet(shipmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shipmentId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetShipmentApiV1ShipmentsShipmentIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>
>;
export type GetShipmentApiV1ShipmentsShipmentIdGetQueryError =
  HTTPValidationError;

export function useGetShipmentApiV1ShipmentsShipmentIdGet<
  TData = Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
          TError,
          Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetShipmentApiV1ShipmentsShipmentIdGet<
  TData = Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
          TError,
          Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetShipmentApiV1ShipmentsShipmentIdGet<
  TData = Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Shipment
 */

export function useGetShipmentApiV1ShipmentsShipmentIdGet<
  TData = Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getShipmentApiV1ShipmentsShipmentIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetShipmentApiV1ShipmentsShipmentIdGetQueryOptions(
    shipmentId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a shipment.
 * @summary Update Shipment
 */
export const updateShipmentApiV1ShipmentsShipmentIdPut = (
  shipmentId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}`,
    method: 'PUT'
  });
};

export const getUpdateShipmentApiV1ShipmentsShipmentIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateShipmentApiV1ShipmentsShipmentIdPut>>,
    TError,
    { shipmentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateShipmentApiV1ShipmentsShipmentIdPut>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationKey = ['updateShipmentApiV1ShipmentsShipmentIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateShipmentApiV1ShipmentsShipmentIdPut>>,
    { shipmentId: string }
  > = (props) => {
    const { shipmentId } = props ?? {};

    return updateShipmentApiV1ShipmentsShipmentIdPut(shipmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateShipmentApiV1ShipmentsShipmentIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateShipmentApiV1ShipmentsShipmentIdPut>>
  >;

export type UpdateShipmentApiV1ShipmentsShipmentIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Shipment
 */
export const useUpdateShipmentApiV1ShipmentsShipmentIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateShipmentApiV1ShipmentsShipmentIdPut>>,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateShipmentApiV1ShipmentsShipmentIdPut>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getUpdateShipmentApiV1ShipmentsShipmentIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft delete a shipment.
 * @summary Delete Shipment
 */
export const deleteShipmentApiV1ShipmentsShipmentIdDelete = (
  shipmentId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}`,
    method: 'DELETE'
  });
};

export const getDeleteShipmentApiV1ShipmentsShipmentIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteShipmentApiV1ShipmentsShipmentIdDelete>>,
    TError,
    { shipmentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteShipmentApiV1ShipmentsShipmentIdDelete>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationKey = ['deleteShipmentApiV1ShipmentsShipmentIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteShipmentApiV1ShipmentsShipmentIdDelete>>,
    { shipmentId: string }
  > = (props) => {
    const { shipmentId } = props ?? {};

    return deleteShipmentApiV1ShipmentsShipmentIdDelete(shipmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteShipmentApiV1ShipmentsShipmentIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteShipmentApiV1ShipmentsShipmentIdDelete>>
  >;

export type DeleteShipmentApiV1ShipmentsShipmentIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Shipment
 */
export const useDeleteShipmentApiV1ShipmentsShipmentIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteShipmentApiV1ShipmentsShipmentIdDelete>>,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteShipmentApiV1ShipmentsShipmentIdDelete>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteShipmentApiV1ShipmentsShipmentIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Transition shipment status.
 * @summary Transition Status
 */
export const transitionStatusApiV1ShipmentsShipmentIdStatusPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/status`,
    method: 'POST',
    signal
  });
};

export const getTransitionStatusApiV1ShipmentsShipmentIdStatusPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof transitionStatusApiV1ShipmentsShipmentIdStatusPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof transitionStatusApiV1ShipmentsShipmentIdStatusPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = ['transitionStatusApiV1ShipmentsShipmentIdStatusPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof transitionStatusApiV1ShipmentsShipmentIdStatusPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return transitionStatusApiV1ShipmentsShipmentIdStatusPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type TransitionStatusApiV1ShipmentsShipmentIdStatusPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof transitionStatusApiV1ShipmentsShipmentIdStatusPost>
    >
  >;

export type TransitionStatusApiV1ShipmentsShipmentIdStatusPostMutationError =
  HTTPValidationError;

/**
 * @summary Transition Status
 */
export const useTransitionStatusApiV1ShipmentsShipmentIdStatusPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof transitionStatusApiV1ShipmentsShipmentIdStatusPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof transitionStatusApiV1ShipmentsShipmentIdStatusPost>
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getTransitionStatusApiV1ShipmentsShipmentIdStatusPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List legs for a shipment.
 * @summary List Legs
 */
export const listLegsApiV1ShipmentsShipmentIdLegsGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/legs`,
    method: 'GET',
    signal
  });
};

export const getListLegsApiV1ShipmentsShipmentIdLegsGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/legs`] as const;
};

export const getListLegsApiV1ShipmentsShipmentIdLegsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListLegsApiV1ShipmentsShipmentIdLegsGetQueryKey(shipmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>
  > = ({ signal }) =>
    listLegsApiV1ShipmentsShipmentIdLegsGet(shipmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shipmentId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListLegsApiV1ShipmentsShipmentIdLegsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>
>;
export type ListLegsApiV1ShipmentsShipmentIdLegsGetQueryError =
  HTTPValidationError;

export function useListLegsApiV1ShipmentsShipmentIdLegsGet<
  TData = Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
          TError,
          Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLegsApiV1ShipmentsShipmentIdLegsGet<
  TData = Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
          TError,
          Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLegsApiV1ShipmentsShipmentIdLegsGet<
  TData = Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Legs
 */

export function useListLegsApiV1ShipmentsShipmentIdLegsGet<
  TData = Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listLegsApiV1ShipmentsShipmentIdLegsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListLegsApiV1ShipmentsShipmentIdLegsGetQueryOptions(
    shipmentId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a leg.
 * @summary Create Leg
 */
export const createLegApiV1ShipmentsShipmentIdLegsPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/legs`,
    method: 'POST',
    signal
  });
};

export const getCreateLegApiV1ShipmentsShipmentIdLegsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLegApiV1ShipmentsShipmentIdLegsPost>>,
    TError,
    { shipmentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLegApiV1ShipmentsShipmentIdLegsPost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationKey = ['createLegApiV1ShipmentsShipmentIdLegsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLegApiV1ShipmentsShipmentIdLegsPost>>,
    { shipmentId: string }
  > = (props) => {
    const { shipmentId } = props ?? {};

    return createLegApiV1ShipmentsShipmentIdLegsPost(shipmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLegApiV1ShipmentsShipmentIdLegsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createLegApiV1ShipmentsShipmentIdLegsPost>>
  >;

export type CreateLegApiV1ShipmentsShipmentIdLegsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Leg
 */
export const useCreateLegApiV1ShipmentsShipmentIdLegsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createLegApiV1ShipmentsShipmentIdLegsPost>>,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createLegApiV1ShipmentsShipmentIdLegsPost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getCreateLegApiV1ShipmentsShipmentIdLegsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a leg.
 * @summary Update Leg
 */
export const updateLegApiV1ShipmentsShipmentIdLegsLegIdPut = (
  shipmentId: string,
  legId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/legs/${legId}`,
    method: 'PUT'
  });
};

export const getUpdateLegApiV1ShipmentsShipmentIdLegsLegIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLegApiV1ShipmentsShipmentIdLegsLegIdPut>>,
    TError,
    { shipmentId: string; legId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLegApiV1ShipmentsShipmentIdLegsLegIdPut>>,
  TError,
  { shipmentId: string; legId: string },
  TContext
> => {
  const mutationKey = ['updateLegApiV1ShipmentsShipmentIdLegsLegIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLegApiV1ShipmentsShipmentIdLegsLegIdPut>>,
    { shipmentId: string; legId: string }
  > = (props) => {
    const { shipmentId, legId } = props ?? {};

    return updateLegApiV1ShipmentsShipmentIdLegsLegIdPut(shipmentId, legId);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLegApiV1ShipmentsShipmentIdLegsLegIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateLegApiV1ShipmentsShipmentIdLegsLegIdPut>>
  >;

export type UpdateLegApiV1ShipmentsShipmentIdLegsLegIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Leg
 */
export const useUpdateLegApiV1ShipmentsShipmentIdLegsLegIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateLegApiV1ShipmentsShipmentIdLegsLegIdPut>>,
      TError,
      { shipmentId: string; legId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateLegApiV1ShipmentsShipmentIdLegsLegIdPut>>,
  TError,
  { shipmentId: string; legId: string },
  TContext
> => {
  const mutationOptions =
    getUpdateLegApiV1ShipmentsShipmentIdLegsLegIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a leg.
 * @summary Delete Leg
 */
export const deleteLegApiV1ShipmentsShipmentIdLegsLegIdDelete = (
  shipmentId: string,
  legId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/legs/${legId}`,
    method: 'DELETE'
  });
};

export const getDeleteLegApiV1ShipmentsShipmentIdLegsLegIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteLegApiV1ShipmentsShipmentIdLegsLegIdDelete>
      >,
      TError,
      { shipmentId: string; legId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteLegApiV1ShipmentsShipmentIdLegsLegIdDelete>
    >,
    TError,
    { shipmentId: string; legId: string },
    TContext
  > => {
    const mutationKey = ['deleteLegApiV1ShipmentsShipmentIdLegsLegIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteLegApiV1ShipmentsShipmentIdLegsLegIdDelete>
      >,
      { shipmentId: string; legId: string }
    > = (props) => {
      const { shipmentId, legId } = props ?? {};

      return deleteLegApiV1ShipmentsShipmentIdLegsLegIdDelete(
        shipmentId,
        legId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteLegApiV1ShipmentsShipmentIdLegsLegIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteLegApiV1ShipmentsShipmentIdLegsLegIdDelete>>
  >;

export type DeleteLegApiV1ShipmentsShipmentIdLegsLegIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Leg
 */
export const useDeleteLegApiV1ShipmentsShipmentIdLegsLegIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteLegApiV1ShipmentsShipmentIdLegsLegIdDelete>
      >,
      TError,
      { shipmentId: string; legId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteLegApiV1ShipmentsShipmentIdLegsLegIdDelete>>,
  TError,
  { shipmentId: string; legId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteLegApiV1ShipmentsShipmentIdLegsLegIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List services for a shipment.
 * @summary List Services
 */
export const listServicesApiV1ShipmentsShipmentIdServicesGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/services`,
    method: 'GET',
    signal
  });
};

export const getListServicesApiV1ShipmentsShipmentIdServicesGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/services`] as const;
};

export const getListServicesApiV1ShipmentsShipmentIdServicesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListServicesApiV1ShipmentsShipmentIdServicesGetQueryKey(shipmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>>
  > = ({ signal }) =>
    listServicesApiV1ShipmentsShipmentIdServicesGet(shipmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shipmentId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListServicesApiV1ShipmentsShipmentIdServicesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>>
  >;
export type ListServicesApiV1ShipmentsShipmentIdServicesGetQueryError =
  HTTPValidationError;

export function useListServicesApiV1ShipmentsShipmentIdServicesGet<
  TData = Awaited<
    ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListServicesApiV1ShipmentsShipmentIdServicesGet<
  TData = Awaited<
    ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListServicesApiV1ShipmentsShipmentIdServicesGet<
  TData = Awaited<
    ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Services
 */

export function useListServicesApiV1ShipmentsShipmentIdServicesGet<
  TData = Awaited<
    ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listServicesApiV1ShipmentsShipmentIdServicesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListServicesApiV1ShipmentsShipmentIdServicesGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a service.
 * @summary Create Service
 */
export const createServiceApiV1ShipmentsShipmentIdServicesPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/services`,
    method: 'POST',
    signal
  });
};

export const getCreateServiceApiV1ShipmentsShipmentIdServicesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createServiceApiV1ShipmentsShipmentIdServicesPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createServiceApiV1ShipmentsShipmentIdServicesPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = ['createServiceApiV1ShipmentsShipmentIdServicesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createServiceApiV1ShipmentsShipmentIdServicesPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return createServiceApiV1ShipmentsShipmentIdServicesPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateServiceApiV1ShipmentsShipmentIdServicesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createServiceApiV1ShipmentsShipmentIdServicesPost>
    >
  >;

export type CreateServiceApiV1ShipmentsShipmentIdServicesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Service
 */
export const useCreateServiceApiV1ShipmentsShipmentIdServicesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createServiceApiV1ShipmentsShipmentIdServicesPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createServiceApiV1ShipmentsShipmentIdServicesPost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getCreateServiceApiV1ShipmentsShipmentIdServicesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a service.
 * @summary Delete Service
 */
export const deleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDelete = (
  shipmentId: string,
  serviceId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/services/${serviceId}`,
    method: 'DELETE'
  });
};

export const getDeleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDelete
        >
      >,
      TError,
      { shipmentId: string; serviceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDelete
      >
    >,
    TError,
    { shipmentId: string; serviceId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDelete
        >
      >,
      { shipmentId: string; serviceId: string }
    > = (props) => {
      const { shipmentId, serviceId } = props ?? {};

      return deleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDelete(
        shipmentId,
        serviceId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDelete
      >
    >
  >;

export type DeleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Service
 */
export const useDeleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDelete
        >
      >,
      TError,
      { shipmentId: string; serviceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDelete
    >
  >,
  TError,
  { shipmentId: string; serviceId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteServiceApiV1ShipmentsShipmentIdServicesServiceIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List cargo for a shipment.
 * @summary List Cargo
 */
export const listCargoApiV1ShipmentsShipmentIdCargoGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentCargoList>({
    url: `/api/v1/shipments/${shipmentId}/cargo`,
    method: 'GET',
    signal
  });
};

export const getListCargoApiV1ShipmentsShipmentIdCargoGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/cargo`] as const;
};

export const getListCargoApiV1ShipmentsShipmentIdCargoGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCargoApiV1ShipmentsShipmentIdCargoGetQueryKey(shipmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>
  > = ({ signal }) =>
    listCargoApiV1ShipmentsShipmentIdCargoGet(shipmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shipmentId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListCargoApiV1ShipmentsShipmentIdCargoGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>
>;
export type ListCargoApiV1ShipmentsShipmentIdCargoGetQueryError =
  HTTPValidationError;

export function useListCargoApiV1ShipmentsShipmentIdCargoGet<
  TData = Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
          TError,
          Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCargoApiV1ShipmentsShipmentIdCargoGet<
  TData = Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
          TError,
          Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCargoApiV1ShipmentsShipmentIdCargoGet<
  TData = Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Cargo
 */

export function useListCargoApiV1ShipmentsShipmentIdCargoGet<
  TData = Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCargoApiV1ShipmentsShipmentIdCargoGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListCargoApiV1ShipmentsShipmentIdCargoGetQueryOptions(
    shipmentId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create cargo.
 * @summary Create Cargo
 */
export const createCargoApiV1ShipmentsShipmentIdCargoPost = (
  shipmentId: string,
  shipmentCargoCreate: ShipmentCargoCreate,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentCargo>({
    url: `/api/v1/shipments/${shipmentId}/cargo`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shipmentCargoCreate,
    signal
  });
};

export const getCreateCargoApiV1ShipmentsShipmentIdCargoPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCargoApiV1ShipmentsShipmentIdCargoPost>>,
    TError,
    { shipmentId: string; data: ShipmentCargoCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCargoApiV1ShipmentsShipmentIdCargoPost>>,
  TError,
  { shipmentId: string; data: ShipmentCargoCreate },
  TContext
> => {
  const mutationKey = ['createCargoApiV1ShipmentsShipmentIdCargoPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCargoApiV1ShipmentsShipmentIdCargoPost>>,
    { shipmentId: string; data: ShipmentCargoCreate }
  > = (props) => {
    const { shipmentId, data } = props ?? {};

    return createCargoApiV1ShipmentsShipmentIdCargoPost(shipmentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCargoApiV1ShipmentsShipmentIdCargoPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createCargoApiV1ShipmentsShipmentIdCargoPost>>
  >;
export type CreateCargoApiV1ShipmentsShipmentIdCargoPostMutationBody =
  ShipmentCargoCreate;
export type CreateCargoApiV1ShipmentsShipmentIdCargoPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Cargo
 */
export const useCreateCargoApiV1ShipmentsShipmentIdCargoPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCargoApiV1ShipmentsShipmentIdCargoPost>>,
      TError,
      { shipmentId: string; data: ShipmentCargoCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCargoApiV1ShipmentsShipmentIdCargoPost>>,
  TError,
  { shipmentId: string; data: ShipmentCargoCreate },
  TContext
> => {
  const mutationOptions =
    getCreateCargoApiV1ShipmentsShipmentIdCargoPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update cargo.
 * @summary Update Cargo
 */
export const updateCargoApiV1ShipmentsShipmentIdCargoCargoIdPut = (
  shipmentId: string,
  cargoId: string,
  shipmentCargoUpdate: ShipmentCargoUpdate
) => {
  return customInstance<ShipmentCargo>({
    url: `/api/v1/shipments/${shipmentId}/cargo/${cargoId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: shipmentCargoUpdate
  });
};

export const getUpdateCargoApiV1ShipmentsShipmentIdCargoCargoIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateCargoApiV1ShipmentsShipmentIdCargoCargoIdPut>
      >,
      TError,
      { shipmentId: string; cargoId: string; data: ShipmentCargoUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateCargoApiV1ShipmentsShipmentIdCargoCargoIdPut>
    >,
    TError,
    { shipmentId: string; cargoId: string; data: ShipmentCargoUpdate },
    TContext
  > => {
    const mutationKey = ['updateCargoApiV1ShipmentsShipmentIdCargoCargoIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateCargoApiV1ShipmentsShipmentIdCargoCargoIdPut>
      >,
      { shipmentId: string; cargoId: string; data: ShipmentCargoUpdate }
    > = (props) => {
      const { shipmentId, cargoId, data } = props ?? {};

      return updateCargoApiV1ShipmentsShipmentIdCargoCargoIdPut(
        shipmentId,
        cargoId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateCargoApiV1ShipmentsShipmentIdCargoCargoIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateCargoApiV1ShipmentsShipmentIdCargoCargoIdPut>
    >
  >;
export type UpdateCargoApiV1ShipmentsShipmentIdCargoCargoIdPutMutationBody =
  ShipmentCargoUpdate;
export type UpdateCargoApiV1ShipmentsShipmentIdCargoCargoIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Cargo
 */
export const useUpdateCargoApiV1ShipmentsShipmentIdCargoCargoIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateCargoApiV1ShipmentsShipmentIdCargoCargoIdPut>
      >,
      TError,
      { shipmentId: string; cargoId: string; data: ShipmentCargoUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateCargoApiV1ShipmentsShipmentIdCargoCargoIdPut>
  >,
  TError,
  { shipmentId: string; cargoId: string; data: ShipmentCargoUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateCargoApiV1ShipmentsShipmentIdCargoCargoIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete cargo.
 * @summary Delete Cargo
 */
export const deleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDelete = (
  shipmentId: string,
  cargoId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/cargo/${cargoId}`,
    method: 'DELETE'
  });
};

export const getDeleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDelete>
      >,
      TError,
      { shipmentId: string; cargoId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDelete>
    >,
    TError,
    { shipmentId: string; cargoId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDelete>
      >,
      { shipmentId: string; cargoId: string }
    > = (props) => {
      const { shipmentId, cargoId } = props ?? {};

      return deleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDelete(
        shipmentId,
        cargoId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDelete>
    >
  >;

export type DeleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Cargo
 */
export const useDeleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDelete>
      >,
      TError,
      { shipmentId: string; cargoId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDelete>
  >,
  TError,
  { shipmentId: string; cargoId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteCargoApiV1ShipmentsShipmentIdCargoCargoIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Pull ONE specific unit out of a cargo row (decrementing a count row),
optionally naming its container number.
 * @summary Enumerate Cargo Unit
 */
export const enumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePost =
  (
    shipmentId: string,
    cargoId: string,
    shipmentCargoEnumerate: ShipmentCargoEnumerate,
    signal?: AbortSignal
  ) => {
    return customInstance<ShipmentCargo>({
      url: `/api/v1/shipments/${shipmentId}/cargo/${cargoId}/enumerate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: shipmentCargoEnumerate,
      signal
    });
  };

export const getEnumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof enumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePost
        >
      >,
      TError,
      { shipmentId: string; cargoId: string; data: ShipmentCargoEnumerate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof enumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePost
      >
    >,
    TError,
    { shipmentId: string; cargoId: string; data: ShipmentCargoEnumerate },
    TContext
  > => {
    const mutationKey = [
      'enumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof enumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePost
        >
      >,
      { shipmentId: string; cargoId: string; data: ShipmentCargoEnumerate }
    > = (props) => {
      const { shipmentId, cargoId, data } = props ?? {};

      return enumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePost(
        shipmentId,
        cargoId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EnumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof enumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePost
      >
    >
  >;
export type EnumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePostMutationBody =
  ShipmentCargoEnumerate;
export type EnumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePostMutationError =
  HTTPValidationError;

/**
 * @summary Enumerate Cargo Unit
 */
export const useEnumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof enumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePost
          >
        >,
        TError,
        { shipmentId: string; cargoId: string; data: ShipmentCargoEnumerate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof enumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePost
      >
    >,
    TError,
    { shipmentId: string; cargoId: string; data: ShipmentCargoEnumerate },
    TContext
  > => {
    const mutationOptions =
      getEnumerateCargoUnitApiV1ShipmentsShipmentIdCargoCargoIdEnumeratePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Every contents link on the shipment, in one round trip.

The stuffing editor asks a per-LINE question — how much of this line is not
in a container yet — whose answer spans every unit, so a per-unit fetch would
cost one request per container to answer it.
 * @summary List Shipment Cargo Contents
 */
export const listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<ShipmentCargoContentsLinkList>({
      url: `/api/v1/shipments/${shipmentId}/cargo-contents`,
      method: 'GET',
      signal
    });
  };

export const getListShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/cargo-contents`] as const;
  };

export const getListShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
        >
      >
    > = ({ signal }) =>
      listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
      >
    >
  >;
export type ListShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGetQueryError =
  HTTPValidationError;

export function useListShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet<
  TData = Awaited<
    ReturnType<
      typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet<
  TData = Awaited<
    ReturnType<
      typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet<
  TData = Awaited<
    ReturnType<
      typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Shipment Cargo Contents
 */

export function useListShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet<
  TData = Awaited<
    ReturnType<
      typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListShipmentCargoContentsApiV1ShipmentsShipmentIdCargoContentsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Contents links of one load unit (bounded by its parent record).
 * @summary List Cargo Contents
 */
export const listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet =
  (shipmentId: string, cargoId: string, signal?: AbortSignal) => {
    return customInstance<ShipmentCargoContentsLinkList>({
      url: `/api/v1/shipments/${shipmentId}/cargo/${cargoId}/contents`,
      method: 'GET',
      signal
    });
  };

export const getListCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGetQueryKey =
  (shipmentId?: string, cargoId?: string) => {
    return [
      `/api/v1/shipments/${shipmentId}/cargo/${cargoId}/contents`
    ] as const;
  };

export const getListCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    cargoId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGetQueryKey(
        shipmentId,
        cargoId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
        >
      >
    > = ({ signal }) =>
      listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet(
        shipmentId,
        cargoId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(shipmentId && cargoId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
      >
    >
  >;
export type ListCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGetQueryError =
  HTTPValidationError;

export function useListCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet<
  TData = Awaited<
    ReturnType<
      typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  cargoId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet<
  TData = Awaited<
    ReturnType<
      typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  cargoId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet<
  TData = Awaited<
    ReturnType<
      typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  cargoId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Cargo Contents
 */

export function useListCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet<
  TData = Awaited<
    ReturnType<
      typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  cargoId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCargoContentsApiV1ShipmentsShipmentIdCargoCargoIdContentsGetQueryOptions(
      shipmentId,
      cargoId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Link a portion of a shipment line into this specific load unit.

Element-scoped on purpose (sibling-containers precedent): two ops users
editing one unit's contents must not discard each other's rows.
 * @summary Add Cargo Contents Link
 */
export const addCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPost =
  (
    shipmentId: string,
    cargoId: string,
    shipmentCargoContentsLinkCreate: ShipmentCargoContentsLinkCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<ShipmentCargoContentsLink>({
      url: `/api/v1/shipments/${shipmentId}/cargo/${cargoId}/contents`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: shipmentCargoContentsLinkCreate,
      signal
    });
  };

export const getAddCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPost
        >
      >,
      TError,
      {
        shipmentId: string;
        cargoId: string;
        data: ShipmentCargoContentsLinkCreate;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPost
      >
    >,
    TError,
    {
      shipmentId: string;
      cargoId: string;
      data: ShipmentCargoContentsLinkCreate;
    },
    TContext
  > => {
    const mutationKey = [
      'addCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPost
        >
      >,
      {
        shipmentId: string;
        cargoId: string;
        data: ShipmentCargoContentsLinkCreate;
      }
    > = (props) => {
      const { shipmentId, cargoId, data } = props ?? {};

      return addCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPost(
        shipmentId,
        cargoId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPost
      >
    >
  >;
export type AddCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPostMutationBody =
  ShipmentCargoContentsLinkCreate;
export type AddCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Cargo Contents Link
 */
export const useAddCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPost
          >
        >,
        TError,
        {
          shipmentId: string;
          cargoId: string;
          data: ShipmentCargoContentsLinkCreate;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPost
      >
    >,
    TError,
    {
      shipmentId: string;
      cargoId: string;
      data: ShipmentCargoContentsLinkCreate;
    },
    TContext
  > => {
    const mutationOptions =
      getAddCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Patch one contents link (quantity stays within the line's own quantity).
 * @summary Update Cargo Contents Link
 */
export const updateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPut =
  (
    shipmentId: string,
    cargoId: string,
    linkId: string,
    shipmentCargoContentsLinkUpdate: ShipmentCargoContentsLinkUpdate
  ) => {
    return customInstance<ShipmentCargoContentsLink>({
      url: `/api/v1/shipments/${shipmentId}/cargo/${cargoId}/contents/${linkId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: shipmentCargoContentsLinkUpdate
    });
  };

export const getUpdateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPut
        >
      >,
      TError,
      {
        shipmentId: string;
        cargoId: string;
        linkId: string;
        data: ShipmentCargoContentsLinkUpdate;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPut
      >
    >,
    TError,
    {
      shipmentId: string;
      cargoId: string;
      linkId: string;
      data: ShipmentCargoContentsLinkUpdate;
    },
    TContext
  > => {
    const mutationKey = [
      'updateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPut
        >
      >,
      {
        shipmentId: string;
        cargoId: string;
        linkId: string;
        data: ShipmentCargoContentsLinkUpdate;
      }
    > = (props) => {
      const { shipmentId, cargoId, linkId, data } = props ?? {};

      return updateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPut(
        shipmentId,
        cargoId,
        linkId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPut
      >
    >
  >;
export type UpdateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPutMutationBody =
  ShipmentCargoContentsLinkUpdate;
export type UpdateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Cargo Contents Link
 */
export const useUpdateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPut
          >
        >,
        TError,
        {
          shipmentId: string;
          cargoId: string;
          linkId: string;
          data: ShipmentCargoContentsLinkUpdate;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPut
      >
    >,
    TError,
    {
      shipmentId: string;
      cargoId: string;
      linkId: string;
      data: ShipmentCargoContentsLinkUpdate;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove one contents link (the line and the unit both survive).
 * @summary Remove Cargo Contents Link
 */
export const removeCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDelete =
  (shipmentId: string, cargoId: string, linkId: string) => {
    return customInstance<ShipmentCargoContentsLinkDeleteResult>({
      url: `/api/v1/shipments/${shipmentId}/cargo/${cargoId}/contents/${linkId}`,
      method: 'DELETE'
    });
  };

export const getRemoveCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDelete
        >
      >,
      TError,
      { shipmentId: string; cargoId: string; linkId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDelete
      >
    >,
    TError,
    { shipmentId: string; cargoId: string; linkId: string },
    TContext
  > => {
    const mutationKey = [
      'removeCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDelete
        >
      >,
      { shipmentId: string; cargoId: string; linkId: string }
    > = (props) => {
      const { shipmentId, cargoId, linkId } = props ?? {};

      return removeCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDelete(
        shipmentId,
        cargoId,
        linkId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDelete
      >
    >
  >;

export type RemoveCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Cargo Contents Link
 */
export const useRemoveCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDelete
          >
        >,
        TError,
        { shipmentId: string; cargoId: string; linkId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDelete
      >
    >,
    TError,
    { shipmentId: string; cargoId: string; linkId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveCargoContentsLinkApiV1ShipmentsShipmentIdCargoCargoIdContentsLinkIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List line items for a shipment.
 * @summary List Line Items
 */
export const listLineItemsApiV1ShipmentsShipmentIdLineItemsGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentLineItemList>({
    url: `/api/v1/shipments/${shipmentId}/line-items`,
    method: 'GET',
    signal
  });
};

export const getListLineItemsApiV1ShipmentsShipmentIdLineItemsGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/line-items`] as const;
};

export const getListLineItemsApiV1ShipmentsShipmentIdLineItemsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListLineItemsApiV1ShipmentsShipmentIdLineItemsGetQueryKey(shipmentId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
      >
    > = ({ signal }) =>
      listLineItemsApiV1ShipmentsShipmentIdLineItemsGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListLineItemsApiV1ShipmentsShipmentIdLineItemsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
    >
  >;
export type ListLineItemsApiV1ShipmentsShipmentIdLineItemsGetQueryError =
  HTTPValidationError;

export function useListLineItemsApiV1ShipmentsShipmentIdLineItemsGet<
  TData = Awaited<
    ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListLineItemsApiV1ShipmentsShipmentIdLineItemsGet<
  TData = Awaited<
    ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListLineItemsApiV1ShipmentsShipmentIdLineItemsGet<
  TData = Awaited<
    ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Line Items
 */

export function useListLineItemsApiV1ShipmentsShipmentIdLineItemsGet<
  TData = Awaited<
    ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listLineItemsApiV1ShipmentsShipmentIdLineItemsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListLineItemsApiV1ShipmentsShipmentIdLineItemsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a line item.
 * @summary Create Line Item
 */
export const createLineItemApiV1ShipmentsShipmentIdLineItemsPost = (
  shipmentId: string,
  shipmentLineItemCreate: ShipmentLineItemCreate,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentLineItem>({
    url: `/api/v1/shipments/${shipmentId}/line-items`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shipmentLineItemCreate,
    signal
  });
};

export const getCreateLineItemApiV1ShipmentsShipmentIdLineItemsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createLineItemApiV1ShipmentsShipmentIdLineItemsPost>
      >,
      TError,
      { shipmentId: string; data: ShipmentLineItemCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createLineItemApiV1ShipmentsShipmentIdLineItemsPost>
    >,
    TError,
    { shipmentId: string; data: ShipmentLineItemCreate },
    TContext
  > => {
    const mutationKey = ['createLineItemApiV1ShipmentsShipmentIdLineItemsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createLineItemApiV1ShipmentsShipmentIdLineItemsPost>
      >,
      { shipmentId: string; data: ShipmentLineItemCreate }
    > = (props) => {
      const { shipmentId, data } = props ?? {};

      return createLineItemApiV1ShipmentsShipmentIdLineItemsPost(
        shipmentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateLineItemApiV1ShipmentsShipmentIdLineItemsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createLineItemApiV1ShipmentsShipmentIdLineItemsPost>
    >
  >;
export type CreateLineItemApiV1ShipmentsShipmentIdLineItemsPostMutationBody =
  ShipmentLineItemCreate;
export type CreateLineItemApiV1ShipmentsShipmentIdLineItemsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Line Item
 */
export const useCreateLineItemApiV1ShipmentsShipmentIdLineItemsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createLineItemApiV1ShipmentsShipmentIdLineItemsPost>
      >,
      TError,
      { shipmentId: string; data: ShipmentLineItemCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createLineItemApiV1ShipmentsShipmentIdLineItemsPost>
  >,
  TError,
  { shipmentId: string; data: ShipmentLineItemCreate },
  TContext
> => {
  const mutationOptions =
    getCreateLineItemApiV1ShipmentsShipmentIdLineItemsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a line item.
 * @summary Update Line Item
 */
export const updateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPut = (
  shipmentId: string,
  lineItemId: string,
  shipmentLineItemUpdate: ShipmentLineItemUpdate
) => {
  return customInstance<ShipmentLineItem>({
    url: `/api/v1/shipments/${shipmentId}/line-items/${lineItemId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: shipmentLineItemUpdate
  });
};

export const getUpdateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPut
        >
      >,
      TError,
      { shipmentId: string; lineItemId: string; data: ShipmentLineItemUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPut
      >
    >,
    TError,
    { shipmentId: string; lineItemId: string; data: ShipmentLineItemUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPut
        >
      >,
      { shipmentId: string; lineItemId: string; data: ShipmentLineItemUpdate }
    > = (props) => {
      const { shipmentId, lineItemId, data } = props ?? {};

      return updateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPut(
        shipmentId,
        lineItemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPut
      >
    >
  >;
export type UpdateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPutMutationBody =
  ShipmentLineItemUpdate;
export type UpdateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Line Item
 */
export const useUpdateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPut
        >
      >,
      TError,
      { shipmentId: string; lineItemId: string; data: ShipmentLineItemUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPut
    >
  >,
  TError,
  { shipmentId: string; lineItemId: string; data: ShipmentLineItemUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a line item.
 * @summary Delete Line Item
 */
export const deleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDelete = (
  shipmentId: string,
  lineItemId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/line-items/${lineItemId}`,
    method: 'DELETE'
  });
};

export const getDeleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDelete
        >
      >,
      TError,
      { shipmentId: string; lineItemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDelete
      >
    >,
    TError,
    { shipmentId: string; lineItemId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDelete
        >
      >,
      { shipmentId: string; lineItemId: string }
    > = (props) => {
      const { shipmentId, lineItemId } = props ?? {};

      return deleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDelete(
        shipmentId,
        lineItemId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDelete
      >
    >
  >;

export type DeleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Line Item
 */
export const useDeleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDelete
          >
        >,
        TError,
        { shipmentId: string; lineItemId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDelete
      >
    >,
    TError,
    { shipmentId: string; lineItemId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteLineItemApiV1ShipmentsShipmentIdLineItemsLineItemIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List parties for a shipment, with resolved organization/contact names.
 * @summary List Parties
 */
export const listPartiesApiV1ShipmentsShipmentIdPartiesGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/parties`,
    method: 'GET',
    signal
  });
};

export const getListPartiesApiV1ShipmentsShipmentIdPartiesGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/parties`] as const;
};

export const getListPartiesApiV1ShipmentsShipmentIdPartiesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListPartiesApiV1ShipmentsShipmentIdPartiesGetQueryKey(shipmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>>
  > = ({ signal }) =>
    listPartiesApiV1ShipmentsShipmentIdPartiesGet(shipmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shipmentId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListPartiesApiV1ShipmentsShipmentIdPartiesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>>
  >;
export type ListPartiesApiV1ShipmentsShipmentIdPartiesGetQueryError =
  HTTPValidationError;

export function useListPartiesApiV1ShipmentsShipmentIdPartiesGet<
  TData = Awaited<
    ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPartiesApiV1ShipmentsShipmentIdPartiesGet<
  TData = Awaited<
    ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPartiesApiV1ShipmentsShipmentIdPartiesGet<
  TData = Awaited<
    ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Parties
 */

export function useListPartiesApiV1ShipmentsShipmentIdPartiesGet<
  TData = Awaited<
    ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listPartiesApiV1ShipmentsShipmentIdPartiesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListPartiesApiV1ShipmentsShipmentIdPartiesGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a party.

The body is bound as a TYPED parameter rather than read off a raw ``Request``:
`check_link_route_far_side.py` inspects a handler's Pydantic body model, so a
`data: dict` / `await request.json()` route has no fields for it to see and its
governed ids are invisible to the gate. Typing it brings this route INTO the gate
(the checker's own `GENERATED REQUEST MODELS` section), which is why it is
preferred here over the `# typed-surface-ok:` untyped-body escape.
 * @summary Create Party
 */
export const createPartyApiV1ShipmentsShipmentIdPartiesPost = (
  shipmentId: string,
  shipmentPartyCreate: ShipmentPartyCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/parties`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shipmentPartyCreate,
    signal
  });
};

export const getCreatePartyApiV1ShipmentsShipmentIdPartiesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createPartyApiV1ShipmentsShipmentIdPartiesPost>
      >,
      TError,
      { shipmentId: string; data: ShipmentPartyCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof createPartyApiV1ShipmentsShipmentIdPartiesPost>>,
    TError,
    { shipmentId: string; data: ShipmentPartyCreate },
    TContext
  > => {
    const mutationKey = ['createPartyApiV1ShipmentsShipmentIdPartiesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createPartyApiV1ShipmentsShipmentIdPartiesPost>
      >,
      { shipmentId: string; data: ShipmentPartyCreate }
    > = (props) => {
      const { shipmentId, data } = props ?? {};

      return createPartyApiV1ShipmentsShipmentIdPartiesPost(shipmentId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreatePartyApiV1ShipmentsShipmentIdPartiesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createPartyApiV1ShipmentsShipmentIdPartiesPost>>
  >;
export type CreatePartyApiV1ShipmentsShipmentIdPartiesPostMutationBody =
  ShipmentPartyCreate;
export type CreatePartyApiV1ShipmentsShipmentIdPartiesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Party
 */
export const useCreatePartyApiV1ShipmentsShipmentIdPartiesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createPartyApiV1ShipmentsShipmentIdPartiesPost>
      >,
      TError,
      { shipmentId: string; data: ShipmentPartyCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPartyApiV1ShipmentsShipmentIdPartiesPost>>,
  TError,
  { shipmentId: string; data: ShipmentPartyCreate },
  TContext
> => {
  const mutationOptions =
    getCreatePartyApiV1ShipmentsShipmentIdPartiesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a party.
 * @summary Delete Party
 */
export const deletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDelete = (
  shipmentId: string,
  partyId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/parties/${partyId}`,
    method: 'DELETE'
  });
};

export const getDeletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDelete
        >
      >,
      TError,
      { shipmentId: string; partyId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDelete>
    >,
    TError,
    { shipmentId: string; partyId: string },
    TContext
  > => {
    const mutationKey = [
      'deletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDelete
        >
      >,
      { shipmentId: string; partyId: string }
    > = (props) => {
      const { shipmentId, partyId } = props ?? {};

      return deletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDelete(
        shipmentId,
        partyId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDelete>
    >
  >;

export type DeletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Party
 */
export const useDeletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDelete
        >
      >,
      TError,
      { shipmentId: string; partyId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDelete>
  >,
  TError,
  { shipmentId: string; partyId: string },
  TContext
> => {
  const mutationOptions =
    getDeletePartyApiV1ShipmentsShipmentIdPartiesPartyIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List references for a shipment.
 * @summary List References
 */
export const listReferencesApiV1ShipmentsShipmentIdReferencesGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/references`,
    method: 'GET',
    signal
  });
};

export const getListReferencesApiV1ShipmentsShipmentIdReferencesGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/references`] as const;
};

export const getListReferencesApiV1ShipmentsShipmentIdReferencesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListReferencesApiV1ShipmentsShipmentIdReferencesGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
      >
    > = ({ signal }) =>
      listReferencesApiV1ShipmentsShipmentIdReferencesGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListReferencesApiV1ShipmentsShipmentIdReferencesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
    >
  >;
export type ListReferencesApiV1ShipmentsShipmentIdReferencesGetQueryError =
  HTTPValidationError;

export function useListReferencesApiV1ShipmentsShipmentIdReferencesGet<
  TData = Awaited<
    ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListReferencesApiV1ShipmentsShipmentIdReferencesGet<
  TData = Awaited<
    ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListReferencesApiV1ShipmentsShipmentIdReferencesGet<
  TData = Awaited<
    ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List References
 */

export function useListReferencesApiV1ShipmentsShipmentIdReferencesGet<
  TData = Awaited<
    ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listReferencesApiV1ShipmentsShipmentIdReferencesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListReferencesApiV1ShipmentsShipmentIdReferencesGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a reference.
 * @summary Create Reference
 */
export const createReferenceApiV1ShipmentsShipmentIdReferencesPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/references`,
    method: 'POST',
    signal
  });
};

export const getCreateReferenceApiV1ShipmentsShipmentIdReferencesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createReferenceApiV1ShipmentsShipmentIdReferencesPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createReferenceApiV1ShipmentsShipmentIdReferencesPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'createReferenceApiV1ShipmentsShipmentIdReferencesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createReferenceApiV1ShipmentsShipmentIdReferencesPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return createReferenceApiV1ShipmentsShipmentIdReferencesPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateReferenceApiV1ShipmentsShipmentIdReferencesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createReferenceApiV1ShipmentsShipmentIdReferencesPost>
    >
  >;

export type CreateReferenceApiV1ShipmentsShipmentIdReferencesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Reference
 */
export const useCreateReferenceApiV1ShipmentsShipmentIdReferencesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createReferenceApiV1ShipmentsShipmentIdReferencesPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createReferenceApiV1ShipmentsShipmentIdReferencesPost>
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getCreateReferenceApiV1ShipmentsShipmentIdReferencesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a reference.
 * @summary Delete Reference
 */
export const deleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDelete =
  (shipmentId: string, referenceId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/references/${referenceId}`,
      method: 'DELETE'
    });
  };

export const getDeleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDelete
        >
      >,
      TError,
      { shipmentId: string; referenceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDelete
      >
    >,
    TError,
    { shipmentId: string; referenceId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDelete
        >
      >,
      { shipmentId: string; referenceId: string }
    > = (props) => {
      const { shipmentId, referenceId } = props ?? {};

      return deleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDelete(
        shipmentId,
        referenceId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDelete
      >
    >
  >;

export type DeleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Reference
 */
export const useDeleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDelete
          >
        >,
        TError,
        { shipmentId: string; referenceId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDelete
      >
    >,
    TError,
    { shipmentId: string; referenceId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteReferenceApiV1ShipmentsShipmentIdReferencesReferenceIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List assignees for a shipment.
 * @summary List Assignees
 */
export const listAssigneesApiV1ShipmentsShipmentIdAssigneesGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/assignees`,
    method: 'GET',
    signal
  });
};

export const getListAssigneesApiV1ShipmentsShipmentIdAssigneesGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/assignees`] as const;
};

export const getListAssigneesApiV1ShipmentsShipmentIdAssigneesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListAssigneesApiV1ShipmentsShipmentIdAssigneesGetQueryKey(shipmentId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
      >
    > = ({ signal }) =>
      listAssigneesApiV1ShipmentsShipmentIdAssigneesGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListAssigneesApiV1ShipmentsShipmentIdAssigneesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
    >
  >;
export type ListAssigneesApiV1ShipmentsShipmentIdAssigneesGetQueryError =
  HTTPValidationError;

export function useListAssigneesApiV1ShipmentsShipmentIdAssigneesGet<
  TData = Awaited<
    ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAssigneesApiV1ShipmentsShipmentIdAssigneesGet<
  TData = Awaited<
    ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAssigneesApiV1ShipmentsShipmentIdAssigneesGet<
  TData = Awaited<
    ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Assignees
 */

export function useListAssigneesApiV1ShipmentsShipmentIdAssigneesGet<
  TData = Awaited<
    ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAssigneesApiV1ShipmentsShipmentIdAssigneesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAssigneesApiV1ShipmentsShipmentIdAssigneesGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create an assignee.
 * @summary Create Assignee
 */
export const createAssigneeApiV1ShipmentsShipmentIdAssigneesPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/assignees`,
    method: 'POST',
    signal
  });
};

export const getCreateAssigneeApiV1ShipmentsShipmentIdAssigneesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createAssigneeApiV1ShipmentsShipmentIdAssigneesPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createAssigneeApiV1ShipmentsShipmentIdAssigneesPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = ['createAssigneeApiV1ShipmentsShipmentIdAssigneesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createAssigneeApiV1ShipmentsShipmentIdAssigneesPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return createAssigneeApiV1ShipmentsShipmentIdAssigneesPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateAssigneeApiV1ShipmentsShipmentIdAssigneesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createAssigneeApiV1ShipmentsShipmentIdAssigneesPost>
    >
  >;

export type CreateAssigneeApiV1ShipmentsShipmentIdAssigneesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Assignee
 */
export const useCreateAssigneeApiV1ShipmentsShipmentIdAssigneesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createAssigneeApiV1ShipmentsShipmentIdAssigneesPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createAssigneeApiV1ShipmentsShipmentIdAssigneesPost>
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getCreateAssigneeApiV1ShipmentsShipmentIdAssigneesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete an assignee.
 * @summary Delete Assignee
 */
export const deleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDelete = (
  shipmentId: string,
  assigneeId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/assignees/${assigneeId}`,
    method: 'DELETE'
  });
};

export const getDeleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDelete
        >
      >,
      TError,
      { shipmentId: string; assigneeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDelete
      >
    >,
    TError,
    { shipmentId: string; assigneeId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDelete
        >
      >,
      { shipmentId: string; assigneeId: string }
    > = (props) => {
      const { shipmentId, assigneeId } = props ?? {};

      return deleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDelete(
        shipmentId,
        assigneeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDelete
      >
    >
  >;

export type DeleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Assignee
 */
export const useDeleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDelete
          >
        >,
        TError,
        { shipmentId: string; assigneeId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDelete
      >
    >,
    TError,
    { shipmentId: string; assigneeId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteAssigneeApiV1ShipmentsShipmentIdAssigneesAssigneeIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List documents for a shipment.

Each row carries its attachment summary (`attached_file_id`,
`attached_file_count`) — the same projection the `/checklist` response's
documents carry, so the two cannot disagree about whether a document has a
file behind it.
 * @summary List Documents
 */
export const listDocumentsApiV1ShipmentsShipmentIdDocumentsGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/documents`,
    method: 'GET',
    signal
  });
};

export const getListDocumentsApiV1ShipmentsShipmentIdDocumentsGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/documents`] as const;
};

export const getListDocumentsApiV1ShipmentsShipmentIdDocumentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDocumentsApiV1ShipmentsShipmentIdDocumentsGetQueryKey(shipmentId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
      >
    > = ({ signal }) =>
      listDocumentsApiV1ShipmentsShipmentIdDocumentsGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDocumentsApiV1ShipmentsShipmentIdDocumentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
    >
  >;
export type ListDocumentsApiV1ShipmentsShipmentIdDocumentsGetQueryError =
  HTTPValidationError;

export function useListDocumentsApiV1ShipmentsShipmentIdDocumentsGet<
  TData = Awaited<
    ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDocumentsApiV1ShipmentsShipmentIdDocumentsGet<
  TData = Awaited<
    ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDocumentsApiV1ShipmentsShipmentIdDocumentsGet<
  TData = Awaited<
    ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Documents
 */

export function useListDocumentsApiV1ShipmentsShipmentIdDocumentsGet<
  TData = Awaited<
    ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDocumentsApiV1ShipmentsShipmentIdDocumentsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDocumentsApiV1ShipmentsShipmentIdDocumentsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a document.
 * @summary Create Document
 */
export const createDocumentApiV1ShipmentsShipmentIdDocumentsPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/documents`,
    method: 'POST',
    signal
  });
};

export const getCreateDocumentApiV1ShipmentsShipmentIdDocumentsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createDocumentApiV1ShipmentsShipmentIdDocumentsPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createDocumentApiV1ShipmentsShipmentIdDocumentsPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = ['createDocumentApiV1ShipmentsShipmentIdDocumentsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createDocumentApiV1ShipmentsShipmentIdDocumentsPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return createDocumentApiV1ShipmentsShipmentIdDocumentsPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDocumentApiV1ShipmentsShipmentIdDocumentsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createDocumentApiV1ShipmentsShipmentIdDocumentsPost>
    >
  >;

export type CreateDocumentApiV1ShipmentsShipmentIdDocumentsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Document
 */
export const useCreateDocumentApiV1ShipmentsShipmentIdDocumentsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createDocumentApiV1ShipmentsShipmentIdDocumentsPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createDocumentApiV1ShipmentsShipmentIdDocumentsPost>
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getCreateDocumentApiV1ShipmentsShipmentIdDocumentsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Docs Agent v1 (F3): queue an uploaded shipping document for extraction into
draft-first AI intake items.

Body: ``{ "file_id": <uuid>, "document_type"?: <intent>,
"confirm_duplicate"?: bool }`` — a file already uploaded/attached to this
shipment. When ``document_type`` is omitted the model classifies it. Each
extracted document lands as ``proposed`` for human review with per-field
confidences and any cross-validation flags; nothing is applied to the shipment
until it is approved.

A drop whose exact bytes this extractor has already read is HELD with
``DOCUMENT_ALREADY_EXTRACTED`` (409) naming where the earlier result is waiting,
rather than silently re-paying for the model; ``confirm_duplicate: true``
re-posts past it for a genuinely re-sent document.

Returns the QUEUED parse job immediately; the segmentation and per-document
extraction run in a background task and the client watches the job through
``GET .../documents/parse-jobs``. It used to run inline, which capped one drop
at whatever fitted in the 60s gateway and left the rest for the operator to
resume by hand. Validation of the drop itself (shipment, file, format) still
happens here, so a bad file is still rejected synchronously and specifically.
 * @summary Extract Document
 */
export const extractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentDocumentParseJob>({
    url: `/api/v1/shipments/${shipmentId}/documents/extract`,
    method: 'POST',
    signal
  });
};

export const getExtractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof extractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof extractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'extractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof extractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return extractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExtractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof extractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPost
      >
    >
  >;

export type ExtractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPostMutationError =
  HTTPValidationError;

/**
 * @summary Extract Document
 */
export const useExtractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof extractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof extractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPost
    >
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getExtractDocumentApiV1ShipmentsShipmentIdDocumentsExtractPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Progress of the background parse jobs for the given dropped files — or, with
``file_ids`` omitted, this shipment's recent parse-job HISTORY.

The drop panel polls this while any job is unsettled, which is how each
extracted document appears on its own row as it lands rather than all at once
when the whole file finishes. It also asks WITHOUT ids when it mounts, which is
what lets the panel resume: the ids live in component state and do not survive a
remount, so before the history arm a drop that failed while the operator was on
the phone was unreachable the moment they navigated away — the row was in the
table, with the filename and the uploader on it, and no route could ask for it
(TKT-00189). ``?file_ids=`` (empty) is still an empty poll, not a history read.

Reached through the shipments router, so it inherits the router-level
``enforce_shipment_route_access`` ReBAC gate (VIEWER on ``{shipment_id}``), and
the query is additionally scoped to that same shipment on BOTH arms — the gate
keys on the PATH shipment, so without that predicate VIEWER on any one job would
expose the parse progress of a bundle filed against a job the caller cannot see.
The history arm drops only the file-id filter, which the gate never rested on.

Batched by id set rather than one request per file: this is on a 2-second timer
and a per-file round trip would be an N+1 against it. The history arm is bounded
by ``PARSE_JOB_HISTORY_LIMIT`` for the same reason — a long-lived job file
accumulates a job per document anyone ever dropped on it.
 * @summary List Document Parse Jobs
 */
export const listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet =
  (
    shipmentId: string,
    params?: ListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<ShipmentDocumentParseJob[]>({
      url: `/api/v1/shipments/${shipmentId}/documents/parse-jobs`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetQueryKey =
  (
    shipmentId?: string,
    params?: ListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetParams
  ) => {
    return [
      `/api/v1/shipments/${shipmentId}/documents/parse-jobs`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    params?: ListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetQueryKey(
        shipmentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
        >
      >
    > = ({ signal }) =>
      listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet(
        shipmentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
      >
    >
  >;
export type ListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetQueryError =
  HTTPValidationError;

export function useListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params:
    | undefined
    | ListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Document Parse Jobs
 */

export function useListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDocumentParseJobsApiV1ShipmentsShipmentIdDocumentsParseJobsGetQueryOptions(
      shipmentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * This job file's browsable UPLOAD-ATTEMPT history: one page of its parse jobs,
newest first, with the unpaginated ``total``.

The route above answers a fixed recent WINDOW (``PARSE_JOB_HISTORY_LIMIT`` = 25),
which is what the drop panel resumes from and all it should ever render — its
density budget is spent. This is the surface behind it, because
``shp_document_parse_jobs`` accumulates a row per distinct file ever dropped here
and nothing deletes them: past 25 documents an older FAILED attempt fell out of
the window, and no other surface in the app lists parse jobs, so it was
unreachable from the UI again — TKT-00189's end state reached by overflow rather
than by component-state loss.

Server-paged (Shape A — these accumulate): explicit ``limit``/``offset``, no
``resolve_limit``, and the order carries an id tiebreak so a far offset cannot
repeat or skip the very row being hunted.

Reached through the shipments router, so it inherits the router-level
``enforce_shipment_route_access`` ReBAC gate (VIEWER on ``{shipment_id}``), and
the query is additionally scoped to that same shipment on EVERY page — paging is
not a place that predicate may be relaxed, which
``tests/integration/shipments/test_document_parse_job_scoping_pg.py`` pins at a
far offset.
 * @summary List Document Parse Job History
 */
export const listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet =
  (
    shipmentId: string,
    params?: ListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<ShipmentDocumentParseJobList>({
      url: `/api/v1/shipments/${shipmentId}/documents/parse-jobs/history`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetQueryKey =
  (
    shipmentId?: string,
    params?: ListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetParams
  ) => {
    return [
      `/api/v1/shipments/${shipmentId}/documents/parse-jobs/history`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    params?: ListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetQueryKey(
        shipmentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
        >
      >
    > = ({ signal }) =>
      listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet(
        shipmentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
      >
    >
  >;
export type ListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetQueryError =
  HTTPValidationError;

export function useListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params:
    | undefined
    | ListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Document Parse Job History
 */

export function useListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDocumentParseJobHistoryApiV1ShipmentsShipmentIdDocumentsParseJobsHistoryGetQueryOptions(
      shipmentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Re-extract only the parts of this drop the model could not read.

A pack whose parse leaves parts unread used to offer nothing but a re-drop, and a
re-drop uploads the same bytes as a NEW file: a new job, the whole file
re-segmented, and every part re-extracted — so "Awaiting review" gained a second
copy of every document that had already worked, each a metered model call the
reviewer then had to reject by hand. This re-extracts the unread parts alone,
against the file already stored, and updates their rows in place.

Reached through the shipments router, so it inherits
``enforce_shipment_route_access`` — a POST, so EDITOR on ``{shipment_id}``, which
is the right floor: a retry lands new ``proposed`` intake items against this job.
The query is additionally scoped to that same shipment, so EDITOR on any one job
cannot drive a parse filed against a job the caller cannot see.

Refuses (409) a job still extracting — which is also what makes a double-click
idempotent — or one with nothing unread. Parts lost during PLANNING (a span past
the tracked-part cap, a page range that would not slice) never became a part row
and are not retryable; a re-drop remains their remedy.
 * @summary Retry Document Parse Job
 */
export const retryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPost =
  (shipmentId: string, jobId: string, signal?: AbortSignal) => {
    return customInstance<ShipmentDocumentParseJob>({
      url: `/api/v1/shipments/${shipmentId}/documents/parse-jobs/${jobId}/retry`,
      method: 'POST',
      signal
    });
  };

export const getRetryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof retryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPost
        >
      >,
      TError,
      { shipmentId: string; jobId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof retryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPost
      >
    >,
    TError,
    { shipmentId: string; jobId: string },
    TContext
  > => {
    const mutationKey = [
      'retryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof retryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPost
        >
      >,
      { shipmentId: string; jobId: string }
    > = (props) => {
      const { shipmentId, jobId } = props ?? {};

      return retryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPost(
        shipmentId,
        jobId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RetryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof retryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPost
      >
    >
  >;

export type RetryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPostMutationError =
  HTTPValidationError;

/**
 * @summary Retry Document Parse Job
 */
export const useRetryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof retryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPost
          >
        >,
        TError,
        { shipmentId: string; jobId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof retryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPost
      >
    >,
    TError,
    { shipmentId: string; jobId: string },
    TContext
  > => {
    const mutationOptions =
      getRetryDocumentParseJobApiV1ShipmentsShipmentIdDocumentsParseJobsJobIdRetryPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Job-file-scoped AI document-intake queue: this shipment's uploaded documents
the Docs Agent extracted but a human has not yet approved.

Reached through the shipments router, so it inherits the router-level
``enforce_shipment_route_access`` ReBAC gate (VIEWER on ``{shipment_id}``) —
unlike the ungated shared ``/ai-intake/items``. That gate is why per-entity
scoping lives here and not on the shared route: a user denied access to this
shipment must not be able to read its extracted document content.
 * @summary List Document Intake Items
 */
export const listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet =
  (
    shipmentId: string,
    params?: ListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/intake-items`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetQueryKey =
  (
    shipmentId?: string,
    params?: ListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetParams
  ) => {
    return [
      `/api/v1/shipments/${shipmentId}/documents/intake-items`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    params?: ListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetQueryKey(
        shipmentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
        >
      >
    > = ({ signal }) =>
      listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet(
        shipmentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
      >
    >
  >;
export type ListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetQueryError =
  HTTPValidationError;

export function useListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params:
    | undefined
    | ListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Document Intake Items
 */

export function useListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDocumentIntakeItemsApiV1ShipmentsShipmentIdDocumentsIntakeItemsGetQueryOptions(
      shipmentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The pages one unrecognised document occupies, so the operator can SEE what they
are being asked about.

Cut from the stored bundle on the fly — no per-span file is stored anywhere (see
``ShipmentDocumentIntakeService.read_triage_document`` for why that is the shared
framework's ruling and not a shortcut).

Gated at VIEWER on ``{shipment_id}`` by the router-level Contract-D dependency,
like every other document read here. Served ``Content-Disposition: attachment`` with
``X-Content-Type-Options: nosniff`` and an inline-safe content type: the triage
dialog fetches this as a blob and renders it from an object URL, so a hostile
document must never be able to execute in the app's origin.
 * @summary Preview Document Triage Item
 */
export const previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet =
  (shipmentId: string, itemId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/triage/${itemId}/preview`,
      method: 'GET',
      signal
    });
  };

export const getPreviewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGetQueryKey =
  (shipmentId?: string, itemId?: string) => {
    return [
      `/api/v1/shipments/${shipmentId}/documents/triage/${itemId}/preview`
    ] as const;
  };

export const getPreviewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    itemId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getPreviewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGetQueryKey(
        shipmentId,
        itemId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
        >
      >
    > = ({ signal }) =>
      previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet(
        shipmentId,
        itemId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(shipmentId && itemId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type PreviewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
      >
    >
  >;
export type PreviewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGetQueryError =
  HTTPValidationError;

export function usePreviewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function usePreviewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePreviewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Preview Document Triage Item
 */

export function usePreviewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getPreviewDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPreviewGetQueryOptions(
      shipmentId,
      itemId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Answer one unrecognised document: file it, keep it as an attachment, or stop
asking.

A POST, so the router-level gate resolves EDITOR on ``{shipment_id}`` rather than
VIEWER — reading what the Docs Agent could not type and DECIDING what it is are
different acts, and only the second changes the file.

None of the three deletes anything. The uploaded bundle may hold several other
documents, and on a single-document drop it IS the operator's own upload with the
parse job cascading onto it, so "discard" means "stop asking me about this" and the
file stays in the Files tab where deleting it is a deliberate, separate act.
 * @summary Resolve Document Triage Item
 */
export const resolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPost =
  (
    shipmentId: string,
    itemId: string,
    shipmentDocumentTriageResolve: ShipmentDocumentTriageResolve,
    signal?: AbortSignal
  ) => {
    return customInstance<AiIntakeItem>({
      url: `/api/v1/shipments/${shipmentId}/documents/triage/${itemId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: shipmentDocumentTriageResolve,
      signal
    });
  };

export const getResolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPost
        >
      >,
      TError,
      {
        shipmentId: string;
        itemId: string;
        data: ShipmentDocumentTriageResolve;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPost
      >
    >,
    TError,
    { shipmentId: string; itemId: string; data: ShipmentDocumentTriageResolve },
    TContext
  > => {
    const mutationKey = [
      'resolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPost
        >
      >,
      {
        shipmentId: string;
        itemId: string;
        data: ShipmentDocumentTriageResolve;
      }
    > = (props) => {
      const { shipmentId, itemId, data } = props ?? {};

      return resolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPost(
        shipmentId,
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPost
      >
    >
  >;
export type ResolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPostMutationBody =
  ShipmentDocumentTriageResolve;
export type ResolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Resolve Document Triage Item
 */
export const useResolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPost
          >
        >,
        TError,
        {
          shipmentId: string;
          itemId: string;
          data: ShipmentDocumentTriageResolve;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPost
      >
    >,
    TError,
    { shipmentId: string; itemId: string; data: ShipmentDocumentTriageResolve },
    TContext
  > => {
    const mutationOptions =
      getResolveDocumentTriageItemApiV1ShipmentsShipmentIdDocumentsTriageItemIdPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Update a document.
 * @summary Update Document
 */
export const updateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPut = (
  shipmentId: string,
  documentId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/documents/${documentId}`,
    method: 'PUT'
  });
};

export const getUpdateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPut
        >
      >,
      TError,
      { shipmentId: string; documentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPut
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationKey = [
      'updateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPut
        >
      >,
      { shipmentId: string; documentId: string }
    > = (props) => {
      const { shipmentId, documentId } = props ?? {};

      return updateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPut(
        shipmentId,
        documentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPut
      >
    >
  >;

export type UpdateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Document
 */
export const useUpdateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPut
        >
      >,
      TError,
      { shipmentId: string; documentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPut
    >
  >,
  TError,
  { shipmentId: string; documentId: string },
  TContext
> => {
  const mutationOptions =
    getUpdateDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a document.
 * @summary Delete Document
 */
export const deleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDelete = (
  shipmentId: string,
  documentId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/documents/${documentId}`,
    method: 'DELETE'
  });
};

export const getDeleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDelete
        >
      >,
      TError,
      { shipmentId: string; documentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDelete
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDelete
        >
      >,
      { shipmentId: string; documentId: string }
    > = (props) => {
      const { shipmentId, documentId } = props ?? {};

      return deleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDelete(
        shipmentId,
        documentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDelete
      >
    >
  >;

export type DeleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Document
 */
export const useDeleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDelete
          >
        >,
        TError,
        { shipmentId: string; documentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDelete
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Move a document along its lifecycle state machine (validated transition).
 * @summary Transition Document
 */
export const transitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPost =
  (shipmentId: string, documentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/transition`,
      method: 'POST',
      signal
    });
  };

export const getTransitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof transitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPost
        >
      >,
      TError,
      { shipmentId: string; documentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof transitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPost
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationKey = [
      'transitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof transitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPost
        >
      >,
      { shipmentId: string; documentId: string }
    > = (props) => {
      const { shipmentId, documentId } = props ?? {};

      return transitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPost(
        shipmentId,
        documentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TransitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof transitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPost
      >
    >
  >;

export type TransitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPostMutationError =
  HTTPValidationError;

/**
 * @summary Transition Document
 */
export const useTransitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof transitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPost
          >
        >,
        TError,
        { shipmentId: string; documentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof transitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPost
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationOptions =
      getTransitionDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdTransitionPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The release-control state of the file's governing house bill (or null).
 * @summary Get Shipment Bl Release
 */
export const getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/bl-release`,
    method: 'GET',
    signal
  });
};

export const getGetShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/bl-release`] as const;
  };

export const getGetShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
        >
      >
    > = ({ signal }) =>
      getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
      >
    >
  >;
export type GetShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGetQueryError =
  HTTPValidationError;

export function useGetShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet<
  TData = Awaited<
    ReturnType<typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet<
  TData = Awaited<
    ReturnType<typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet<
  TData = Awaited<
    ReturnType<typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Shipment Bl Release
 */

export function useGetShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet<
  TData = Awaited<
    ReturnType<typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetShipmentBlReleaseApiV1ShipmentsShipmentIdBlReleaseGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The B/L release-control state of a transport document + its transition trail.
 * @summary Get Document Release State
 */
export const getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet =
  (shipmentId: string, documentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/release`,
      method: 'GET',
      signal
    });
  };

export const getGetDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGetQueryKey =
  (shipmentId?: string, documentId?: string) => {
    return [
      `/api/v1/shipments/${shipmentId}/documents/${documentId}/release`
    ] as const;
  };

export const getGetDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    documentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGetQueryKey(
        shipmentId,
        documentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
        >
      >
    > = ({ signal }) =>
      getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet(
        shipmentId,
        documentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(shipmentId && documentId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
      >
    >
  >;
export type GetDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGetQueryError =
  HTTPValidationError;

export function useGetDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet<
  TData = Awaited<
    ReturnType<
      typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet<
  TData = Awaited<
    ReturnType<
      typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet<
  TData = Awaited<
    ReturnType<
      typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Document Release State
 */

export function useGetDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet<
  TData = Awaited<
    ReturnType<
      typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDocumentReleaseStateApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseGetQueryOptions(
      shipmentId,
      documentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Advance a transport document's B/L release-control state machine by one step.

On reaching ``release_authorized`` the destination agent named on the file is
notified via the SHIPMENT_BL_RELEASE_AUTHORIZED event (published post-commit).
 * @summary Transition Document Release
 */
export const transitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPost =
  (shipmentId: string, documentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/release/transition`,
      method: 'POST',
      signal
    });
  };

export const getTransitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof transitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPost
        >
      >,
      TError,
      { shipmentId: string; documentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof transitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPost
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationKey = [
      'transitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof transitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPost
        >
      >,
      { shipmentId: string; documentId: string }
    > = (props) => {
      const { shipmentId, documentId } = props ?? {};

      return transitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPost(
        shipmentId,
        documentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TransitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof transitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPost
      >
    >
  >;

export type TransitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPostMutationError =
  HTTPValidationError;

/**
 * @summary Transition Document Release
 */
export const useTransitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof transitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPost
          >
        >,
        TError,
        { shipmentId: string; documentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof transitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPost
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationOptions =
      getTransitionDocumentReleaseApiV1ShipmentsShipmentIdDocumentsDocumentIdReleaseTransitionPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Re-issue a document (version++); optionally substitute parties (switch bill).

Prior versions — including the parties named on them — stay retrievable via
version history (GET /api/v1/versions/shp_shipment_documents/{id}).
 * @summary Reissue Document
 */
export const reissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePost =
  (shipmentId: string, documentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/reissue`,
      method: 'POST',
      signal
    });
  };

export const getReissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePost
        >
      >,
      TError,
      { shipmentId: string; documentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePost
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationKey = [
      'reissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePost
        >
      >,
      { shipmentId: string; documentId: string }
    > = (props) => {
      const { shipmentId, documentId } = props ?? {};

      return reissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePost(
        shipmentId,
        documentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePost
      >
    >
  >;

export type ReissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePostMutationError =
  HTTPValidationError;

/**
 * @summary Reissue Document
 */
export const useReissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePost
          >
        >,
        TError,
        { shipmentId: string; documentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePost
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationOptions =
      getReissueDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdReissuePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Clear a diversion's reissue-required mark WITHOUT re-issuing the document.

Only the four house/master transport documents are ours to re-issue; an
arrival notice, a delivery order, a customs entry and an ISF are issued by a
carrier, a broker or an authority. Without this the mark would be permanent
on seven of the eleven flagged types.
 * @summary Resolve Document Reissue Required
 */
export const resolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePost =
  (shipmentId: string, documentId: string, signal?: AbortSignal) => {
    return customInstance<ShipmentDocumentReissueResolution>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/reissue-required/resolve`,
      method: 'POST',
      signal
    });
  };

export const getResolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePost
        >
      >,
      TError,
      { shipmentId: string; documentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePost
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationKey = [
      'resolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePost
        >
      >,
      { shipmentId: string; documentId: string }
    > = (props) => {
      const { shipmentId, documentId } = props ?? {};

      return resolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePost(
        shipmentId,
        documentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePost
      >
    >
  >;

export type ResolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePostMutationError =
  HTTPValidationError;

/**
 * @summary Resolve Document Reissue Required
 */
export const useResolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePost
          >
        >,
        TError,
        { shipmentId: string; documentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePost
      >
    >,
    TError,
    { shipmentId: string; documentId: string },
    TContext
  > => {
    const mutationOptions =
      getResolveDocumentReissueRequiredApiV1ShipmentsShipmentIdDocumentsDocumentIdReissueRequiredResolvePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Branded quotation PDF for a QUOTATION document.

Prices are the shipment's manually entered sell-side charge lines — there is
NO rate computation (non-compete guardrail; see quotation_pdf_service.py).
 * @summary Get Quotation Pdf
 */
export const getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet =
  (
    shipmentId: string,
    documentId: string,
    params?: GetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/quotation/pdf`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetQueryKey =
  (
    shipmentId?: string,
    documentId?: string,
    params?: GetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetParams
  ) => {
    return [
      `/api/v1/shipments/${shipmentId}/documents/${documentId}/quotation/pdf`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    documentId: string,
    params?: GetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetQueryKey(
        shipmentId,
        documentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
        >
      >
    > = ({ signal }) =>
      getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet(
        shipmentId,
        documentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(shipmentId && documentId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
      >
    >
  >;
export type GetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetQueryError =
  HTTPValidationError;

export function useGetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params:
    | undefined
    | GetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Quotation Pdf
 */

export function useGetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetQuotationPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPdfGetQueryOptions(
      shipmentId,
      documentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Branded quotation preview HTML (for in-browser rendering).
 * @summary Get Quotation Preview
 */
export const getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet =
  (
    shipmentId: string,
    documentId: string,
    params?: GetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/quotation/preview`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetQueryKey =
  (
    shipmentId?: string,
    documentId?: string,
    params?: GetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetParams
  ) => {
    return [
      `/api/v1/shipments/${shipmentId}/documents/${documentId}/quotation/preview`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    documentId: string,
    params?: GetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetQueryKey(
        shipmentId,
        documentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
        >
      >
    > = ({ signal }) =>
      getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet(
        shipmentId,
        documentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(shipmentId && documentId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
      >
    >
  >;
export type GetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetQueryError =
  HTTPValidationError;

export function useGetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params:
    | undefined
    | GetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Quotation Preview
 */

export function useGetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetQuotationPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationPreviewGetQueryOptions(
      shipmentId,
      documentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Email the branded quotation PDF to the shipment's customer.

Renders the existing branded quotation PDF (no rate logic — see
``QuotationPdfService``) and sends it through the unified outbound seam
(``OutboundDeliveryService``): the user's connected mailbox when mailbox-send
is enabled, otherwise the platform ESP. Either way an ``outbound_emails`` row
is recorded against ``entity_ref=("shipment", shipment_id)``.

The recipient defaults to the customer organization's first business email;
``to_email`` / ``cc_emails`` in the body override it.
 * @summary Email Quotation
 */
export const emailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPost =
  (
    shipmentId: string,
    documentId: string,
    shipmentQuotationEmailRequest: ShipmentQuotationEmailRequest,
    params?: EmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/quotation/email`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: shipmentQuotationEmailRequest,
      params,
      signal
    });
  };

export const getEmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof emailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPost
        >
      >,
      TError,
      {
        shipmentId: string;
        documentId: string;
        data: ShipmentQuotationEmailRequest;
        params?: EmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof emailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPost
      >
    >,
    TError,
    {
      shipmentId: string;
      documentId: string;
      data: ShipmentQuotationEmailRequest;
      params?: EmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      'emailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof emailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPost
        >
      >,
      {
        shipmentId: string;
        documentId: string;
        data: ShipmentQuotationEmailRequest;
        params?: EmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostParams;
      }
    > = (props) => {
      const { shipmentId, documentId, data, params } = props ?? {};

      return emailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPost(
        shipmentId,
        documentId,
        data,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof emailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPost
      >
    >
  >;
export type EmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostMutationBody =
  ShipmentQuotationEmailRequest;
export type EmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostMutationError =
  HTTPValidationError;

/**
 * @summary Email Quotation
 */
export const useEmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof emailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPost
          >
        >,
        TError,
        {
          shipmentId: string;
          documentId: string;
          data: ShipmentQuotationEmailRequest;
          params?: EmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostParams;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof emailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPost
      >
    >,
    TError,
    {
      shipmentId: string;
      documentId: string;
      data: ShipmentQuotationEmailRequest;
      params?: EmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostParams;
    },
    TContext
  > => {
    const mutationOptions =
      getEmailQuotationApiV1ShipmentsShipmentIdDocumentsDocumentIdQuotationEmailPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Branded freight-document PDF (HBL/HAWB/arrival notice/delivery order).

House BLs/AWBs are forwarder-only — a shipper-only tenant gets a 404 (the
document type is invisible, mirroring ``require_forwarder_mode``). Arrival
notices and delivery orders are available to both personas. The generated
PDF is also retained via file_management, attached to the document.
 * @summary Get Freight Document Pdf
 */
export const getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet =
  (
    shipmentId: string,
    documentId: string,
    params?: GetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/freight/pdf`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetQueryKey =
  (
    shipmentId?: string,
    documentId?: string,
    params?: GetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetParams
  ) => {
    return [
      `/api/v1/shipments/${shipmentId}/documents/${documentId}/freight/pdf`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    documentId: string,
    params?: GetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetQueryKey(
        shipmentId,
        documentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
        >
      >
    > = ({ signal }) =>
      getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet(
        shipmentId,
        documentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(shipmentId && documentId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
      >
    >
  >;
export type GetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetQueryError =
  HTTPValidationError;

export function useGetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params:
    | undefined
    | GetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Freight Document Pdf
 */

export function useGetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetFreightDocumentPdfApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPdfGetQueryOptions(
      shipmentId,
      documentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Branded freight-document preview HTML (for in-browser rendering).
 * @summary Get Freight Document Preview
 */
export const getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet =
  (
    shipmentId: string,
    documentId: string,
    params?: GetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/freight/preview`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetQueryKey =
  (
    shipmentId?: string,
    documentId?: string,
    params?: GetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetParams
  ) => {
    return [
      `/api/v1/shipments/${shipmentId}/documents/${documentId}/freight/preview`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    documentId: string,
    params?: GetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetQueryKey(
        shipmentId,
        documentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
        >
      >
    > = ({ signal }) =>
      getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet(
        shipmentId,
        documentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(shipmentId && documentId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
      >
    >
  >;
export type GetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetQueryError =
  HTTPValidationError;

export function useGetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params:
    | undefined
    | GetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Freight Document Preview
 */

export function useGetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  documentId: string,
  params?: GetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetFreightDocumentPreviewApiV1ShipmentsShipmentIdDocumentsDocumentIdFreightPreviewGetQueryOptions(
      shipmentId,
      documentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Whether the shipment's delivery order may be released, and the per-condition
reasons if not (customs release + house-bill surrender per its release type).

Forwarder-only (issuing a delivery order is a forwarder-mode action). Powers
the UI that blocks the dispatch action and explains the block.
 * @summary Get Delivery Order Release Status
 */
export const getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/delivery-order/release-status`,
      method: 'GET',
      signal
    });
  };

export const getGetDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGetQueryKey =
  (shipmentId?: string) => {
    return [
      `/api/v1/shipments/${shipmentId}/delivery-order/release-status`
    ] as const;
  };

export const getGetDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
        >
      >
    > = ({ signal }) =>
      getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
      >
    >
  >;
export type GetDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGetQueryError =
  HTTPValidationError;

export function useGetDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Delivery Order Release Status
 */

export function useGetDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet<
  TData = Awaited<
    ReturnType<
      typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDeliveryOrderReleaseStatusApiV1ShipmentsShipmentIdDeliveryOrderReleaseStatusGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate-and-dispatch an arrival notice / delivery order in one action.

Renders the branded PDF, advances the document draft/approved -> issued,
emails it to the consignee/notify party (``to_email`` overrides), and records
``sent_at`` — ticking the checklist requirement. A DELIVERY_ORDER is gated on
release conditions: an un-releasable order returns 400
``SHIPMENT_DELIVERY_ORDER_NOT_RELEASABLE`` with the unmet conditions in
``details``. Forwarder-only (404 for shipper-only tenants).
 * @summary Dispatch Document
 */
export const dispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPost =
  (
    shipmentId: string,
    documentId: string,
    shipmentDocumentDispatchRequest: ShipmentDocumentDispatchRequest,
    params?: DispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/documents/${documentId}/dispatch`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: shipmentDocumentDispatchRequest,
      params,
      signal
    });
  };

export const getDispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof dispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPost
        >
      >,
      TError,
      {
        shipmentId: string;
        documentId: string;
        data: ShipmentDocumentDispatchRequest;
        params?: DispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof dispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPost
      >
    >,
    TError,
    {
      shipmentId: string;
      documentId: string;
      data: ShipmentDocumentDispatchRequest;
      params?: DispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      'dispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof dispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPost
        >
      >,
      {
        shipmentId: string;
        documentId: string;
        data: ShipmentDocumentDispatchRequest;
        params?: DispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostParams;
      }
    > = (props) => {
      const { shipmentId, documentId, data, params } = props ?? {};

      return dispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPost(
        shipmentId,
        documentId,
        data,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof dispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPost
      >
    >
  >;
export type DispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostMutationBody =
  ShipmentDocumentDispatchRequest;
export type DispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostMutationError =
  HTTPValidationError;

/**
 * @summary Dispatch Document
 */
export const useDispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof dispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPost
          >
        >,
        TError,
        {
          shipmentId: string;
          documentId: string;
          data: ShipmentDocumentDispatchRequest;
          params?: DispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostParams;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof dispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPost
      >
    >,
    TError,
    {
      shipmentId: string;
      documentId: string;
      data: ShipmentDocumentDispatchRequest;
      params?: DispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostParams;
    },
    TContext
  > => {
    const mutationOptions =
      getDispatchDocumentApiV1ShipmentsShipmentIdDocumentsDocumentIdDispatchPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The shipment's checklist: expected documents, template milestones, active
template code, the suggested one, and completion percent.

The derived commerce direction is resolved here (it comes from the sibling
order modules' junctions — see ``ShipmentService.get_direction``) and handed
to the service so the suggested lane matches what a re-evaluation would pick,
rather than the direction-blind guess made at creation time.
 * @summary Get Shipment Checklist
 */
export const getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/checklist`,
    method: 'GET',
    signal
  });
};

export const getGetShipmentChecklistApiV1ShipmentsShipmentIdChecklistGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/checklist`] as const;
  };

export const getGetShipmentChecklistApiV1ShipmentsShipmentIdChecklistGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetShipmentChecklistApiV1ShipmentsShipmentIdChecklistGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
        >
      >
    > = ({ signal }) =>
      getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetShipmentChecklistApiV1ShipmentsShipmentIdChecklistGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
      >
    >
  >;
export type GetShipmentChecklistApiV1ShipmentsShipmentIdChecklistGetQueryError =
  HTTPValidationError;

export function useGetShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet<
  TData = Awaited<
    ReturnType<typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet<
  TData = Awaited<
    ReturnType<typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet<
  TData = Awaited<
    ReturnType<typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Shipment Checklist
 */

export function useGetShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet<
  TData = Awaited<
    ReturnType<typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentChecklistApiV1ShipmentsShipmentIdChecklistGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetShipmentChecklistApiV1ShipmentsShipmentIdChecklistGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Apply (or re-apply) a checklist template, letting a tenant override the
auto-suggested one.

A SWAP, not a union: the previous plan's untouched placeholders are retired
and its touched documents demoted to ad-hoc, so the file is on exactly one
plan and the completion percentage stops counting a lane it no longer runs.
``template_code: "NONE"`` clears the plan instead.
 * @summary Apply Shipment Checklist
 */
export const applyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPost =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/checklist/apply`,
      method: 'POST',
      signal
    });
  };

export const getApplyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof applyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof applyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'applyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof applyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return applyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApplyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof applyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPost
      >
    >
  >;

export type ApplyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPostMutationError =
  HTTPValidationError;

/**
 * @summary Apply Shipment Checklist
 */
export const useApplyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof applyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPost
          >
        >,
        TError,
        { shipmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof applyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationOptions =
      getApplyShipmentChecklistApiV1ShipmentsShipmentIdChecklistApplyPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Re-pick the checklist template now that the shipment's commerce direction
is known. Called by the client after a PO/SO link is created or removed (the
link establishes the derived direction) — additively applies the best-matching
(mode x direction x border x regime) template, so e.g. an inbound import
upgrades from a generic checklist to "Ocean Import". Idempotent. Returns the
refreshed checklist (or the existing one when nothing better matches).
 * @summary Reevaluate Shipment Checklist
 */
export const reevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePost =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/checklist/reevaluate`,
      method: 'POST',
      signal
    });
  };

export const getReevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'reevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return reevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePost
      >
    >
  >;

export type ReevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePostMutationError =
  HTTPValidationError;

/**
 * @summary Reevaluate Shipment Checklist
 */
export const useReevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePost
          >
        >,
        TError,
        { shipmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationOptions =
      getReevaluateShipmentChecklistApiV1ShipmentsShipmentIdChecklistReevaluatePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List charges for a shipment.
 * @summary List Charges
 */
export const listChargesApiV1ShipmentsShipmentIdChargesGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentChargeList>({
    url: `/api/v1/shipments/${shipmentId}/charges`,
    method: 'GET',
    signal
  });
};

export const getListChargesApiV1ShipmentsShipmentIdChargesGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/charges`] as const;
};

export const getListChargesApiV1ShipmentsShipmentIdChargesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListChargesApiV1ShipmentsShipmentIdChargesGetQueryKey(shipmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>>
  > = ({ signal }) =>
    listChargesApiV1ShipmentsShipmentIdChargesGet(shipmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shipmentId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListChargesApiV1ShipmentsShipmentIdChargesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>>
  >;
export type ListChargesApiV1ShipmentsShipmentIdChargesGetQueryError =
  HTTPValidationError;

export function useListChargesApiV1ShipmentsShipmentIdChargesGet<
  TData = Awaited<
    ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListChargesApiV1ShipmentsShipmentIdChargesGet<
  TData = Awaited<
    ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListChargesApiV1ShipmentsShipmentIdChargesGet<
  TData = Awaited<
    ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Charges
 */

export function useListChargesApiV1ShipmentsShipmentIdChargesGet<
  TData = Awaited<
    ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listChargesApiV1ShipmentsShipmentIdChargesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListChargesApiV1ShipmentsShipmentIdChargesGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a charge.
 * @summary Create Charge
 */
export const createChargeApiV1ShipmentsShipmentIdChargesPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentCharge>({
    url: `/api/v1/shipments/${shipmentId}/charges`,
    method: 'POST',
    signal
  });
};

export const getCreateChargeApiV1ShipmentsShipmentIdChargesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createChargeApiV1ShipmentsShipmentIdChargesPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof createChargeApiV1ShipmentsShipmentIdChargesPost>>,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = ['createChargeApiV1ShipmentsShipmentIdChargesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createChargeApiV1ShipmentsShipmentIdChargesPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return createChargeApiV1ShipmentsShipmentIdChargesPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateChargeApiV1ShipmentsShipmentIdChargesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createChargeApiV1ShipmentsShipmentIdChargesPost>>
  >;

export type CreateChargeApiV1ShipmentsShipmentIdChargesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Charge
 */
export const useCreateChargeApiV1ShipmentsShipmentIdChargesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createChargeApiV1ShipmentsShipmentIdChargesPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createChargeApiV1ShipmentsShipmentIdChargesPost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getCreateChargeApiV1ShipmentsShipmentIdChargesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a charge (partial — only provided fields are applied).
 * @summary Update Charge
 */
export const updateChargeApiV1ShipmentsShipmentIdChargesChargeIdPut = (
  shipmentId: string,
  chargeId: string
) => {
  return customInstance<ShipmentCharge>({
    url: `/api/v1/shipments/${shipmentId}/charges/${chargeId}`,
    method: 'PUT'
  });
};

export const getUpdateChargeApiV1ShipmentsShipmentIdChargesChargeIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateChargeApiV1ShipmentsShipmentIdChargesChargeIdPut
        >
      >,
      TError,
      { shipmentId: string; chargeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateChargeApiV1ShipmentsShipmentIdChargesChargeIdPut>
    >,
    TError,
    { shipmentId: string; chargeId: string },
    TContext
  > => {
    const mutationKey = [
      'updateChargeApiV1ShipmentsShipmentIdChargesChargeIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateChargeApiV1ShipmentsShipmentIdChargesChargeIdPut
        >
      >,
      { shipmentId: string; chargeId: string }
    > = (props) => {
      const { shipmentId, chargeId } = props ?? {};

      return updateChargeApiV1ShipmentsShipmentIdChargesChargeIdPut(
        shipmentId,
        chargeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateChargeApiV1ShipmentsShipmentIdChargesChargeIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateChargeApiV1ShipmentsShipmentIdChargesChargeIdPut>
    >
  >;

export type UpdateChargeApiV1ShipmentsShipmentIdChargesChargeIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Charge
 */
export const useUpdateChargeApiV1ShipmentsShipmentIdChargesChargeIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateChargeApiV1ShipmentsShipmentIdChargesChargeIdPut
        >
      >,
      TError,
      { shipmentId: string; chargeId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateChargeApiV1ShipmentsShipmentIdChargesChargeIdPut>
  >,
  TError,
  { shipmentId: string; chargeId: string },
  TContext
> => {
  const mutationOptions =
    getUpdateChargeApiV1ShipmentsShipmentIdChargesChargeIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a charge.
 * @summary Delete Charge
 */
export const deleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDelete = (
  shipmentId: string,
  chargeId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/charges/${chargeId}`,
    method: 'DELETE'
  });
};

export const getDeleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDelete
        >
      >,
      TError,
      { shipmentId: string; chargeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDelete
      >
    >,
    TError,
    { shipmentId: string; chargeId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDelete
        >
      >,
      { shipmentId: string; chargeId: string }
    > = (props) => {
      const { shipmentId, chargeId } = props ?? {};

      return deleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDelete(
        shipmentId,
        chargeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDelete
      >
    >
  >;

export type DeleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Charge
 */
export const useDeleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDelete
        >
      >,
      TError,
      { shipmentId: string; chargeId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDelete>
  >,
  TError,
  { shipmentId: string; chargeId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteChargeApiV1ShipmentsShipmentIdChargesChargeIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Coverage block, recorded certificates, premium rollup and the CIF+uplift
suggested insured value for one job file. `coverage` is null when the file has
none yet.
 * @summary Get Shipment Coverage
 */
export const getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentCoverageDetail>({
    url: `/api/v1/shipments/${shipmentId}/coverage`,
    method: 'GET',
    signal
  });
};

export const getGetShipmentCoverageApiV1ShipmentsShipmentIdCoverageGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/coverage`] as const;
  };

export const getGetShipmentCoverageApiV1ShipmentsShipmentIdCoverageGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetShipmentCoverageApiV1ShipmentsShipmentIdCoverageGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
        >
      >
    > = ({ signal }) =>
      getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetShipmentCoverageApiV1ShipmentsShipmentIdCoverageGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet>
    >
  >;
export type GetShipmentCoverageApiV1ShipmentsShipmentIdCoverageGetQueryError =
  HTTPValidationError;

export function useGetShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet<
  TData = Awaited<
    ReturnType<typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet<
  TData = Awaited<
    ReturnType<typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet<
  TData = Awaited<
    ReturnType<typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Shipment Coverage
 */

export function useGetShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet<
  TData = Awaited<
    ReturnType<typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentCoverageApiV1ShipmentsShipmentIdCoverageGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetShipmentCoverageApiV1ShipmentsShipmentIdCoverageGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or patch the file's coverage block. Status moves are validated against
the config transition graph.
 * @summary Upsert Shipment Coverage
 */
export const upsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePut = (
  shipmentId: string
) => {
  return customInstance<ShipmentCoverage>({
    url: `/api/v1/shipments/${shipmentId}/coverage`,
    method: 'PUT'
  });
};

export const getUpsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof upsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePut
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof upsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePut
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'upsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof upsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePut
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return upsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePut(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof upsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePut
      >
    >
  >;

export type UpsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePutMutationError =
  HTTPValidationError;

/**
 * @summary Upsert Shipment Coverage
 */
export const useUpsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof upsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePut
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof upsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePut>
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getUpsertShipmentCoverageApiV1ShipmentsShipmentIdCoveragePutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Record a certificate obtained from the insurer/broker. This is what binds
cover: it moves the file's coverage to `covered`.
 * @summary Create Insurance Certificate
 */
export const createInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPost =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<InsuranceCertificate>({
      url: `/api/v1/shipments/${shipmentId}/coverage/certificates`,
      method: 'POST',
      signal
    });
  };

export const getCreateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'createInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return createInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPost
      >
    >
  >;

export type CreateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Insurance Certificate
 */
export const useCreateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPost
          >
        >,
        TError,
        { shipmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationOptions =
      getCreateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Patch a recorded certificate (partial — only provided fields are applied).
 * @summary Update Insurance Certificate
 */
export const updateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPut =
  (shipmentId: string, certificateId: string) => {
    return customInstance<InsuranceCertificate>({
      url: `/api/v1/shipments/${shipmentId}/coverage/certificates/${certificateId}`,
      method: 'PUT'
    });
  };

export const getUpdateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPut
        >
      >,
      TError,
      { shipmentId: string; certificateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPut
      >
    >,
    TError,
    { shipmentId: string; certificateId: string },
    TContext
  > => {
    const mutationKey = [
      'updateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPut
        >
      >,
      { shipmentId: string; certificateId: string }
    > = (props) => {
      const { shipmentId, certificateId } = props ?? {};

      return updateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPut(
        shipmentId,
        certificateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPut
      >
    >
  >;

export type UpdateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Insurance Certificate
 */
export const useUpdateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPut
          >
        >,
        TError,
        { shipmentId: string; certificateId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPut
      >
    >,
    TError,
    { shipmentId: string; certificateId: string },
    TContext
  > => {
    const mutationOptions =
      getUpdateInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Soft-delete a mis-recorded certificate. The file's coverage status is NOT
reverted — an operator fixing a typo shouldn't trip an uninsured-cargo
exception; moving the status back is a deliberate, separate act.
 * @summary Delete Insurance Certificate
 */
export const deleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDelete =
  (shipmentId: string, certificateId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/coverage/certificates/${certificateId}`,
      method: 'DELETE'
    });
  };

export const getDeleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDelete
        >
      >,
      TError,
      { shipmentId: string; certificateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDelete
      >
    >,
    TError,
    { shipmentId: string; certificateId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDelete
        >
      >,
      { shipmentId: string; certificateId: string }
    > = (props) => {
      const { shipmentId, certificateId } = props ?? {};

      return deleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDelete(
        shipmentId,
        certificateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDelete
      >
    >
  >;

export type DeleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Insurance Certificate
 */
export const useDeleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDelete
          >
        >,
        TError,
        { shipmentId: string; certificateId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDelete
      >
    >,
    TError,
    { shipmentId: string; certificateId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteInsuranceCertificateApiV1ShipmentsShipmentIdCoverageCertificatesCertificateIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Per-vendor-role + total AP cost rollup for a shipment, plus landed_unit_cost.
 * @summary Get Cost Rollup
 */
export const getCostRollupApiV1ShipmentsShipmentIdCostRollupGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/cost-rollup`,
    method: 'GET',
    signal
  });
};

export const getGetCostRollupApiV1ShipmentsShipmentIdCostRollupGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/cost-rollup`] as const;
};

export const getGetCostRollupApiV1ShipmentsShipmentIdCostRollupGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCostRollupApiV1ShipmentsShipmentIdCostRollupGetQueryKey(shipmentId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
      >
    > = ({ signal }) =>
      getCostRollupApiV1ShipmentsShipmentIdCostRollupGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCostRollupApiV1ShipmentsShipmentIdCostRollupGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
    >
  >;
export type GetCostRollupApiV1ShipmentsShipmentIdCostRollupGetQueryError =
  HTTPValidationError;

export function useGetCostRollupApiV1ShipmentsShipmentIdCostRollupGet<
  TData = Awaited<
    ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCostRollupApiV1ShipmentsShipmentIdCostRollupGet<
  TData = Awaited<
    ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCostRollupApiV1ShipmentsShipmentIdCostRollupGet<
  TData = Awaited<
    ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Cost Rollup
 */

export function useGetCostRollupApiV1ShipmentsShipmentIdCostRollupGet<
  TData = Awaited<
    ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCostRollupApiV1ShipmentsShipmentIdCostRollupGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCostRollupApiV1ShipmentsShipmentIdCostRollupGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Blended per-category landed cost for the Costs tab (E4, design §4.6): one
row per category, each tagged `estimated` or `actual`, with the variance where
both sides are known. Projected from procurement's blended rollup, so it cannot
disagree with the order and goods-receipt Landed Cost cards.
 * @summary Get Cost Summary
 */
export const getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentCostSummary>({
    url: `/api/v1/shipments/${shipmentId}/cost-summary`,
    method: 'GET',
    signal
  });
};

export const getGetCostSummaryApiV1ShipmentsShipmentIdCostSummaryGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/cost-summary`] as const;
};

export const getGetCostSummaryApiV1ShipmentsShipmentIdCostSummaryGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCostSummaryApiV1ShipmentsShipmentIdCostSummaryGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet>
      >
    > = ({ signal }) =>
      getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCostSummaryApiV1ShipmentsShipmentIdCostSummaryGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet>
    >
  >;
export type GetCostSummaryApiV1ShipmentsShipmentIdCostSummaryGetQueryError =
  HTTPValidationError;

export function useGetCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet<
  TData = Awaited<
    ReturnType<typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet<
  TData = Awaited<
    ReturnType<typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet<
  TData = Awaited<
    ReturnType<typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Cost Summary
 */

export function useGetCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet<
  TData = Awaited<
    ReturnType<typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCostSummaryApiV1ShipmentsShipmentIdCostSummaryGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCostSummaryApiV1ShipmentsShipmentIdCostSummaryGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Whether the Costs tab should show its "no cost estimates yet" banner for THIS
reader — the same predicate and the same dismissal store as the
`shipments.estimate_missing` nag (design §4.6).
 * @summary Get Estimate Reminder
 */
export const getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentEstimateReminder>({
    url: `/api/v1/shipments/${shipmentId}/estimate-reminder`,
    method: 'GET',
    signal
  });
};

export const getGetEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/estimate-reminder`] as const;
  };

export const getGetEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
        >
      >
    > = ({ signal }) =>
      getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
      >
    >
  >;
export type GetEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGetQueryError =
  HTTPValidationError;

export function useGetEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet<
  TData = Awaited<
    ReturnType<
      typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet<
  TData = Awaited<
    ReturnType<
      typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet<
  TData = Awaited<
    ReturnType<
      typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Estimate Reminder
 */

export function useGetEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet<
  TData = Awaited<
    ReturnType<
      typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEstimateReminderApiV1ShipmentsShipmentIdEstimateReminderGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Dismiss the banner AND the nag together, per the reminders framework — one
condition, one dismissal. Idempotent.
 * @summary Dismiss Estimate Reminder Route
 */
export const dismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPost =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<ShipmentEstimateReminder>({
      url: `/api/v1/shipments/${shipmentId}/estimate-reminder/dismiss`,
      method: 'POST',
      signal
    });
  };

export const getDismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof dismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof dismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'dismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof dismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return dismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof dismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPost
      >
    >
  >;

export type DismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPostMutationError =
  HTTPValidationError;

/**
 * @summary Dismiss Estimate Reminder Route
 */
export const useDismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof dismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPost
          >
        >,
        TError,
        { shipmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof dismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationOptions =
      getDismissEstimateReminderRouteApiV1ShipmentsShipmentIdEstimateReminderDismissPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Job P&L rollup for a shipment (TMS B4): three-view (planned/actual/accrued)
summary, per-charge grid, buy-side variance panel, allocated consol costs.

Persona-gated: forwarders (``sells_freight_services``) get the full P&L
(revenue / margin / WIP); other tenants get a cost-only view (revenue and
margin stripped server-side).
 * @summary Get Job Pnl
 */
export const getJobPnlApiV1ShipmentsShipmentIdJobPnlGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<JobPnl>({
    url: `/api/v1/shipments/${shipmentId}/job-pnl`,
    method: 'GET',
    signal
  });
};

export const getGetJobPnlApiV1ShipmentsShipmentIdJobPnlGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/job-pnl`] as const;
};

export const getGetJobPnlApiV1ShipmentsShipmentIdJobPnlGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetJobPnlApiV1ShipmentsShipmentIdJobPnlGetQueryKey(shipmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>>
  > = ({ signal }) =>
    getJobPnlApiV1ShipmentsShipmentIdJobPnlGet(shipmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shipmentId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetJobPnlApiV1ShipmentsShipmentIdJobPnlGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>>
>;
export type GetJobPnlApiV1ShipmentsShipmentIdJobPnlGetQueryError =
  HTTPValidationError;

export function useGetJobPnlApiV1ShipmentsShipmentIdJobPnlGet<
  TData = Awaited<
    ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>
          >,
          TError,
          Awaited<ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJobPnlApiV1ShipmentsShipmentIdJobPnlGet<
  TData = Awaited<
    ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>
          >,
          TError,
          Awaited<ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJobPnlApiV1ShipmentsShipmentIdJobPnlGet<
  TData = Awaited<
    ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Job Pnl
 */

export function useGetJobPnlApiV1ShipmentsShipmentIdJobPnlGet<
  TData = Awaited<
    ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobPnlApiV1ShipmentsShipmentIdJobPnlGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJobPnlApiV1ShipmentsShipmentIdJobPnlGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Job-close panel state (TMS B7): live completeness validation, the latest
immutable profit snapshot (if the file was closed), and its late-cost variance
annotations.
 * @summary Get Job Close State
 */
export const getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<JobCloseState>({
    url: `/api/v1/shipments/${shipmentId}/close-state`,
    method: 'GET',
    signal
  });
};

export const getGetJobCloseStateApiV1ShipmentsShipmentIdCloseStateGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/close-state`] as const;
  };

export const getGetJobCloseStateApiV1ShipmentsShipmentIdCloseStateGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetJobCloseStateApiV1ShipmentsShipmentIdCloseStateGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet>
      >
    > = ({ signal }) =>
      getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetJobCloseStateApiV1ShipmentsShipmentIdCloseStateGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet>
    >
  >;
export type GetJobCloseStateApiV1ShipmentsShipmentIdCloseStateGetQueryError =
  HTTPValidationError;

export function useGetJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet<
  TData = Awaited<
    ReturnType<typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet<
  TData = Awaited<
    ReturnType<typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet<
  TData = Awaited<
    ReturnType<typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Job Close State
 */

export function useGetJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet<
  TData = Awaited<
    ReturnType<typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobCloseStateApiV1ShipmentsShipmentIdCloseStateGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJobCloseStateApiV1ShipmentsShipmentIdCloseStateGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Close (liquidate) a delivered shipment file (TMS B7): validate completeness,
freeze the ledger, and write the immutable profit snapshot. Blocking-check
failures require an audited ``override_reason``.
 * @summary Close Job
 */
export const closeJobApiV1ShipmentsShipmentIdClosePost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/close`,
    method: 'POST',
    signal
  });
};

export const getCloseJobApiV1ShipmentsShipmentIdClosePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeJobApiV1ShipmentsShipmentIdClosePost>>,
    TError,
    { shipmentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeJobApiV1ShipmentsShipmentIdClosePost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationKey = ['closeJobApiV1ShipmentsShipmentIdClosePost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeJobApiV1ShipmentsShipmentIdClosePost>>,
    { shipmentId: string }
  > = (props) => {
    const { shipmentId } = props ?? {};

    return closeJobApiV1ShipmentsShipmentIdClosePost(shipmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseJobApiV1ShipmentsShipmentIdClosePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof closeJobApiV1ShipmentsShipmentIdClosePost>>
  >;

export type CloseJobApiV1ShipmentsShipmentIdClosePostMutationError =
  HTTPValidationError;

/**
 * @summary Close Job
 */
export const useCloseJobApiV1ShipmentsShipmentIdClosePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof closeJobApiV1ShipmentsShipmentIdClosePost>>,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof closeJobApiV1ShipmentsShipmentIdClosePost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getCloseJobApiV1ShipmentsShipmentIdClosePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reopen a closed file (TMS B7 / G6) — explicit, admin-gated, audited. The
profit-snapshot history is retained; a later re-close appends a new snapshot.
 * @summary Reopen Job
 */
export const reopenJobApiV1ShipmentsShipmentIdReopenPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/reopen`,
    method: 'POST',
    signal
  });
};

export const getReopenJobApiV1ShipmentsShipmentIdReopenPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reopenJobApiV1ShipmentsShipmentIdReopenPost>>,
    TError,
    { shipmentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reopenJobApiV1ShipmentsShipmentIdReopenPost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationKey = ['reopenJobApiV1ShipmentsShipmentIdReopenPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reopenJobApiV1ShipmentsShipmentIdReopenPost>>,
    { shipmentId: string }
  > = (props) => {
    const { shipmentId } = props ?? {};

    return reopenJobApiV1ShipmentsShipmentIdReopenPost(shipmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReopenJobApiV1ShipmentsShipmentIdReopenPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof reopenJobApiV1ShipmentsShipmentIdReopenPost>>
  >;

export type ReopenJobApiV1ShipmentsShipmentIdReopenPostMutationError =
  HTTPValidationError;

/**
 * @summary Reopen Job
 */
export const useReopenJobApiV1ShipmentsShipmentIdReopenPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reopenJobApiV1ShipmentsShipmentIdReopenPost>>,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reopenJobApiV1ShipmentsShipmentIdReopenPost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getReopenJobApiV1ShipmentsShipmentIdReopenPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * A shipment's diversion history, newest first — who re-pointed the goods,
when, why, and what the same action changed downstream.
 * @summary List Diversions
 */
export const listDiversionsApiV1ShipmentsShipmentIdDiversionsGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentDiversionList>({
    url: `/api/v1/shipments/${shipmentId}/diversions`,
    method: 'GET',
    signal
  });
};

export const getListDiversionsApiV1ShipmentsShipmentIdDiversionsGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/diversions`] as const;
};

export const getListDiversionsApiV1ShipmentsShipmentIdDiversionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDiversionsApiV1ShipmentsShipmentIdDiversionsGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
      >
    > = ({ signal }) =>
      listDiversionsApiV1ShipmentsShipmentIdDiversionsGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDiversionsApiV1ShipmentsShipmentIdDiversionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
    >
  >;
export type ListDiversionsApiV1ShipmentsShipmentIdDiversionsGetQueryError =
  HTTPValidationError;

export function useListDiversionsApiV1ShipmentsShipmentIdDiversionsGet<
  TData = Awaited<
    ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDiversionsApiV1ShipmentsShipmentIdDiversionsGet<
  TData = Awaited<
    ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDiversionsApiV1ShipmentsShipmentIdDiversionsGet<
  TData = Awaited<
    ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Diversions
 */

export function useListDiversionsApiV1ShipmentsShipmentIdDiversionsGet<
  TData = Awaited<
    ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDiversionsApiV1ShipmentsShipmentIdDiversionsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDiversionsApiV1ShipmentsShipmentIdDiversionsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * What diverting this shipment to the proposed destination/consignee would do.

A POST because the answer depends on the PROPOSED values (which documents go
stale, and what a filed customs entry needs amending FOR), but it writes
nothing — the same shape as ``/routing/plan/{shipment_id}``, which plans a
route without applying it.
 * @summary Preview Diversion
 */
export const previewDiversionApiV1ShipmentsShipmentIdDivertPreviewPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentDivertPreview>({
    url: `/api/v1/shipments/${shipmentId}/divert/preview`,
    method: 'POST',
    signal
  });
};

export const getPreviewDiversionApiV1ShipmentsShipmentIdDivertPreviewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof previewDiversionApiV1ShipmentsShipmentIdDivertPreviewPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof previewDiversionApiV1ShipmentsShipmentIdDivertPreviewPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'previewDiversionApiV1ShipmentsShipmentIdDivertPreviewPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof previewDiversionApiV1ShipmentsShipmentIdDivertPreviewPost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return previewDiversionApiV1ShipmentsShipmentIdDivertPreviewPost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PreviewDiversionApiV1ShipmentsShipmentIdDivertPreviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewDiversionApiV1ShipmentsShipmentIdDivertPreviewPost
      >
    >
  >;

export type PreviewDiversionApiV1ShipmentsShipmentIdDivertPreviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Preview Diversion
 */
export const usePreviewDiversionApiV1ShipmentsShipmentIdDivertPreviewPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof previewDiversionApiV1ShipmentsShipmentIdDivertPreviewPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof previewDiversionApiV1ShipmentsShipmentIdDivertPreviewPost>
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getPreviewDiversionApiV1ShipmentsShipmentIdDivertPreviewPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Divert an already-sailed shipment to a new destination and/or consignee.

One recorded action: the header change, the diversion row (actor + timestamp),
the re-pointed inland leg, the documents stamped as needing reissue, the
re-evaluated checklist, and the warnings for what could not be fixed —
a filed customs entry among them, flagged rather than silently invalidated.
 * @summary Divert Shipment
 */
export const divertShipmentApiV1ShipmentsShipmentIdDivertPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentDivertResult>({
    url: `/api/v1/shipments/${shipmentId}/divert`,
    method: 'POST',
    signal
  });
};

export const getDivertShipmentApiV1ShipmentsShipmentIdDivertPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof divertShipmentApiV1ShipmentsShipmentIdDivertPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof divertShipmentApiV1ShipmentsShipmentIdDivertPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = ['divertShipmentApiV1ShipmentsShipmentIdDivertPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof divertShipmentApiV1ShipmentsShipmentIdDivertPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return divertShipmentApiV1ShipmentsShipmentIdDivertPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DivertShipmentApiV1ShipmentsShipmentIdDivertPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof divertShipmentApiV1ShipmentsShipmentIdDivertPost>>
  >;

export type DivertShipmentApiV1ShipmentsShipmentIdDivertPostMutationError =
  HTTPValidationError;

/**
 * @summary Divert Shipment
 */
export const useDivertShipmentApiV1ShipmentsShipmentIdDivertPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof divertShipmentApiV1ShipmentsShipmentIdDivertPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof divertShipmentApiV1ShipmentsShipmentIdDivertPost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getDivertShipmentApiV1ShipmentsShipmentIdDivertPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Manager release of a customer credit hold on a file (G2) — admin-gated,
audited, reason mandatory. Returns the file to ``credit_status = 'ok'``.
 * @summary Release Credit Hold
 */
export const releaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/credit-release`,
    method: 'POST',
    signal
  });
};

export const getReleaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof releaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof releaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'releaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof releaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return releaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReleaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof releaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePost
      >
    >
  >;

export type ReleaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePostMutationError =
  HTTPValidationError;

/**
 * @summary Release Credit Hold
 */
export const useReleaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof releaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof releaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePost
    >
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getReleaseCreditHoldApiV1ShipmentsShipmentIdCreditReleasePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * WS5 (E3): the file's live denied-party screening results + whether it is on
a compliance hold (an open COMPLIANCE exception). Drives the E4 review UI.
 * @summary List Shipment Screening
 */
export const listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/screening`,
    method: 'GET',
    signal
  });
};

export const getListShipmentScreeningApiV1ShipmentsShipmentIdScreeningGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/screening`] as const;
  };

export const getListShipmentScreeningApiV1ShipmentsShipmentIdScreeningGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListShipmentScreeningApiV1ShipmentsShipmentIdScreeningGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
        >
      >
    > = ({ signal }) =>
      listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListShipmentScreeningApiV1ShipmentsShipmentIdScreeningGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
      >
    >
  >;
export type ListShipmentScreeningApiV1ShipmentsShipmentIdScreeningGetQueryError =
  HTTPValidationError;

export function useListShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet<
  TData = Awaited<
    ReturnType<typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet<
  TData = Awaited<
    ReturnType<typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet<
  TData = Awaited<
    ReturnType<typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Shipment Screening
 */

export function useListShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet<
  TData = Awaited<
    ReturnType<typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentScreeningApiV1ShipmentsShipmentIdScreeningGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListShipmentScreeningApiV1ShipmentsShipmentIdScreeningGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * WS5 (E3): a compliance user dispositions a screening result on the file —
admin-gated. A ``false_positive`` releases the compliance hold once nothing
blocking remains; ``confirmed`` keeps it. Returns the updated result.
 * @summary Disposition Shipment Screening
 */
export const dispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPost =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/screening/disposition`,
      method: 'POST',
      signal
    });
  };

export const getDispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof dispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof dispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'dispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof dispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return dispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof dispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPost
      >
    >
  >;

export type DispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPostMutationError =
  HTTPValidationError;

/**
 * @summary Disposition Shipment Screening
 */
export const useDispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof dispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPost
          >
        >,
        TError,
        { shipmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof dispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationOptions =
      getDispositionShipmentScreeningApiV1ShipmentsShipmentIdScreeningDispositionPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * WS5 (E4): the org-level denied-party screening result for one organization
(``shipment_id IS NULL``) — drives the compliance panel on the master-data org
page. Returns ``{"result": <result | null>}``; ``null`` means the org has never
been screened.
 * @summary Get Organization Screening
 */
export const getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/organizations/${organizationId}/screening`,
      method: 'GET',
      signal
    });
  };

export const getGetOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGetQueryKey =
  (organizationId?: string) => {
    return [
      `/api/v1/shipments/organizations/${organizationId}/screening`
    ] as const;
  };

export const getGetOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
      >
    >,
    TError = HTTPValidationError
  >(
    organizationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGetQueryKey(
        organizationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
        >
      >
    > = ({ signal }) =>
      getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet(
        organizationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!organizationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
      >
    >
  >;
export type GetOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGetQueryError =
  HTTPValidationError;

export function useGetOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Organization Screening
 */

export function useGetOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet<
  TData = Awaited<
    ReturnType<
      typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetOrganizationScreeningApiV1ShipmentsOrganizationsOrganizationIdScreeningGetQueryOptions(
      organizationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * WS5 (E4): manually (re-)screen one organization against the current
denied-party lists — the "Re-screen now" action on the org compliance panel.
Admin-gated (same posture as disposition). Returns ``{"result": <result | null>}``;
``null`` if the organization no longer exists.
 * @summary Rescreen Organization
 */
export const rescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPost =
  (organizationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/organizations/${organizationId}/screening/rescreen`,
      method: 'POST',
      signal
    });
  };

export const getRescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof rescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPost
        >
      >,
      TError,
      { organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof rescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'rescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof rescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPost
        >
      >,
      { organizationId: string }
    > = (props) => {
      const { organizationId } = props ?? {};

      return rescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPost(
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof rescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPost
      >
    >
  >;

export type RescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPostMutationError =
  HTTPValidationError;

/**
 * @summary Rescreen Organization
 */
export const useRescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof rescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPost
          >
        >,
        TError,
        { organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof rescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPost
      >
    >,
    TError,
    { organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getRescreenOrganizationApiV1ShipmentsOrganizationsOrganizationIdScreeningRescreenPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Per-PO, per-line landed-cost allocation across this shipment's orders —
the read behind the Bills tab "Cost allocation across orders" card. Pure
display projection of the already-computed rollup; no writes.
 * @summary Get Landed Cost Allocation
 */
export const getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentCostAllocation>({
    url: `/api/v1/shipments/${shipmentId}/landed-cost`,
    method: 'GET',
    signal
  });
};

export const getGetLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/landed-cost`] as const;
  };

export const getGetLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
        >
      >
    > = ({ signal }) =>
      getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
      >
    >
  >;
export type GetLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGetQueryError =
  HTTPValidationError;

export function useGetLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet<
  TData = Awaited<
    ReturnType<
      typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet<
  TData = Awaited<
    ReturnType<
      typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet<
  TData = Awaited<
    ReturnType<
      typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Landed Cost Allocation
 */

export function useGetLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet<
  TData = Awaited<
    ReturnType<
      typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLandedCostAllocationApiV1ShipmentsShipmentIdLandedCostGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Actualize landed cost: capitalize the attached AP bills onto the inbound
receipts' cost layers + post the inventory JE, and reconcile landed_unit_cost.
Idempotent — safe to press repeatedly.

Gated to accounting 'member' access — this posts a GL journal entry, so it
follows the same authZ convention as the accounting GL-write endpoints
rather than bare ``require_auth``.
 * @summary Apply Landed Cost
 */
export const applyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<LandedCostApplyResponse>({
    url: `/api/v1/shipments/${shipmentId}/landed-cost/apply`,
    method: 'POST',
    signal
  });
};

export const getApplyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof applyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof applyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPost
      >
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'applyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof applyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return applyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApplyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof applyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPost
      >
    >
  >;

export type ApplyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPostMutationError =
  HTTPValidationError;

/**
 * @summary Apply Landed Cost
 */
export const useApplyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof applyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof applyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPost
    >
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getApplyLandedCostApiV1ShipmentsShipmentIdLandedCostApplyPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * AP bills grouped under this shipment, with vendor role, payment date + TNUM.
 * @summary List Shipment Bills
 */
export const listShipmentBillsApiV1ShipmentsShipmentIdBillsGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentBillList>({
    url: `/api/v1/shipments/${shipmentId}/bills`,
    method: 'GET',
    signal
  });
};

export const getListShipmentBillsApiV1ShipmentsShipmentIdBillsGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/bills`] as const;
};

export const getListShipmentBillsApiV1ShipmentsShipmentIdBillsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListShipmentBillsApiV1ShipmentsShipmentIdBillsGetQueryKey(shipmentId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
      >
    > = ({ signal }) =>
      listShipmentBillsApiV1ShipmentsShipmentIdBillsGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListShipmentBillsApiV1ShipmentsShipmentIdBillsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
    >
  >;
export type ListShipmentBillsApiV1ShipmentsShipmentIdBillsGetQueryError =
  HTTPValidationError;

export function useListShipmentBillsApiV1ShipmentsShipmentIdBillsGet<
  TData = Awaited<
    ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListShipmentBillsApiV1ShipmentsShipmentIdBillsGet<
  TData = Awaited<
    ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListShipmentBillsApiV1ShipmentsShipmentIdBillsGet<
  TData = Awaited<
    ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Shipment Bills
 */

export function useListShipmentBillsApiV1ShipmentsShipmentIdBillsGet<
  TData = Awaited<
    ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listShipmentBillsApiV1ShipmentsShipmentIdBillsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListShipmentBillsApiV1ShipmentsShipmentIdBillsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Attachable AP bills for the attach-bill picker: non-voided bills not yet
grouped under this shipment (read via accounting's BillService).
 * @summary List Candidate Bills
 */
export const listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet = (
  shipmentId: string,
  params?: ListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/candidate-bills`,
    method: 'GET',
    params,
    signal
  });
};

export const getListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetQueryKey =
  (
    shipmentId?: string,
    params?: ListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetParams
  ) => {
    return [
      `/api/v1/shipments/${shipmentId}/candidate-bills`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    params?: ListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetQueryKey(
        shipmentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
        >
      >
    > = ({ signal }) =>
      listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet(
        shipmentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
      >
    >
  >;
export type ListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetQueryError =
  HTTPValidationError;

export function useListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params:
    | undefined
    | ListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Candidate Bills
 */

export function useListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCandidateBillsApiV1ShipmentsShipmentIdCandidateBillsGetQueryOptions(
      shipmentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Group an existing AP bill under this shipment with a vendor role. Drives
the actuals landed-cost rollup (recompute fires on accounting.bill.changed).
 * @summary Attach Bill
 */
export const attachBillApiV1ShipmentsShipmentIdBillsAttachPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/bills/attach`,
    method: 'POST',
    signal
  });
};

export const getAttachBillApiV1ShipmentsShipmentIdBillsAttachPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof attachBillApiV1ShipmentsShipmentIdBillsAttachPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof attachBillApiV1ShipmentsShipmentIdBillsAttachPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = ['attachBillApiV1ShipmentsShipmentIdBillsAttachPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof attachBillApiV1ShipmentsShipmentIdBillsAttachPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return attachBillApiV1ShipmentsShipmentIdBillsAttachPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AttachBillApiV1ShipmentsShipmentIdBillsAttachPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof attachBillApiV1ShipmentsShipmentIdBillsAttachPost>
    >
  >;

export type AttachBillApiV1ShipmentsShipmentIdBillsAttachPostMutationError =
  HTTPValidationError;

/**
 * @summary Attach Bill
 */
export const useAttachBillApiV1ShipmentsShipmentIdBillsAttachPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof attachBillApiV1ShipmentsShipmentIdBillsAttachPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof attachBillApiV1ShipmentsShipmentIdBillsAttachPost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getAttachBillApiV1ShipmentsShipmentIdBillsAttachPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * AR invoices billing this freight shipment (forwarder sell-side job revenue).
 * @summary List Shipment Invoices
 */
export const listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/invoices`,
    method: 'GET',
    signal
  });
};

export const getListShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/invoices`] as const;
  };

export const getListShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
        >
      >
    > = ({ signal }) =>
      listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet>
    >
  >;
export type ListShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGetQueryError =
  HTTPValidationError;

export function useListShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet<
  TData = Awaited<
    ReturnType<typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet<
  TData = Awaited<
    ReturnType<typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet<
  TData = Awaited<
    ReturnType<typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Shipment Invoices
 */

export function useListShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet<
  TData = Awaited<
    ReturnType<typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListShipmentInvoicesApiV1ShipmentsShipmentIdInvoicesGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Attachable AR invoices for the attach-invoice picker: non-voided invoices
not yet linked to this shipment (read via accounting's InvoiceService).
 * @summary List Candidate Invoices
 */
export const listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet =
  (
    shipmentId: string,
    params?: ListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/candidate-invoices`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetQueryKey =
  (
    shipmentId?: string,
    params?: ListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetParams
  ) => {
    return [
      `/api/v1/shipments/${shipmentId}/candidate-invoices`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    params?: ListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetQueryKey(
        shipmentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
        >
      >
    > = ({ signal }) =>
      listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet(
        shipmentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
      >
    >
  >;
export type ListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetQueryError =
  HTTPValidationError;

export function useListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params:
    | undefined
    | ListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Candidate Invoices
 */

export function useListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCandidateInvoicesApiV1ShipmentsShipmentIdCandidateInvoicesGetQueryOptions(
      shipmentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Link an existing AR invoice to this shipment as sell-side job revenue.
 * @summary Attach Invoice
 */
export const attachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/invoices/attach`,
    method: 'POST',
    signal
  });
};

export const getAttachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof attachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof attachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'attachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof attachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return attachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AttachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof attachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPost>
    >
  >;

export type AttachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPostMutationError =
  HTTPValidationError;

/**
 * @summary Attach Invoice
 */
export const useAttachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof attachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof attachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPost>
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getAttachInvoiceApiV1ShipmentsShipmentIdInvoicesAttachPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Unlink an AR invoice from this shipment — the half the attach path never
had (the wave-C inventory records this direction as edit-surface-less).

Gated EDITOR on the SHIPMENT and on the shipment only: §5 of the
relationship contract is explicit that removing a link requires editor on
the near side alone, because requiring viewer on the far side would leave a
shipment's owner unable to detach an invoice that has since been unshared
from them. Removal reveals nothing.
 * @summary Detach Invoice
 */
export const detachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/invoices/detach`,
    method: 'POST',
    signal
  });
};

export const getDetachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof detachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof detachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'detachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof detachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPost
        >
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return detachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPost(
        shipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DetachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof detachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPost>
    >
  >;

export type DetachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPostMutationError =
  HTTPValidationError;

/**
 * @summary Detach Invoice
 */
export const useDetachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof detachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPost
        >
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof detachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPost>
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getDetachInvoiceApiV1ShipmentsShipmentIdInvoicesDetachPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List milestones for a shipment.
 * @summary List Milestones
 */
export const listMilestonesApiV1ShipmentsShipmentIdMilestonesGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentMilestoneList>({
    url: `/api/v1/shipments/${shipmentId}/milestones`,
    method: 'GET',
    signal
  });
};

export const getListMilestonesApiV1ShipmentsShipmentIdMilestonesGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/milestones`] as const;
};

export const getListMilestonesApiV1ShipmentsShipmentIdMilestonesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListMilestonesApiV1ShipmentsShipmentIdMilestonesGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
      >
    > = ({ signal }) =>
      listMilestonesApiV1ShipmentsShipmentIdMilestonesGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListMilestonesApiV1ShipmentsShipmentIdMilestonesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
    >
  >;
export type ListMilestonesApiV1ShipmentsShipmentIdMilestonesGetQueryError =
  HTTPValidationError;

export function useListMilestonesApiV1ShipmentsShipmentIdMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMilestonesApiV1ShipmentsShipmentIdMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMilestonesApiV1ShipmentsShipmentIdMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Milestones
 */

export function useListMilestonesApiV1ShipmentsShipmentIdMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMilestonesApiV1ShipmentsShipmentIdMilestonesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListMilestonesApiV1ShipmentsShipmentIdMilestonesGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a milestone.
 * @summary Create Milestone
 */
export const createMilestoneApiV1ShipmentsShipmentIdMilestonesPost = (
  shipmentId: string,
  shipmentMilestoneCreate: ShipmentMilestoneCreate,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentMilestone>({
    url: `/api/v1/shipments/${shipmentId}/milestones`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shipmentMilestoneCreate,
    signal
  });
};

export const getCreateMilestoneApiV1ShipmentsShipmentIdMilestonesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createMilestoneApiV1ShipmentsShipmentIdMilestonesPost>
      >,
      TError,
      { shipmentId: string; data: ShipmentMilestoneCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createMilestoneApiV1ShipmentsShipmentIdMilestonesPost>
    >,
    TError,
    { shipmentId: string; data: ShipmentMilestoneCreate },
    TContext
  > => {
    const mutationKey = [
      'createMilestoneApiV1ShipmentsShipmentIdMilestonesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createMilestoneApiV1ShipmentsShipmentIdMilestonesPost>
      >,
      { shipmentId: string; data: ShipmentMilestoneCreate }
    > = (props) => {
      const { shipmentId, data } = props ?? {};

      return createMilestoneApiV1ShipmentsShipmentIdMilestonesPost(
        shipmentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateMilestoneApiV1ShipmentsShipmentIdMilestonesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createMilestoneApiV1ShipmentsShipmentIdMilestonesPost>
    >
  >;
export type CreateMilestoneApiV1ShipmentsShipmentIdMilestonesPostMutationBody =
  ShipmentMilestoneCreate;
export type CreateMilestoneApiV1ShipmentsShipmentIdMilestonesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Milestone
 */
export const useCreateMilestoneApiV1ShipmentsShipmentIdMilestonesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createMilestoneApiV1ShipmentsShipmentIdMilestonesPost>
      >,
      TError,
      { shipmentId: string; data: ShipmentMilestoneCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createMilestoneApiV1ShipmentsShipmentIdMilestonesPost>
  >,
  TError,
  { shipmentId: string; data: ShipmentMilestoneCreate },
  TContext
> => {
  const mutationOptions =
    getCreateMilestoneApiV1ShipmentsShipmentIdMilestonesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a milestone.
 * @summary Delete Milestone
 */
export const deleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDelete =
  (shipmentId: string, milestoneId: string) => {
    return customInstance<ShipmentMilestoneDeleteResult>({
      url: `/api/v1/shipments/${shipmentId}/milestones/${milestoneId}`,
      method: 'DELETE'
    });
  };

export const getDeleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDelete
        >
      >,
      TError,
      { shipmentId: string; milestoneId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDelete
      >
    >,
    TError,
    { shipmentId: string; milestoneId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDelete
        >
      >,
      { shipmentId: string; milestoneId: string }
    > = (props) => {
      const { shipmentId, milestoneId } = props ?? {};

      return deleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDelete(
        shipmentId,
        milestoneId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDelete
      >
    >
  >;

export type DeleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Milestone
 */
export const useDeleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDelete
          >
        >,
        TError,
        { shipmentId: string; milestoneId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDelete
      >
    >,
    TError,
    { shipmentId: string; milestoneId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteMilestoneApiV1ShipmentsShipmentIdMilestonesMilestoneIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Document readiness for every container on this shipment.

The catalog travels with the containers so the caller renders the same columns
whether or not a box has anything recorded yet — and so an empty `containers`
is legible as "this file has no containers" rather than as a failed read.
 * @summary List Container Gates
 */
export const listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ContainerGateReadinessList>({
    url: `/api/v1/shipments/${shipmentId}/container-gates`,
    method: 'GET',
    signal
  });
};

export const getListContainerGatesApiV1ShipmentsShipmentIdContainerGatesGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/container-gates`] as const;
  };

export const getListContainerGatesApiV1ShipmentsShipmentIdContainerGatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListContainerGatesApiV1ShipmentsShipmentIdContainerGatesGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
        >
      >
    > = ({ signal }) =>
      listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListContainerGatesApiV1ShipmentsShipmentIdContainerGatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
      >
    >
  >;
export type ListContainerGatesApiV1ShipmentsShipmentIdContainerGatesGetQueryError =
  HTTPValidationError;

export function useListContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet<
  TData = Awaited<
    ReturnType<
      typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet<
  TData = Awaited<
    ReturnType<
      typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet<
  TData = Awaited<
    ReturnType<
      typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Container Gates
 */

export function useListContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet<
  TData = Awaited<
    ReturnType<
      typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContainerGatesApiV1ShipmentsShipmentIdContainerGatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListContainerGatesApiV1ShipmentsShipmentIdContainerGatesGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Record one gate against one container. Idempotent.

Returns the whole readiness projection rather than the row written: the caller's
next render needs the recomputed n-of-m anyway, and returning it here saves a
round trip that would otherwise race the write.
 * @summary Record Container Gate
 */
export const recordContainerGateApiV1ShipmentsShipmentIdContainerGatesPost = (
  shipmentId: string,
  containerGateRecord: ContainerGateRecord,
  signal?: AbortSignal
) => {
  return customInstance<ContainerGateReadinessList>({
    url: `/api/v1/shipments/${shipmentId}/container-gates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: containerGateRecord,
    signal
  });
};

export const getRecordContainerGateApiV1ShipmentsShipmentIdContainerGatesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof recordContainerGateApiV1ShipmentsShipmentIdContainerGatesPost
        >
      >,
      TError,
      { shipmentId: string; data: ContainerGateRecord },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof recordContainerGateApiV1ShipmentsShipmentIdContainerGatesPost
      >
    >,
    TError,
    { shipmentId: string; data: ContainerGateRecord },
    TContext
  > => {
    const mutationKey = [
      'recordContainerGateApiV1ShipmentsShipmentIdContainerGatesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof recordContainerGateApiV1ShipmentsShipmentIdContainerGatesPost
        >
      >,
      { shipmentId: string; data: ContainerGateRecord }
    > = (props) => {
      const { shipmentId, data } = props ?? {};

      return recordContainerGateApiV1ShipmentsShipmentIdContainerGatesPost(
        shipmentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RecordContainerGateApiV1ShipmentsShipmentIdContainerGatesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof recordContainerGateApiV1ShipmentsShipmentIdContainerGatesPost
      >
    >
  >;
export type RecordContainerGateApiV1ShipmentsShipmentIdContainerGatesPostMutationBody =
  ContainerGateRecord;
export type RecordContainerGateApiV1ShipmentsShipmentIdContainerGatesPostMutationError =
  HTTPValidationError;

/**
 * @summary Record Container Gate
 */
export const useRecordContainerGateApiV1ShipmentsShipmentIdContainerGatesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof recordContainerGateApiV1ShipmentsShipmentIdContainerGatesPost
          >
        >,
        TError,
        { shipmentId: string; data: ContainerGateRecord },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof recordContainerGateApiV1ShipmentsShipmentIdContainerGatesPost
      >
    >,
    TError,
    { shipmentId: string; data: ContainerGateRecord },
    TContext
  > => {
    const mutationOptions =
      getRecordContainerGateApiV1ShipmentsShipmentIdContainerGatesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Untick one gate on one container.
 * @summary Clear Container Gate
 */
export const clearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDelete =
  (shipmentId: string, cargoId: string, gateCode: string) => {
    return customInstance<ContainerGateReadinessList>({
      url: `/api/v1/shipments/${shipmentId}/container-gates/${cargoId}/${gateCode}`,
      method: 'DELETE'
    });
  };

export const getClearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof clearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDelete
        >
      >,
      TError,
      { shipmentId: string; cargoId: string; gateCode: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof clearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDelete
      >
    >,
    TError,
    { shipmentId: string; cargoId: string; gateCode: string },
    TContext
  > => {
    const mutationKey = [
      'clearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof clearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDelete
        >
      >,
      { shipmentId: string; cargoId: string; gateCode: string }
    > = (props) => {
      const { shipmentId, cargoId, gateCode } = props ?? {};

      return clearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDelete(
        shipmentId,
        cargoId,
        gateCode
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ClearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof clearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDelete
      >
    >
  >;

export type ClearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Clear Container Gate
 */
export const useClearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof clearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDelete
          >
        >,
        TError,
        { shipmentId: string; cargoId: string; gateCode: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof clearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDelete
      >
    >,
    TError,
    { shipmentId: string; cargoId: string; gateCode: string },
    TContext
  > => {
    const mutationOptions =
      getClearContainerGateApiV1ShipmentsShipmentIdContainerGatesCargoIdGateCodeDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Set or clear ONE container's FDA disposition.

Null clears the override and returns the box to inheriting the file's derived
rollup; this route never writes that rollup, which the customs sub-module owns.
 * @summary Set Container Fda Status
 */
export const setContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPut =
  (
    shipmentId: string,
    cargoId: string,
    containerFdaStatusUpdate: ContainerFdaStatusUpdate
  ) => {
    return customInstance<ContainerGateReadinessList>({
      url: `/api/v1/shipments/${shipmentId}/container-gates/${cargoId}/fda-status`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: containerFdaStatusUpdate
    });
  };

export const getSetContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPut
        >
      >,
      TError,
      { shipmentId: string; cargoId: string; data: ContainerFdaStatusUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPut
      >
    >,
    TError,
    { shipmentId: string; cargoId: string; data: ContainerFdaStatusUpdate },
    TContext
  > => {
    const mutationKey = [
      'setContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPut
        >
      >,
      { shipmentId: string; cargoId: string; data: ContainerFdaStatusUpdate }
    > = (props) => {
      const { shipmentId, cargoId, data } = props ?? {};

      return setContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPut(
        shipmentId,
        cargoId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPut
      >
    >
  >;
export type SetContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPutMutationBody =
  ContainerFdaStatusUpdate;
export type SetContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPutMutationError =
  HTTPValidationError;

/**
 * @summary Set Container Fda Status
 */
export const useSetContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPut
          >
        >,
        TError,
        { shipmentId: string; cargoId: string; data: ContainerFdaStatusUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPut
      >
    >,
    TError,
    { shipmentId: string; cargoId: string; data: ContainerFdaStatusUpdate },
    TContext
  > => {
    const mutationOptions =
      getSetContainerFdaStatusApiV1ShipmentsShipmentIdContainerGatesCargoIdFdaStatusPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The D&D clock panel for a shipment: per-container clocks, batch-enriched
with container / equipment context and each clock's open-dispute count.
 * @summary List Shipment Dnd Clocks
 */
export const listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/dnd-clocks`,
    method: 'GET',
    signal
  });
};

export const getListShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/dnd-clocks`] as const;
  };

export const getListShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
        >
      >
    > = ({ signal }) =>
      listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
      >
    >
  >;
export type ListShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGetQueryError =
  HTTPValidationError;

export function useListShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet<
  TData = Awaited<
    ReturnType<typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet<
  TData = Awaited<
    ReturnType<typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet<
  TData = Awaited<
    ReturnType<typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Shipment Dnd Clocks
 */

export function useListShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet<
  TData = Awaited<
    ReturnType<typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListShipmentDndClocksApiV1ShipmentsShipmentIdDndClocksGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The street turns touching this shipment on either side of the pairing.

The router-level Contract-D gate already proved VIEWER on the path shipment.
Contract C additionally narrows to turns whose *other* shipment the caller can
see too — a turn names two files, and seeing one is not permission to learn the
other. Rows carry both files' reference numbers so the UI can name the
counterparty without a lookup per row.

Bounded — returns ``{"items": [...], "truncated": bool}`` like the tenant-wide
queue.
 * @summary List Shipment Street Turns
 */
export const listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet = (
  shipmentId: string,
  params?: ListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/street-turns`,
    method: 'GET',
    params,
    signal
  });
};

export const getListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetQueryKey =
  (
    shipmentId?: string,
    params?: ListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetParams
  ) => {
    return [
      `/api/v1/shipments/${shipmentId}/street-turns`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    params?: ListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetQueryKey(
        shipmentId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
        >
      >
    > = ({ signal }) =>
      listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet(
        shipmentId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
      >
    >
  >;
export type ListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetQueryError =
  HTTPValidationError;

export function useListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet<
  TData = Awaited<
    ReturnType<
      typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params:
    | undefined
    | ListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet<
  TData = Awaited<
    ReturnType<
      typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet<
  TData = Awaited<
    ReturnType<
      typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Shipment Street Turns
 */

export function useListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet<
  TData = Awaited<
    ReturnType<
      typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  params?: ListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListShipmentStreetTurnsApiV1ShipmentsShipmentIdStreetTurnsGetQueryOptions(
      shipmentId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List exceptions for a shipment.
 * @summary List Exceptions
 */
export const listExceptionsApiV1ShipmentsShipmentIdExceptionsGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/exceptions`,
    method: 'GET',
    signal
  });
};

export const getListExceptionsApiV1ShipmentsShipmentIdExceptionsGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/exceptions`] as const;
};

export const getListExceptionsApiV1ShipmentsShipmentIdExceptionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListExceptionsApiV1ShipmentsShipmentIdExceptionsGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
      >
    > = ({ signal }) =>
      listExceptionsApiV1ShipmentsShipmentIdExceptionsGet(shipmentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListExceptionsApiV1ShipmentsShipmentIdExceptionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
    >
  >;
export type ListExceptionsApiV1ShipmentsShipmentIdExceptionsGetQueryError =
  HTTPValidationError;

export function useListExceptionsApiV1ShipmentsShipmentIdExceptionsGet<
  TData = Awaited<
    ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListExceptionsApiV1ShipmentsShipmentIdExceptionsGet<
  TData = Awaited<
    ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListExceptionsApiV1ShipmentsShipmentIdExceptionsGet<
  TData = Awaited<
    ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Exceptions
 */

export function useListExceptionsApiV1ShipmentsShipmentIdExceptionsGet<
  TData = Awaited<
    ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listExceptionsApiV1ShipmentsShipmentIdExceptionsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListExceptionsApiV1ShipmentsShipmentIdExceptionsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create an exception.
 * @summary Create Exception
 */
export const createExceptionApiV1ShipmentsShipmentIdExceptionsPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/exceptions`,
    method: 'POST',
    signal
  });
};

export const getCreateExceptionApiV1ShipmentsShipmentIdExceptionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createExceptionApiV1ShipmentsShipmentIdExceptionsPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createExceptionApiV1ShipmentsShipmentIdExceptionsPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'createExceptionApiV1ShipmentsShipmentIdExceptionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createExceptionApiV1ShipmentsShipmentIdExceptionsPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return createExceptionApiV1ShipmentsShipmentIdExceptionsPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateExceptionApiV1ShipmentsShipmentIdExceptionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createExceptionApiV1ShipmentsShipmentIdExceptionsPost>
    >
  >;

export type CreateExceptionApiV1ShipmentsShipmentIdExceptionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Exception
 */
export const useCreateExceptionApiV1ShipmentsShipmentIdExceptionsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createExceptionApiV1ShipmentsShipmentIdExceptionsPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createExceptionApiV1ShipmentsShipmentIdExceptionsPost>
  >,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getCreateExceptionApiV1ShipmentsShipmentIdExceptionsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Resolve an exception (update resolved_at, resolution_notes).

Legacy direct-resolve path (shipment detail Tracking tab). Keeps the `status`
discriminator consistent: stamping resolved_at moves the row to the terminal
'resolved' status so it leaves the open triage queue. The work-queue lifecycle
(acknowledge / in-progress / dismiss / inline resolve) goes through the
dedicated /transition endpoint below.
 * @summary Resolve Exception
 */
export const resolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPut =
  (shipmentId: string, exceptionId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/exceptions/${exceptionId}`,
      method: 'PUT'
    });
  };

export const getResolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPut
        >
      >,
      TError,
      { shipmentId: string; exceptionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPut
      >
    >,
    TError,
    { shipmentId: string; exceptionId: string },
    TContext
  > => {
    const mutationKey = [
      'resolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPut
        >
      >,
      { shipmentId: string; exceptionId: string }
    > = (props) => {
      const { shipmentId, exceptionId } = props ?? {};

      return resolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPut(
        shipmentId,
        exceptionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPut
      >
    >
  >;

export type ResolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Resolve Exception
 */
export const useResolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPut
          >
        >,
        TError,
        { shipmentId: string; exceptionId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPut
      >
    >,
    TError,
    { shipmentId: string; exceptionId: string },
    TContext
  > => {
    const mutationOptions =
      getResolveExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Move an exception through its work-queue lifecycle (acknowledge / start /
resolve-with-note / dismiss). The target must be reachable from the current
status via the config transition graph; an illegal move is rejected.
 * @summary Transition Exception
 */
export const transitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPut =
  (
    shipmentId: string,
    exceptionId: string,
    shipmentExceptionTransition: ShipmentExceptionTransition
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/exceptions/${exceptionId}/transition`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: shipmentExceptionTransition
    });
  };

export const getTransitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof transitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPut
        >
      >,
      TError,
      {
        shipmentId: string;
        exceptionId: string;
        data: ShipmentExceptionTransition;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof transitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPut
      >
    >,
    TError,
    {
      shipmentId: string;
      exceptionId: string;
      data: ShipmentExceptionTransition;
    },
    TContext
  > => {
    const mutationKey = [
      'transitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof transitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPut
        >
      >,
      {
        shipmentId: string;
        exceptionId: string;
        data: ShipmentExceptionTransition;
      }
    > = (props) => {
      const { shipmentId, exceptionId, data } = props ?? {};

      return transitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPut(
        shipmentId,
        exceptionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TransitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof transitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPut
      >
    >
  >;
export type TransitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPutMutationBody =
  ShipmentExceptionTransition;
export type TransitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPutMutationError =
  HTTPValidationError;

/**
 * @summary Transition Exception
 */
export const useTransitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof transitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPut
          >
        >,
        TError,
        {
          shipmentId: string;
          exceptionId: string;
          data: ShipmentExceptionTransition;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof transitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPut
      >
    >,
    TError,
    {
      shipmentId: string;
      exceptionId: string;
      data: ShipmentExceptionTransition;
    },
    TContext
  > => {
    const mutationOptions =
      getTransitionExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdTransitionPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Claim / reassign / unassign an exception's ops owner. A new owner is pinged
through the notification substrate.
 * @summary Assign Exception
 */
export const assignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPut =
  (
    shipmentId: string,
    exceptionId: string,
    shipmentExceptionAssign: ShipmentExceptionAssign
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/exceptions/${exceptionId}/assign`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: shipmentExceptionAssign
    });
  };

export const getAssignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof assignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPut
        >
      >,
      TError,
      {
        shipmentId: string;
        exceptionId: string;
        data: ShipmentExceptionAssign;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof assignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPut
      >
    >,
    TError,
    { shipmentId: string; exceptionId: string; data: ShipmentExceptionAssign },
    TContext
  > => {
    const mutationKey = [
      'assignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof assignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPut
        >
      >,
      { shipmentId: string; exceptionId: string; data: ShipmentExceptionAssign }
    > = (props) => {
      const { shipmentId, exceptionId, data } = props ?? {};

      return assignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPut(
        shipmentId,
        exceptionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof assignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPut
      >
    >
  >;
export type AssignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPutMutationBody =
  ShipmentExceptionAssign;
export type AssignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPutMutationError =
  HTTPValidationError;

/**
 * @summary Assign Exception
 */
export const useAssignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof assignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPut
          >
        >,
        TError,
        {
          shipmentId: string;
          exceptionId: string;
          data: ShipmentExceptionAssign;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof assignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPut
      >
    >,
    TError,
    { shipmentId: string; exceptionId: string; data: ShipmentExceptionAssign },
    TContext
  > => {
    const mutationOptions =
      getAssignExceptionApiV1ShipmentsShipmentIdExceptionsExceptionIdAssignPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List bookings for a shipment.
 * @summary List Bookings
 */
export const listBookingsApiV1ShipmentsShipmentIdBookingsGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/bookings`,
    method: 'GET',
    signal
  });
};

export const getListBookingsApiV1ShipmentsShipmentIdBookingsGetQueryKey = (
  shipmentId?: string
) => {
  return [`/api/v1/shipments/${shipmentId}/bookings`] as const;
};

export const getListBookingsApiV1ShipmentsShipmentIdBookingsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListBookingsApiV1ShipmentsShipmentIdBookingsGetQueryKey(shipmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>>
  > = ({ signal }) =>
    listBookingsApiV1ShipmentsShipmentIdBookingsGet(shipmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!shipmentId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListBookingsApiV1ShipmentsShipmentIdBookingsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>>
  >;
export type ListBookingsApiV1ShipmentsShipmentIdBookingsGetQueryError =
  HTTPValidationError;

export function useListBookingsApiV1ShipmentsShipmentIdBookingsGet<
  TData = Awaited<
    ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListBookingsApiV1ShipmentsShipmentIdBookingsGet<
  TData = Awaited<
    ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListBookingsApiV1ShipmentsShipmentIdBookingsGet<
  TData = Awaited<
    ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Bookings
 */

export function useListBookingsApiV1ShipmentsShipmentIdBookingsGet<
  TData = Awaited<
    ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listBookingsApiV1ShipmentsShipmentIdBookingsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListBookingsApiV1ShipmentsShipmentIdBookingsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a booking.

G2: refuses to book a file on a customer credit hold. The hold is re-checked
here (the customer may have crossed their limit since the file was opened);
a newly-over-limit customer puts the file on hold and the booking is blocked
until a manager releases it.

WS5 (E3): also block-on-red — re-screen the file's parties + embargo (a party
may have become denied, or the lists refreshed, since the file was opened) and
refuse the booking while any COMPLIANCE hold is open. A compliance user clears
it via a false-positive disposition (or the route/party changes).
 * @summary Create Booking
 */
export const createBookingApiV1ShipmentsShipmentIdBookingsPost = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/bookings`,
    method: 'POST',
    signal
  });
};

export const getCreateBookingApiV1ShipmentsShipmentIdBookingsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createBookingApiV1ShipmentsShipmentIdBookingsPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createBookingApiV1ShipmentsShipmentIdBookingsPost>
    >,
    TError,
    { shipmentId: string },
    TContext
  > => {
    const mutationKey = ['createBookingApiV1ShipmentsShipmentIdBookingsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createBookingApiV1ShipmentsShipmentIdBookingsPost>
      >,
      { shipmentId: string }
    > = (props) => {
      const { shipmentId } = props ?? {};

      return createBookingApiV1ShipmentsShipmentIdBookingsPost(shipmentId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateBookingApiV1ShipmentsShipmentIdBookingsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createBookingApiV1ShipmentsShipmentIdBookingsPost>
    >
  >;

export type CreateBookingApiV1ShipmentsShipmentIdBookingsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Booking
 */
export const useCreateBookingApiV1ShipmentsShipmentIdBookingsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createBookingApiV1ShipmentsShipmentIdBookingsPost>
      >,
      TError,
      { shipmentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createBookingApiV1ShipmentsShipmentIdBookingsPost>>,
  TError,
  { shipmentId: string },
  TContext
> => {
  const mutationOptions =
    getCreateBookingApiV1ShipmentsShipmentIdBookingsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a booking.
 * @summary Update Booking
 */
export const updateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPut = (
  shipmentId: string,
  bookingId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/bookings/${bookingId}`,
    method: 'PUT'
  });
};

export const getUpdateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPut
        >
      >,
      TError,
      { shipmentId: string; bookingId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPut
      >
    >,
    TError,
    { shipmentId: string; bookingId: string },
    TContext
  > => {
    const mutationKey = [
      'updateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPut
        >
      >,
      { shipmentId: string; bookingId: string }
    > = (props) => {
      const { shipmentId, bookingId } = props ?? {};

      return updateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPut(
        shipmentId,
        bookingId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPut
      >
    >
  >;

export type UpdateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Booking
 */
export const useUpdateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPut
        >
      >,
      TError,
      { shipmentId: string; bookingId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPut>
  >,
  TError,
  { shipmentId: string; bookingId: string },
  TContext
> => {
  const mutationOptions =
    getUpdateBookingApiV1ShipmentsShipmentIdBookingsBookingIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a booking.
 * @summary Delete Booking
 */
export const deleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDelete = (
  shipmentId: string,
  bookingId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/shipments/${shipmentId}/bookings/${bookingId}`,
    method: 'DELETE'
  });
};

export const getDeleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDelete
        >
      >,
      TError,
      { shipmentId: string; bookingId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDelete
      >
    >,
    TError,
    { shipmentId: string; bookingId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDelete
        >
      >,
      { shipmentId: string; bookingId: string }
    > = (props) => {
      const { shipmentId, bookingId } = props ?? {};

      return deleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDelete(
        shipmentId,
        bookingId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDelete
      >
    >
  >;

export type DeleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Booking
 */
export const useDeleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDelete
        >
      >,
      TError,
      { shipmentId: string; bookingId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof deleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDelete
    >
  >,
  TError,
  { shipmentId: string; bookingId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteBookingApiV1ShipmentsShipmentIdBookingsBookingIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Add an equipment line to a booking, optionally naming its container.
 * @summary Add Booking Equipment
 */
export const addBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPost =
  (shipmentId: string, bookingId: string, signal?: AbortSignal) => {
    return customInstance<BookingEquipment>({
      url: `/api/v1/shipments/${shipmentId}/bookings/${bookingId}/equipment`,
      method: 'POST',
      signal
    });
  };

export const getAddBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPost
        >
      >,
      TError,
      { shipmentId: string; bookingId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPost
      >
    >,
    TError,
    { shipmentId: string; bookingId: string },
    TContext
  > => {
    const mutationKey = [
      'addBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPost
        >
      >,
      { shipmentId: string; bookingId: string }
    > = (props) => {
      const { shipmentId, bookingId } = props ?? {};

      return addBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPost(
        shipmentId,
        bookingId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPost
      >
    >
  >;

export type AddBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Booking Equipment
 */
export const useAddBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPost
          >
        >,
        TError,
        { shipmentId: string; bookingId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPost
      >
    >,
    TError,
    { shipmentId: string; bookingId: string },
    TContext
  > => {
    const mutationOptions =
      getAddBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Edit one equipment line — its type, counts, or the container it covers.

The cargo check is keyed on PRESENCE, so an explicit ``cargo_id: null``
clears the container link rather than being skipped.
 * @summary Update Booking Equipment
 */
export const updateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPut =
  (shipmentId: string, bookingId: string, equipmentId: string) => {
    return customInstance<BookingEquipment>({
      url: `/api/v1/shipments/${shipmentId}/bookings/${bookingId}/equipment/${equipmentId}`,
      method: 'PUT'
    });
  };

export const getUpdateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPut
        >
      >,
      TError,
      { shipmentId: string; bookingId: string; equipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPut
      >
    >,
    TError,
    { shipmentId: string; bookingId: string; equipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'updateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPut
        >
      >,
      { shipmentId: string; bookingId: string; equipmentId: string }
    > = (props) => {
      const { shipmentId, bookingId, equipmentId } = props ?? {};

      return updateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPut(
        shipmentId,
        bookingId,
        equipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPut
      >
    >
  >;

export type UpdateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Booking Equipment
 */
export const useUpdateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPut
          >
        >,
        TError,
        { shipmentId: string; bookingId: string; equipmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPut
      >
    >,
    TError,
    { shipmentId: string; bookingId: string; equipmentId: string },
    TContext
  > => {
    const mutationOptions =
      getUpdateBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove an equipment line from a booking.
 * @summary Delete Booking Equipment
 */
export const deleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDelete =
  (shipmentId: string, bookingId: string, equipmentId: string) => {
    return customInstance<BookingEquipmentDeleteResult>({
      url: `/api/v1/shipments/${shipmentId}/bookings/${bookingId}/equipment/${equipmentId}`,
      method: 'DELETE'
    });
  };

export const getDeleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDelete
        >
      >,
      TError,
      { shipmentId: string; bookingId: string; equipmentId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDelete
      >
    >,
    TError,
    { shipmentId: string; bookingId: string; equipmentId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDelete
        >
      >,
      { shipmentId: string; bookingId: string; equipmentId: string }
    > = (props) => {
      const { shipmentId, bookingId, equipmentId } = props ?? {};

      return deleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDelete(
        shipmentId,
        bookingId,
        equipmentId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDelete
      >
    >
  >;

export type DeleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Booking Equipment
 */
export const useDeleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDelete
          >
        >,
        TError,
        { shipmentId: string; bookingId: string; equipmentId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDelete
      >
    >,
    TError,
    { shipmentId: string; bookingId: string; equipmentId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteBookingEquipmentApiV1ShipmentsShipmentIdBookingsBookingIdEquipmentEquipmentIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Add a cut-off clock to a booking.
 * @summary Add Booking Cutoff
 */
export const addBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPost =
  (shipmentId: string, bookingId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/bookings/${bookingId}/cutoffs`,
      method: 'POST',
      signal
    });
  };

export const getAddBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPost
        >
      >,
      TError,
      { shipmentId: string; bookingId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPost
      >
    >,
    TError,
    { shipmentId: string; bookingId: string },
    TContext
  > => {
    const mutationKey = [
      'addBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPost
        >
      >,
      { shipmentId: string; bookingId: string }
    > = (props) => {
      const { shipmentId, bookingId } = props ?? {};

      return addBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPost(
        shipmentId,
        bookingId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPost
      >
    >
  >;

export type AddBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Booking Cutoff
 */
export const useAddBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPost
          >
        >,
        TError,
        { shipmentId: string; bookingId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPost
      >
    >,
    TError,
    { shipmentId: string; bookingId: string },
    TContext
  > => {
    const mutationOptions =
      getAddBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Edit a booking cut-off — revise the deadline/source or advance its
fulfillment state (pending → submitted → confirmed, or waived).
 * @summary Update Booking Cutoff
 */
export const updateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatch =
  (shipmentId: string, bookingId: string, cutoffId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/bookings/${bookingId}/cutoffs/${cutoffId}`,
      method: 'PATCH'
    });
  };

export const getUpdateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatch
        >
      >,
      TError,
      { shipmentId: string; bookingId: string; cutoffId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatch
      >
    >,
    TError,
    { shipmentId: string; bookingId: string; cutoffId: string },
    TContext
  > => {
    const mutationKey = [
      'updateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatch
        >
      >,
      { shipmentId: string; bookingId: string; cutoffId: string }
    > = (props) => {
      const { shipmentId, bookingId, cutoffId } = props ?? {};

      return updateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatch(
        shipmentId,
        bookingId,
        cutoffId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatch
      >
    >
  >;

export type UpdateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatchMutationError =
  HTTPValidationError;

/**
 * @summary Update Booking Cutoff
 */
export const useUpdateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatch
          >
        >,
        TError,
        { shipmentId: string; bookingId: string; cutoffId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatch
      >
    >,
    TError,
    { shipmentId: string; bookingId: string; cutoffId: string },
    TContext
  > => {
    const mutationOptions =
      getUpdateBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a cut-off clock from a booking.
 * @summary Delete Booking Cutoff
 */
export const deleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDelete =
  (shipmentId: string, bookingId: string, cutoffId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/bookings/${bookingId}/cutoffs/${cutoffId}`,
      method: 'DELETE'
    });
  };

export const getDeleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDelete
        >
      >,
      TError,
      { shipmentId: string; bookingId: string; cutoffId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDelete
      >
    >,
    TError,
    { shipmentId: string; bookingId: string; cutoffId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDelete
        >
      >,
      { shipmentId: string; bookingId: string; cutoffId: string }
    > = (props) => {
      const { shipmentId, bookingId, cutoffId } = props ?? {};

      return deleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDelete(
        shipmentId,
        bookingId,
        cutoffId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDelete
      >
    >
  >;

export type DeleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Booking Cutoff
 */
export const useDeleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDelete
          >
        >,
        TError,
        { shipmentId: string; bookingId: string; cutoffId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDelete
      >
    >,
    TError,
    { shipmentId: string; bookingId: string; cutoffId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteBookingCutoffApiV1ShipmentsShipmentIdBookingsBookingIdCutoffsCutoffIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the partner requests on a shipment (newest first).
 * @summary List Partner Requests
 */
export const listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet = (
  shipmentId: string,
  signal?: AbortSignal
) => {
  return customInstance<PartnerRequestList>({
    url: `/api/v1/shipments/${shipmentId}/partner-requests`,
    method: 'GET',
    signal
  });
};

export const getListPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/partner-requests`] as const;
  };

export const getListPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
        >
      >
    > = ({ signal }) =>
      listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
      >
    >
  >;
export type ListPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGetQueryError =
  HTTPValidationError;

export function useListPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Partner Requests
 */

export function useListPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListPartnerRequestsApiV1ShipmentsShipmentIdPartnerRequestsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Open a draft partner request against a shipment.
 * @summary Create Partner Request
 */
export const createPartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPost = (
  shipmentId: string,
  partnerRequestCreate: PartnerRequestCreate,
  signal?: AbortSignal
) => {
  return customInstance<PartnerRequest>({
    url: `/api/v1/shipments/${shipmentId}/partner-requests`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: partnerRequestCreate,
    signal
  });
};

export const getCreatePartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createPartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPost
        >
      >,
      TError,
      { shipmentId: string; data: PartnerRequestCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createPartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPost
      >
    >,
    TError,
    { shipmentId: string; data: PartnerRequestCreate },
    TContext
  > => {
    const mutationKey = [
      'createPartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createPartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPost
        >
      >,
      { shipmentId: string; data: PartnerRequestCreate }
    > = (props) => {
      const { shipmentId, data } = props ?? {};

      return createPartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPost(
        shipmentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreatePartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createPartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPost
      >
    >
  >;
export type CreatePartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPostMutationBody =
  PartnerRequestCreate;
export type CreatePartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Partner Request
 */
export const useCreatePartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createPartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPost
          >
        >,
        TError,
        { shipmentId: string; data: PartnerRequestCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createPartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPost
      >
    >,
    TError,
    { shipmentId: string; data: PartnerRequestCreate },
    TContext
  > => {
    const mutationOptions =
      getCreatePartnerRequestApiV1ShipmentsShipmentIdPartnerRequestsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Fetch one partner request with its quote lines.
 * @summary Get Partner Request
 */
export const getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet = (
  requestId: string,
  signal?: AbortSignal
) => {
  return customInstance<PartnerRequest>({
    url: `/api/v1/shipments/partner-requests/${requestId}`,
    method: 'GET',
    signal
  });
};

export const getGetPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGetQueryKey =
  (requestId?: string) => {
    return [`/api/v1/shipments/partner-requests/${requestId}`] as const;
  };

export const getGetPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    requestId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGetQueryKey(
        requestId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
        >
      >
    > = ({ signal }) =>
      getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet(
        requestId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!requestId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
      >
    >
  >;
export type GetPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGetQueryError =
  HTTPValidationError;

export function useGetPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
    >
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
    >
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
    >
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Partner Request
 */

export function useGetPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<
      typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
    >
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdGetQueryOptions(
      requestId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Edit a draft partner request.
 * @summary Update Partner Request
 */
export const updatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPut = (
  requestId: string,
  partnerRequestUpdate: PartnerRequestUpdate
) => {
  return customInstance<PartnerRequest>({
    url: `/api/v1/shipments/partner-requests/${requestId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: partnerRequestUpdate
  });
};

export const getUpdatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPut
        >
      >,
      TError,
      { requestId: string; data: PartnerRequestUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPut
      >
    >,
    TError,
    { requestId: string; data: PartnerRequestUpdate },
    TContext
  > => {
    const mutationKey = [
      'updatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPut
        >
      >,
      { requestId: string; data: PartnerRequestUpdate }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return updatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPut(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPut
      >
    >
  >;
export type UpdatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPutMutationBody =
  PartnerRequestUpdate;
export type UpdatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Partner Request
 */
export const useUpdatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPut
          >
        >,
        TError,
        { requestId: string; data: PartnerRequestUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPut
      >
    >,
    TError,
    { requestId: string; data: PartnerRequestUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdatePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a draft partner request.
 * @summary Delete Partner Request
 */
export const deletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDelete =
  (requestId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/partner-requests/${requestId}`,
      method: 'DELETE'
    });
  };

export const getDeletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDelete
        >
      >,
      TError,
      { requestId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDelete
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationKey = [
      'deletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDelete
        >
      >,
      { requestId: string }
    > = (props) => {
      const { requestId } = props ?? {};

      return deletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDelete(
        requestId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDelete
      >
    >
  >;

export type DeletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Partner Request
 */
export const useDeletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDelete
          >
        >,
        TError,
        { requestId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDelete
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationOptions =
      getDeletePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Send a draft request to the counterparty (emails it) and mark it sent.
 * @summary Send Partner Request
 */
export const sendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPost =
  (
    requestId: string,
    partnerRequestSend: PartnerRequestSend,
    signal?: AbortSignal
  ) => {
    return customInstance<PartnerRequest>({
      url: `/api/v1/shipments/partner-requests/${requestId}/send`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: partnerRequestSend,
      signal
    });
  };

export const getSendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof sendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPost
        >
      >,
      TError,
      { requestId: string; data: PartnerRequestSend },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof sendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPost
      >
    >,
    TError,
    { requestId: string; data: PartnerRequestSend },
    TContext
  > => {
    const mutationKey = [
      'sendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof sendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPost
        >
      >,
      { requestId: string; data: PartnerRequestSend }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return sendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPost(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof sendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPost
      >
    >
  >;
export type SendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPostMutationBody =
  PartnerRequestSend;
export type SendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPostMutationError =
  HTTPValidationError;

/**
 * @summary Send Partner Request
 */
export const useSendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof sendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPost
          >
        >,
        TError,
        { requestId: string; data: PartnerRequestSend },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof sendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPost
      >
    >,
    TError,
    { requestId: string; data: PartnerRequestSend },
    TContext
  > => {
    const mutationOptions =
      getSendPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdSendPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Capture the partner's manual response (message + priced quote lines).
 * @summary Respond Partner Request
 */
export const respondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPost =
  (
    requestId: string,
    partnerRequestRespond: PartnerRequestRespond,
    signal?: AbortSignal
  ) => {
    return customInstance<PartnerRequest>({
      url: `/api/v1/shipments/partner-requests/${requestId}/respond`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: partnerRequestRespond,
      signal
    });
  };

export const getRespondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof respondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPost
        >
      >,
      TError,
      { requestId: string; data: PartnerRequestRespond },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof respondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPost
      >
    >,
    TError,
    { requestId: string; data: PartnerRequestRespond },
    TContext
  > => {
    const mutationKey = [
      'respondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof respondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPost
        >
      >,
      { requestId: string; data: PartnerRequestRespond }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return respondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPost(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RespondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof respondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPost
      >
    >
  >;
export type RespondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPostMutationBody =
  PartnerRequestRespond;
export type RespondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPostMutationError =
  HTTPValidationError;

/**
 * @summary Respond Partner Request
 */
export const useRespondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof respondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPost
          >
        >,
        TError,
        { requestId: string; data: PartnerRequestRespond },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof respondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPost
      >
    >,
    TError,
    { requestId: string; data: PartnerRequestRespond },
    TContext
  > => {
    const mutationOptions =
      getRespondPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdRespondPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Accept a responded request: copy its quote lines onto the shipment's buy
side and (for a handoff) set the leg's responsible org.
 * @summary Accept Partner Request
 */
export const acceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPost =
  (requestId: string, signal?: AbortSignal) => {
    return customInstance<PartnerRequest>({
      url: `/api/v1/shipments/partner-requests/${requestId}/accept`,
      method: 'POST',
      signal
    });
  };

export const getAcceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof acceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPost
        >
      >,
      TError,
      { requestId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof acceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationKey = [
      'acceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof acceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPost
        >
      >,
      { requestId: string }
    > = (props) => {
      const { requestId } = props ?? {};

      return acceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPost(
        requestId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AcceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof acceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPost
      >
    >
  >;

export type AcceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPostMutationError =
  HTTPValidationError;

/**
 * @summary Accept Partner Request
 */
export const useAcceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof acceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPost
          >
        >,
        TError,
        { requestId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof acceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationOptions =
      getAcceptPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdAcceptPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Decline a responded request (terminal — no charges copied).
 * @summary Decline Partner Request
 */
export const declinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePost =
  (requestId: string, signal?: AbortSignal) => {
    return customInstance<PartnerRequest>({
      url: `/api/v1/shipments/partner-requests/${requestId}/decline`,
      method: 'POST',
      signal
    });
  };

export const getDeclinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof declinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePost
        >
      >,
      TError,
      { requestId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof declinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationKey = [
      'declinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof declinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePost
        >
      >,
      { requestId: string }
    > = (props) => {
      const { requestId } = props ?? {};

      return declinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePost(
        requestId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeclinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof declinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePost
      >
    >
  >;

export type DeclinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePostMutationError =
  HTTPValidationError;

/**
 * @summary Decline Partner Request
 */
export const useDeclinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof declinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePost
          >
        >,
        TError,
        { requestId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof declinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationOptions =
      getDeclinePartnerRequestApiV1ShipmentsPartnerRequestsRequestIdDeclinePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Cancel a draft / sent / responded request (terminal).
 * @summary Cancel Partner Request
 */
export const cancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPost =
  (requestId: string, signal?: AbortSignal) => {
    return customInstance<PartnerRequest>({
      url: `/api/v1/shipments/partner-requests/${requestId}/cancel`,
      method: 'POST',
      signal
    });
  };

export const getCancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPost
        >
      >,
      TError,
      { requestId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationKey = [
      'cancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPost
        >
      >,
      { requestId: string }
    > = (props) => {
      const { requestId } = props ?? {};

      return cancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPost(
        requestId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPost
      >
    >
  >;

export type CancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPostMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Partner Request
 */
export const useCancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof cancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPost
          >
        >,
        TError,
        { requestId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof cancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationOptions =
      getCancelPartnerRequestApiV1ShipmentsPartnerRequestsRequestIdCancelPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the freight quote rounds on a shipment (newest first).
 * @summary List Freight Quote Requests
 */
export const listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<FreightQuoteRequestList>({
      url: `/api/v1/shipments/${shipmentId}/freight-quote-requests`,
      method: 'GET',
      signal
    });
  };

export const getListFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/freight-quote-requests`] as const;
  };

export const getListFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
        >
      >
    > = ({ signal }) =>
      listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
      >
    >
  >;
export type ListFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGetQueryError =
  HTTPValidationError;

export function useListFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Freight Quote Requests
 */

export function useListFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet<
  TData = Awaited<
    ReturnType<
      typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListFreightQuoteRequestsApiV1ShipmentsShipmentIdFreightQuoteRequestsGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Open a draft freight quote round against a shipment.
 * @summary Create Freight Quote Request
 */
export const createFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPost =
  (
    shipmentId: string,
    freightQuoteRequestCreate: FreightQuoteRequestCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<FreightQuoteRequest>({
      url: `/api/v1/shipments/${shipmentId}/freight-quote-requests`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: freightQuoteRequestCreate,
      signal
    });
  };

export const getCreateFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPost
        >
      >,
      TError,
      { shipmentId: string; data: FreightQuoteRequestCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPost
      >
    >,
    TError,
    { shipmentId: string; data: FreightQuoteRequestCreate },
    TContext
  > => {
    const mutationKey = [
      'createFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPost
        >
      >,
      { shipmentId: string; data: FreightQuoteRequestCreate }
    > = (props) => {
      const { shipmentId, data } = props ?? {};

      return createFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPost(
        shipmentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPost
      >
    >
  >;
export type CreateFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPostMutationBody =
  FreightQuoteRequestCreate;
export type CreateFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Freight Quote Request
 */
export const useCreateFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPost
          >
        >,
        TError,
        { shipmentId: string; data: FreightQuoteRequestCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPost
      >
    >,
    TError,
    { shipmentId: string; data: FreightQuoteRequestCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateFreightQuoteRequestApiV1ShipmentsShipmentIdFreightQuoteRequestsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Fetch one freight quote round with its recipient quotes.
 * @summary Get Freight Quote Request
 */
export const getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet =
  (requestId: string, signal?: AbortSignal) => {
    return customInstance<FreightQuoteRequest>({
      url: `/api/v1/shipments/freight-quote-requests/${requestId}`,
      method: 'GET',
      signal
    });
  };

export const getGetFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGetQueryKey =
  (requestId?: string) => {
    return [`/api/v1/shipments/freight-quote-requests/${requestId}`] as const;
  };

export const getGetFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    requestId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGetQueryKey(
        requestId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
        >
      >
    > = ({ signal }) =>
      getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet(
        requestId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!requestId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
      >
    >
  >;
export type GetFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGetQueryError =
  HTTPValidationError;

export function useGetFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
    >
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
    >
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
    >
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Freight Quote Request
 */

export function useGetFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet<
  TData = Awaited<
    ReturnType<
      typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
    >
  >,
  TError = HTTPValidationError
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdGetQueryOptions(
      requestId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Edit a draft freight quote round's header.
 * @summary Update Freight Quote Request
 */
export const updateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPut =
  (requestId: string, freightQuoteRequestUpdate: FreightQuoteRequestUpdate) => {
    return customInstance<FreightQuoteRequest>({
      url: `/api/v1/shipments/freight-quote-requests/${requestId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: freightQuoteRequestUpdate
    });
  };

export const getUpdateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPut
        >
      >,
      TError,
      { requestId: string; data: FreightQuoteRequestUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPut
      >
    >,
    TError,
    { requestId: string; data: FreightQuoteRequestUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPut
        >
      >,
      { requestId: string; data: FreightQuoteRequestUpdate }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return updateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPut(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPut
      >
    >
  >;
export type UpdateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPutMutationBody =
  FreightQuoteRequestUpdate;
export type UpdateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Freight Quote Request
 */
export const useUpdateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPut
          >
        >,
        TError,
        { requestId: string; data: FreightQuoteRequestUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPut
      >
    >,
    TError,
    { requestId: string; data: FreightQuoteRequestUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a draft freight quote round (cascades its recipient quotes).
 * @summary Delete Freight Quote Request
 */
export const deleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDelete =
  (requestId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/freight-quote-requests/${requestId}`,
      method: 'DELETE'
    });
  };

export const getDeleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDelete
        >
      >,
      TError,
      { requestId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDelete
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDelete
        >
      >,
      { requestId: string }
    > = (props) => {
      const { requestId } = props ?? {};

      return deleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDelete(
        requestId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDelete
      >
    >
  >;

export type DeleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Freight Quote Request
 */
export const useDeleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDelete
          >
        >,
        TError,
        { requestId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDelete
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Add a recipient (forwarder or supplier-DDP) to a round.
 * @summary Add Freight Quote Recipient
 */
export const addFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPost =
  (
    requestId: string,
    freightQuoteRecipientInput: FreightQuoteRecipientInput,
    signal?: AbortSignal
  ) => {
    return customInstance<FreightQuoteRequest>({
      url: `/api/v1/shipments/freight-quote-requests/${requestId}/recipients`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: freightQuoteRecipientInput,
      signal
    });
  };

export const getAddFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPost
        >
      >,
      TError,
      { requestId: string; data: FreightQuoteRecipientInput },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPost
      >
    >,
    TError,
    { requestId: string; data: FreightQuoteRecipientInput },
    TContext
  > => {
    const mutationKey = [
      'addFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPost
        >
      >,
      { requestId: string; data: FreightQuoteRecipientInput }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return addFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPost(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPost
      >
    >
  >;
export type AddFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPostMutationBody =
  FreightQuoteRecipientInput;
export type AddFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Freight Quote Recipient
 */
export const useAddFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPost
          >
        >,
        TError,
        { requestId: string; data: FreightQuoteRecipientInput },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPost
      >
    >,
    TError,
    { requestId: string; data: FreightQuoteRecipientInput },
    TContext
  > => {
    const mutationOptions =
      getAddFreightQuoteRecipientApiV1ShipmentsFreightQuoteRequestsRequestIdRecipientsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a recipient/quote that has not been received or won.
 * @summary Remove Freight Quote
 */
export const removeFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDelete = (
  quoteId: string
) => {
  return customInstance<FreightQuoteRequest>({
    url: `/api/v1/shipments/freight-quotes/${quoteId}`,
    method: 'DELETE'
  });
};

export const getRemoveFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDelete
        >
      >,
      TError,
      { quoteId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDelete
      >
    >,
    TError,
    { quoteId: string },
    TContext
  > => {
    const mutationKey = [
      'removeFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDelete
        >
      >,
      { quoteId: string }
    > = (props) => {
      const { quoteId } = props ?? {};

      return removeFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDelete(
        quoteId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDelete
      >
    >
  >;

export type RemoveFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Freight Quote
 */
export const useRemoveFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDelete
        >
      >,
      TError,
      { quoteId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof removeFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDelete
    >
  >,
  TError,
  { quoteId: string },
  TContext
> => {
  const mutationOptions =
    getRemoveFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Send the round to every not-yet-sent recipient (emails the cargo summary).
 * @summary Send Freight Quote Request
 */
export const sendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPost =
  (requestId: string, signal?: AbortSignal) => {
    return customInstance<FreightQuoteRequest>({
      url: `/api/v1/shipments/freight-quote-requests/${requestId}/send`,
      method: 'POST',
      signal
    });
  };

export const getSendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof sendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPost
        >
      >,
      TError,
      { requestId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof sendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationKey = [
      'sendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof sendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPost
        >
      >,
      { requestId: string }
    > = (props) => {
      const { requestId } = props ?? {};

      return sendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPost(
        requestId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof sendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPost
      >
    >
  >;

export type SendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPostMutationError =
  HTTPValidationError;

/**
 * @summary Send Freight Quote Request
 */
export const useSendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof sendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPost
          >
        >,
        TError,
        { requestId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof sendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationOptions =
      getSendFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdSendPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Record a returned quote against a recipient (buy amount, validity, transit, doc).
 * @summary Record Freight Quote
 */
export const recordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPost = (
  quoteId: string,
  freightQuoteRecord: FreightQuoteRecord,
  signal?: AbortSignal
) => {
  return customInstance<FreightQuoteRequest>({
    url: `/api/v1/shipments/freight-quotes/${quoteId}/record`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: freightQuoteRecord,
    signal
  });
};

export const getRecordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof recordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPost
        >
      >,
      TError,
      { quoteId: string; data: FreightQuoteRecord },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof recordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPost
      >
    >,
    TError,
    { quoteId: string; data: FreightQuoteRecord },
    TContext
  > => {
    const mutationKey = [
      'recordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof recordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPost
        >
      >,
      { quoteId: string; data: FreightQuoteRecord }
    > = (props) => {
      const { quoteId, data } = props ?? {};

      return recordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPost(
        quoteId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RecordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof recordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPost
      >
    >
  >;
export type RecordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPostMutationBody =
  FreightQuoteRecord;
export type RecordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPostMutationError =
  HTTPValidationError;

/**
 * @summary Record Freight Quote
 */
export const useRecordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof recordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPost
          >
        >,
        TError,
        { quoteId: string; data: FreightQuoteRecord },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof recordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPost
      >
    >,
    TError,
    { quoteId: string; data: FreightQuoteRecord },
    TContext
  > => {
    const mutationOptions =
      getRecordFreightQuoteApiV1ShipmentsFreightQuotesQuoteIdRecordPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Solicit the client's approval of the comparable sell-side quotes.
 * @summary Request Freight Quote Approval
 */
export const requestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPost =
  (
    requestId: string,
    freightQuoteApprovalRequest: FreightQuoteApprovalRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<FreightQuoteRequest>({
      url: `/api/v1/shipments/freight-quote-requests/${requestId}/request-approval`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: freightQuoteApprovalRequest,
      signal
    });
  };

export const getRequestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof requestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPost
        >
      >,
      TError,
      { requestId: string; data: FreightQuoteApprovalRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof requestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPost
      >
    >,
    TError,
    { requestId: string; data: FreightQuoteApprovalRequest },
    TContext
  > => {
    const mutationKey = [
      'requestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof requestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPost
        >
      >,
      { requestId: string; data: FreightQuoteApprovalRequest }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return requestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPost(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RequestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof requestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPost
      >
    >
  >;
export type RequestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPostMutationBody =
  FreightQuoteApprovalRequest;
export type RequestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPostMutationError =
  HTTPValidationError;

/**
 * @summary Request Freight Quote Approval
 */
export const useRequestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof requestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPost
          >
        >,
        TError,
        { requestId: string; data: FreightQuoteApprovalRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof requestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPost
      >
    >,
    TError,
    { requestId: string; data: FreightQuoteApprovalRequest },
    TContext
  > => {
    const mutationOptions =
      getRequestFreightQuoteApprovalApiV1ShipmentsFreightQuoteRequestsRequestIdRequestApprovalPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Record the client's approval decision internally (operator captures an
offline/phone decision — channel-agnostic).
 * @summary Record Freight Quote Decision
 */
export const recordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPost =
  (
    requestId: string,
    freightQuoteDecision: FreightQuoteDecision,
    signal?: AbortSignal
  ) => {
    return customInstance<FreightQuoteRequest>({
      url: `/api/v1/shipments/freight-quote-requests/${requestId}/decision`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: freightQuoteDecision,
      signal
    });
  };

export const getRecordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof recordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPost
        >
      >,
      TError,
      { requestId: string; data: FreightQuoteDecision },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof recordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPost
      >
    >,
    TError,
    { requestId: string; data: FreightQuoteDecision },
    TContext
  > => {
    const mutationKey = [
      'recordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof recordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPost
        >
      >,
      { requestId: string; data: FreightQuoteDecision }
    > = (props) => {
      const { requestId, data } = props ?? {};

      return recordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPost(
        requestId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RecordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof recordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPost
      >
    >
  >;
export type RecordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPostMutationBody =
  FreightQuoteDecision;
export type RecordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPostMutationError =
  HTTPValidationError;

/**
 * @summary Record Freight Quote Decision
 */
export const useRecordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof recordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPost
          >
        >,
        TError,
        { requestId: string; data: FreightQuoteDecision },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof recordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPost
      >
    >,
    TError,
    { requestId: string; data: FreightQuoteDecision },
    TContext
  > => {
    const mutationOptions =
      getRecordFreightQuoteDecisionApiV1ShipmentsFreightQuoteRequestsRequestIdDecisionPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Award the winner — stamp its buy-side charge onto the shipment and assign
the winning forwarder/supplier as the leg vendor.
 * @summary Award Freight Quote
 */
export const awardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPost =
  (
    requestId: string,
    params?: AwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostParams,
    signal?: AbortSignal
  ) => {
    return customInstance<FreightQuoteRequest>({
      url: `/api/v1/shipments/freight-quote-requests/${requestId}/award`,
      method: 'POST',
      params,
      signal
    });
  };

export const getAwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof awardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPost
        >
      >,
      TError,
      {
        requestId: string;
        params?: AwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof awardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPost
      >
    >,
    TError,
    {
      requestId: string;
      params?: AwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      'awardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof awardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPost
        >
      >,
      {
        requestId: string;
        params?: AwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostParams;
      }
    > = (props) => {
      const { requestId, params } = props ?? {};

      return awardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPost(
        requestId,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof awardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPost
      >
    >
  >;

export type AwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostMutationError =
  HTTPValidationError;

/**
 * @summary Award Freight Quote
 */
export const useAwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof awardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPost
          >
        >,
        TError,
        {
          requestId: string;
          params?: AwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostParams;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof awardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPost
      >
    >,
    TError,
    {
      requestId: string;
      params?: AwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostParams;
    },
    TContext
  > => {
    const mutationOptions =
      getAwardFreightQuoteApiV1ShipmentsFreightQuoteRequestsRequestIdAwardPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Cancel a freight quote round (terminal).
 * @summary Cancel Freight Quote Request
 */
export const cancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPost =
  (requestId: string, signal?: AbortSignal) => {
    return customInstance<FreightQuoteRequest>({
      url: `/api/v1/shipments/freight-quote-requests/${requestId}/cancel`,
      method: 'POST',
      signal
    });
  };

export const getCancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPost
        >
      >,
      TError,
      { requestId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationKey = [
      'cancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPost
        >
      >,
      { requestId: string }
    > = (props) => {
      const { requestId } = props ?? {};

      return cancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPost(
        requestId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPost
      >
    >
  >;

export type CancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPostMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Freight Quote Request
 */
export const useCancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof cancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPost
          >
        >,
        TError,
        { requestId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof cancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPost
      >
    >,
    TError,
    { requestId: string },
    TContext
  > => {
    const mutationOptions =
      getCancelFreightQuoteRequestApiV1ShipmentsFreightQuoteRequestsRequestIdCancelPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Which supplier documents (commercial invoice + packing list) are required
before booking this shipment, and whether they're attached yet (OC&CO C4 item
5). Read-only readiness surface — does not block booking.
 * @summary Get Pre Booking Readiness
 */
export const getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet =
  (shipmentId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/shipments/${shipmentId}/pre-booking-readiness`,
      method: 'GET',
      signal
    });
  };

export const getGetPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGetQueryKey =
  (shipmentId?: string) => {
    return [`/api/v1/shipments/${shipmentId}/pre-booking-readiness`] as const;
  };

export const getGetPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
      >
    >,
    TError = HTTPValidationError
  >(
    shipmentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGetQueryKey(
        shipmentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
        >
      >
    > = ({ signal }) =>
      getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet(
        shipmentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!shipmentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
      >
    >
  >;
export type GetPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGetQueryError =
  HTTPValidationError;

export function useGetPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet<
  TData = Awaited<
    ReturnType<
      typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet<
  TData = Awaited<
    ReturnType<
      typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet<
  TData = Awaited<
    ReturnType<
      typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pre Booking Readiness
 */

export function useGetPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet<
  TData = Awaited<
    ReturnType<
      typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
    >
  >,
  TError = HTTPValidationError
>(
  shipmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPreBookingReadinessApiV1ShipmentsShipmentIdPreBookingReadinessGetQueryOptions(
      shipmentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One document by its own id, with the parent that locates it.

The response carries ``shipment_id`` / ``consol_id`` (exactly one is set — DB
CHECK ``chk_shp_shipment_documents_parent``), which is what the
``/shipments/documents/:documentId`` page redirects on.

Deliberately NOT ``ShipmentDocument.to_dict()``: this is a locator, and echoing
the whole row here would mean every field later added to the document travels
through a route whose only job is to answer "which page shows this?".
 * @summary Get Shipment Document
 */
export const getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet = (
  documentId: string,
  signal?: AbortSignal
) => {
  return customInstance<ShipmentsShipmentDocumentLocation>({
    url: `/api/v1/shipment-documents/${documentId}`,
    method: 'GET',
    signal
  });
};

export const getGetShipmentDocumentApiV1ShipmentDocumentsDocumentIdGetQueryKey =
  (documentId?: string) => {
    return [`/api/v1/shipment-documents/${documentId}`] as const;
  };

export const getGetShipmentDocumentApiV1ShipmentDocumentsDocumentIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet>
    >,
    TError = HTTPValidationError
  >(
    documentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetShipmentDocumentApiV1ShipmentDocumentsDocumentIdGetQueryKey(
        documentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
        >
      >
    > = ({ signal }) =>
      getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet(
        documentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!documentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetShipmentDocumentApiV1ShipmentDocumentsDocumentIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet>
    >
  >;
export type GetShipmentDocumentApiV1ShipmentDocumentsDocumentIdGetQueryError =
  HTTPValidationError;

export function useGetShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet<
  TData = Awaited<
    ReturnType<typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet>
  >,
  TError = HTTPValidationError
>(
  documentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet<
  TData = Awaited<
    ReturnType<typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet>
  >,
  TError = HTTPValidationError
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet<
  TData = Awaited<
    ReturnType<typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet>
  >,
  TError = HTTPValidationError
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Shipment Document
 */

export function useGetShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet<
  TData = Awaited<
    ReturnType<typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet>
  >,
  TError = HTTPValidationError
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShipmentDocumentApiV1ShipmentDocumentsDocumentIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetShipmentDocumentApiV1ShipmentDocumentsDocumentIdGetQueryOptions(
      documentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
